"undefined" != typeof exports && (exports = void 0),
  (function () {
    var t = {
      2: function (t, e, i) {
        (i =
          "undefined" != typeof window
            ? window
            : void 0 !== i.g
              ? i.g
              : "undefined" != typeof self
                ? self
                : {}),
          (t.exports = i);
      },
      1: function (t) {
        t.exports = function (t) {
          "complete" === document.readyState ||
            "interactive" === document.readyState
            ? t.call()
            : document.attachEvent
              ? document.attachEvent("onreadystatechange", function () {
                "interactive" === document.readyState && t.call();
              })
              : document.addEventListener &&
              document.addEventListener("DOMContentLoaded", t);
        };
      },
      8: function (t, e, i) {
        "use strict";
        i.r(e);
        var n = i(1),
          a = ((n = i.n(n)), i(2));
        function o(t, e) {
          return (
            (function (t) {
              if (Array.isArray(t)) return t;
            })(t) ||
            (function (t, e) {
              var i =
                null == t
                  ? null
                  : ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
                  t["@@iterator"];
              if (null != i) {
                var n,
                  a,
                  o = [],
                  s = !0,
                  r = !1;
                try {
                  for (
                    i = i.call(t);
                    !(s = (n = i.next()).done) &&
                    (o.push(n.value), !e || o.length !== e);
                    s = !0
                  );
                } catch (t) {
                  (r = !0), (a = t);
                } finally {
                  try {
                    s || null == i.return || i.return();
                  } finally {
                    if (r) throw a;
                  }
                }
                return o;
              }
            })(t, e) ||
            (function (t, e) {
              if (t) {
                if ("string" == typeof t) return s(t, e);
                var i = Object.prototype.toString.call(t).slice(8, -1);
                return "Map" ===
                  (i =
                    "Object" === i && t.constructor
                      ? t.constructor.name
                      : i) || "Set" === i
                  ? Array.from(t)
                  : "Arguments" === i ||
                    /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
                    ? s(t, e)
                    : void 0;
              }
            })(t, e) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function s(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
          return n;
        }
        function r(t) {
          return (r =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
        }
        function l(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              "value" in n && (n.writable = !0),
              Object.defineProperty(t, n.key, n);
          }
        }
        var d,
          c,
          u = a.window.navigator,
          f =
            -1 < u.userAgent.indexOf("MSIE ") ||
            -1 < u.userAgent.indexOf("Trident/") ||
            -1 < u.userAgent.indexOf("Edge/"),
          p =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              u.userAgent
            ),
          h = (function () {
            for (
              var t = "transform WebkitTransform MozTransform".split(" "),
              e = document.createElement("div"),
              i = 0;
              i < t.length;
              i += 1
            )
              if (e && void 0 !== e.style[t[i]]) return t[i];
            return !1;
          })();
        function m() {
          c = p
            ? (!d &&
              document.body &&
              (((d = document.createElement("div")).style.cssText =
                "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;"),
                document.body.appendChild(d)),
              (d ? d.clientHeight : 0) ||
              a.window.innerHeight ||
              document.documentElement.clientHeight)
            : a.window.innerHeight || document.documentElement.clientHeight;
        }
        m(),
          a.window.addEventListener("resize", m),
          a.window.addEventListener("orientationchange", m),
          a.window.addEventListener("load", m),
          n()(function () {
            m();
          });
        var g = [];
        function v() {
          g.length &&
            (g.forEach(function (t, e) {
              var i,
                n = t.instance,
                o = t.oldData;
              (t = {
                width: (i = n.$item.getBoundingClientRect()).width,
                height: i.height,
                top: i.top,
                bottom: i.bottom,
                wndW: a.window.innerWidth,
                wndH: c,
              }),
                (o =
                  (i =
                    !o ||
                    o.wndW !== t.wndW ||
                    o.wndH !== t.wndH ||
                    o.width !== t.width ||
                    o.height !== t.height) ||
                  !o ||
                  o.top !== t.top ||
                  o.bottom !== t.bottom);
              (g[e].oldData = t), i && n.onResize(), o && n.onScroll();
            }),
              a.window.requestAnimationFrame(v));
        }
        var y = 0,
          b = (function () {
            function t(e, i) {
              !(function (e, i) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this);
              var n = this;
              (n.instanceID = y),
                (y += 1),
                (n.$item = e),
                (n.defaults = {
                  type: "scroll",
                  speed: 0.5,
                  imgSrc: null,
                  imgElement: ".jarallax-img",
                  imgSize: "cover",
                  imgPosition: "50% 50%",
                  imgRepeat: "no-repeat",
                  keepImg: !1,
                  elementInViewport: null,
                  zIndex: -100,
                  disableParallax: !1,
                  disableVideo: !1,
                  videoSrc: null,
                  videoStartTime: 0,
                  videoEndTime: 0,
                  videoVolume: 0,
                  videoLoop: !0,
                  videoPlayOnlyVisible: !0,
                  videoLazyLoading: !0,
                  onScroll: null,
                  onInit: null,
                  onDestroy: null,
                  onCoverImage: null,
                });
              var a,
                s,
                l = n.$item.dataset || {},
                d = {};
              Object.keys(l).forEach(function (t) {
                var e = t.substr(0, 1).toLowerCase() + t.substr(1);
                e && void 0 !== n.defaults[e] && (d[e] = l[t]);
              }),
                (n.options = n.extend({}, n.defaults, d, i)),
                (n.pureOptions = n.extend({}, n.options)),
                Object.keys(n.options).forEach(function (t) {
                  "true" === n.options[t]
                    ? (n.options[t] = !0)
                    : "false" === n.options[t] && (n.options[t] = !1);
                }),
                (n.options.speed = Math.min(
                  2,
                  Math.max(-1, parseFloat(n.options.speed))
                )),
                "string" == typeof n.options.disableParallax &&
                (n.options.disableParallax = new RegExp(
                  n.options.disableParallax
                )),
                n.options.disableParallax instanceof RegExp &&
                ((a = n.options.disableParallax),
                  (n.options.disableParallax = function () {
                    return a.test(u.userAgent);
                  })),
                "function" != typeof n.options.disableParallax &&
                (n.options.disableParallax = function () {
                  return !1;
                }),
                "string" == typeof n.options.disableVideo &&
                (n.options.disableVideo = new RegExp(
                  n.options.disableVideo
                )),
                n.options.disableVideo instanceof RegExp &&
                ((s = n.options.disableVideo),
                  (n.options.disableVideo = function () {
                    return s.test(u.userAgent);
                  })),
                "function" != typeof n.options.disableVideo &&
                (n.options.disableVideo = function () {
                  return !1;
                }),
                (i =
                  (i = n.options.elementInViewport) &&
                    "object" === r(i) &&
                    void 0 !== i.length
                    ? o(i, 1)[0]
                    : i) instanceof Element || (i = null),
                (n.options.elementInViewport = i),
                (n.image = {
                  src: n.options.imgSrc || null,
                  $container: null,
                  useImgTag: !1,
                  position: "fixed",
                }),
                n.initImg() && n.canInitParallax() && n.init();
            }
            var e, i;
            return (
              (e = t),
              (i = [
                {
                  key: "css",
                  value: function (t, e) {
                    return "string" == typeof e
                      ? a.window.getComputedStyle(t).getPropertyValue(e)
                      : (e.transform && h && (e[h] = e.transform),
                        Object.keys(e).forEach(function (i) {
                          t.style[i] = e[i];
                        }),
                        t);
                  },
                },
                {
                  key: "extend",
                  value: function (t) {
                    for (
                      var e = arguments.length,
                      i = new Array(1 < e ? e - 1 : 0),
                      n = 1;
                      n < e;
                      n++
                    )
                      i[n - 1] = arguments[n];
                    return (
                      (t = t || {}),
                      Object.keys(i).forEach(function (e) {
                        i[e] &&
                          Object.keys(i[e]).forEach(function (n) {
                            t[n] = i[e][n];
                          });
                      }),
                      t
                    );
                  },
                },
                {
                  key: "getWindowData",
                  value: function () {
                    return {
                      width:
                        a.window.innerWidth ||
                        document.documentElement.clientWidth,
                      height: c,
                      y: document.documentElement.scrollTop,
                    };
                  },
                },
                {
                  key: "initImg",
                  value: function () {
                    var t = this,
                      e = t.options.imgElement;
                    return (
                      (e =
                        e && "string" == typeof e
                          ? t.$item.querySelector(e)
                          : e) instanceof Element ||
                      (t.options.imgSrc
                        ? ((e = new Image()).src = t.options.imgSrc)
                        : (e = null)),
                      e &&
                      (t.options.keepImg
                        ? (t.image.$item = e.cloneNode(!0))
                        : ((t.image.$item = e),
                          (t.image.$itemParent = e.parentNode)),
                        (t.image.useImgTag = !0)),
                      !(
                        !t.image.$item &&
                        (null === t.image.src &&
                          ((t.image.src =
                            "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
                            (t.image.bgImage = t.css(
                              t.$item,
                              "background-image"
                            ))),
                          !t.image.bgImage || "none" === t.image.bgImage)
                      )
                    );
                  },
                },
                {
                  key: "canInitParallax",
                  value: function () {
                    return h && !this.options.disableParallax();
                  },
                },
                {
                  key: "init",
                  value: function () {
                    var t,
                      e = this,
                      i = {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                      },
                      n = {
                        pointerEvents: "none",
                        transformStyle: "preserve-3d",
                        backfaceVisibility: "hidden",
                        willChange: "transform,opacity",
                      };
                    e.options.keepImg ||
                      ((t = e.$item.getAttribute("style")) &&
                        e.$item.setAttribute(
                          "data-jarallax-original-styles",
                          t
                        ),
                        !e.image.useImgTag ||
                        ((t = e.image.$item.getAttribute("style")) &&
                          e.image.$item.setAttribute(
                            "data-jarallax-original-styles",
                            t
                          ))),
                      "static" === e.css(e.$item, "position") &&
                      e.css(e.$item, {
                        position: "relative",
                      }),
                      "auto" === e.css(e.$item, "z-index") &&
                      e.css(e.$item, {
                        zIndex: 0,
                      }),
                      (e.image.$container = document.createElement("div")),
                      e.css(e.image.$container, i),
                      e.css(e.image.$container, {
                        "z-index": e.options.zIndex,
                      }),
                      f &&
                      e.css(e.image.$container, {
                        opacity: 0.9999,
                      }),
                      e.image.$container.setAttribute(
                        "id",
                        "jarallax-container-".concat(e.instanceID)
                      ),
                      e.$item.appendChild(e.image.$container),
                      e.image.useImgTag
                        ? (n = e.extend(
                          {
                            "object-fit": e.options.imgSize,
                            "object-position": e.options.imgPosition,
                            "font-family": "object-fit: "
                              .concat(
                                e.options.imgSize,
                                "; object-position: "
                              )
                              .concat(e.options.imgPosition, ";"),
                            "max-width": "none",
                          },
                          i,
                          n
                        ))
                        : ((e.image.$item = document.createElement("div")),
                          e.image.src &&
                          (n = e.extend(
                            {
                              "background-position": e.options.imgPosition,
                              "background-size": e.options.imgSize,
                              "background-repeat": e.options.imgRepeat,
                              "background-image":
                                e.image.bgImage ||
                                'url("'.concat(e.image.src, '")'),
                            },
                            i,
                            n
                          ))),
                      ("opacity" !== e.options.type &&
                        "scale" !== e.options.type &&
                        "scale-opacity" !== e.options.type &&
                        1 !== e.options.speed) ||
                      (e.image.position = "absolute"),
                      "fixed" === e.image.position &&
                      ((i = (function (t) {
                        for (var e = []; null !== t.parentElement;)
                          1 === (t = t.parentElement).nodeType && e.push(t);
                        return e;
                      })(e.$item).filter(function (t) {
                        var e = a.window.getComputedStyle(t);
                        return (
                          ((t =
                            e["-webkit-transform"] ||
                            e["-moz-transform"] ||
                            e.transform) &&
                            "none" !== t) ||
                          /(auto|scroll)/.test(
                            e.overflow + e["overflow-y"] + e["overflow-x"]
                          )
                        );
                      })),
                        (e.image.position = i.length ? "absolute" : "fixed")),
                      (n.position = e.image.position),
                      e.css(e.image.$item, n),
                      e.image.$container.appendChild(e.image.$item),
                      e.onResize(),
                      e.onScroll(!0),
                      e.options.onInit && e.options.onInit.call(e),
                      "none" !== e.css(e.$item, "background-image") &&
                      e.css(e.$item, {
                        "background-image": "none",
                      }),
                      e.addToParallaxList();
                  },
                },
                {
                  key: "addToParallaxList",
                  value: function () {
                    g.push({
                      instance: this,
                    }),
                      1 === g.length && a.window.requestAnimationFrame(v);
                  },
                },
                {
                  key: "removeFromParallaxList",
                  value: function () {
                    var t = this;
                    g.forEach(function (e, i) {
                      e.instance.instanceID === t.instanceID &&
                        g.splice(i, 1);
                    });
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    var t = this;
                    t.removeFromParallaxList();
                    var e,
                      i = t.$item.getAttribute(
                        "data-jarallax-original-styles"
                      );
                    t.$item.removeAttribute("data-jarallax-original-styles"),
                      i
                        ? t.$item.setAttribute("style", i)
                        : t.$item.removeAttribute("style"),
                      t.image.useImgTag &&
                      ((e = t.image.$item.getAttribute(
                        "data-jarallax-original-styles"
                      )),
                        t.image.$item.removeAttribute(
                          "data-jarallax-original-styles"
                        ),
                        e
                          ? t.image.$item.setAttribute("style", i)
                          : t.image.$item.removeAttribute("style"),
                        t.image.$itemParent &&
                        t.image.$itemParent.appendChild(t.image.$item)),
                      t.$clipStyles &&
                      t.$clipStyles.parentNode.removeChild(t.$clipStyles),
                      t.image.$container &&
                      t.image.$container.parentNode.removeChild(
                        t.image.$container
                      ),
                      t.options.onDestroy && t.options.onDestroy.call(t),
                      delete t.$item.jarallax;
                  },
                },
                {
                  key: "clipContainer",
                  value: function () {
                    var t, e, i;
                    "fixed" === this.image.position &&
                      ((e = (i = (t =
                        this).image.$container.getBoundingClientRect())
                        .width),
                        (i = i.height),
                        t.$clipStyles ||
                        ((t.$clipStyles = document.createElement("style")),
                          t.$clipStyles.setAttribute("type", "text/css"),
                          t.$clipStyles.setAttribute(
                            "id",
                            "jarallax-clip-".concat(t.instanceID)
                          ),
                          (
                            document.head ||
                            document.getElementsByTagName("head")[0]
                          ).appendChild(t.$clipStyles)),
                        (i = "#jarallax-container-"
                          .concat(t.instanceID, " {\n            clip: rect(0 ")
                          .concat(e, "px ")
                          .concat(i, "px 0);\n            clip: rect(0, ")
                          .concat(e, "px, ")
                          .concat(
                            i,
                            "px, 0);\n            -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n        }"
                          )),
                        t.$clipStyles.styleSheet
                          ? (t.$clipStyles.styleSheet.cssText = i)
                          : (t.$clipStyles.innerHTML = i));
                  },
                },
                {
                  key: "coverImage",
                  value: function () {
                    var t,
                      e = this,
                      i = e.image.$container.getBoundingClientRect(),
                      n = i.height,
                      a = e.options.speed,
                      o =
                        "scroll" === e.options.type ||
                        "scroll-opacity" === e.options.type,
                      s = 0,
                      r = n;
                    return (
                      o &&
                      (a < 0
                        ? ((s = a * Math.max(n, c)),
                          c < n && (s -= a * (n - c)))
                        : (s = a * (n + c)),
                        1 < a
                          ? (r = Math.abs(s - c))
                          : a < 0
                            ? (r = s / a + Math.abs(s))
                            : (r += (c - n) * (1 - a)),
                        (s /= 2)),
                      (e.parallaxScrollDistance = s),
                      (t = o ? (c - r) / 2 : (n - r) / 2),
                      e.css(e.image.$item, {
                        height: "".concat(r, "px"),
                        marginTop: "".concat(t, "px"),
                        left:
                          "fixed" === e.image.position
                            ? "".concat(i.left, "px")
                            : "0",
                        width: "".concat(i.width, "px"),
                      }),
                      e.options.onCoverImage &&
                      e.options.onCoverImage.call(e),
                      {
                        image: {
                          height: r,
                          marginTop: t,
                        },
                        container: i,
                      }
                    );
                  },
                },
                {
                  key: "isVisible",
                  value: function () {
                    return this.isElementInViewport || !1;
                  },
                },
                {
                  key: "onScroll",
                  value: function (t) {
                    var e,
                      i,
                      n,
                      o,
                      s,
                      r,
                      l,
                      d = this,
                      u = d.$item.getBoundingClientRect(),
                      f = u.top,
                      p = u.height,
                      h = {},
                      m = u;
                    d.options.elementInViewport &&
                      (m =
                        d.options.elementInViewport.getBoundingClientRect()),
                      (d.isElementInViewport =
                        0 <= m.bottom &&
                        0 <= m.right &&
                        m.top <= c &&
                        m.left <= a.window.innerWidth),
                      (t || d.isElementInViewport) &&
                      ((e = Math.max(0, f)),
                        (i = Math.max(0, p + f)),
                        (n = Math.max(0, -f)),
                        (o = Math.max(0, f + p - c)),
                        (s = Math.max(0, p - (f + p - c))),
                        (r = Math.max(0, -f + c - p)),
                        (m = 1 - ((c - f) / (c + p)) * 2),
                        (t = 1),
                        p < c
                          ? (t = 1 - (n || o) / p)
                          : i <= c
                            ? (t = i / c)
                            : s <= c && (t = s / c),
                        ("opacity" !== d.options.type &&
                          "scale-opacity" !== d.options.type &&
                          "scroll-opacity" !== d.options.type) ||
                        ((h.transform = "translate3d(0,0,0)"),
                          (h.opacity = t)),
                        ("scale" !== d.options.type &&
                          "scale-opacity" !== d.options.type) ||
                        ((l = 1),
                          d.options.speed < 0
                            ? (l -= d.options.speed * t)
                            : (l += d.options.speed * (1 - t)),
                          (h.transform = "scale(".concat(
                            l,
                            ") translate3d(0,0,0)"
                          ))),
                        ("scroll" !== d.options.type &&
                          "scroll-opacity" !== d.options.type) ||
                        ((l = d.parallaxScrollDistance * m),
                          "absolute" === d.image.position && (l -= f),
                          (h.transform = "translate3d(0,".concat(
                            l,
                            "px,0)"
                          ))),
                        d.css(d.image.$item, h),
                        d.options.onScroll &&
                        d.options.onScroll.call(d, {
                          section: u,
                          beforeTop: e,
                          beforeTopEnd: i,
                          afterTop: n,
                          beforeBottom: o,
                          beforeBottomEnd: s,
                          afterBottom: r,
                          visiblePercent: t,
                          fromViewportCenter: m,
                        }));
                  },
                },
                {
                  key: "onResize",
                  value: function () {
                    this.coverImage(), this.clipContainer();
                  },
                },
              ]) && l(e.prototype, i),
              t
            );
          })();
        ((n = function (t, e) {
          for (
            var i,
            n = (t = (
              "object" ===
                ("undefined" == typeof HTMLElement
                  ? "undefined"
                  : r(HTMLElement))
                ? t instanceof HTMLElement
                : t &&
                "object" === r(t) &&
                null !== t &&
                1 === t.nodeType &&
                "string" == typeof t.nodeName
            )
              ? [t]
              : t).length,
            a = 0,
            o = arguments.length,
            s = new Array(2 < o ? o - 2 : 0),
            l = 2;
            l < o;
            l++
          )
            s[l - 2] = arguments[l];
          for (; a < n; a += 1)
            if (
              ("object" === r(e) || void 0 === e
                ? t[a].jarallax || (t[a].jarallax = new b(t[a], e))
                : t[a].jarallax &&
                (i = t[a].jarallax[e].apply(t[a].jarallax, s)),
                void 0 !== i)
            )
              return i;
          return t;
        }).constructor = b),
          (e.default = n);
      },
    },
      e = {};
    function i(n) {
      var a = e[n];
      return void 0 !== a
        ? a.exports
        : ((a = e[n] =
        {
          exports: {},
        }),
          t[n](a, a.exports, i),
          a.exports);
    }
    (i.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
            return t.default;
          }
          : function () {
            return t;
          };
      return (
        i.d(e, {
          a: e,
        }),
        e
      );
    }),
      (i.d = function (t, e) {
        for (var n in e)
          i.o(e, n) &&
            !i.o(t, n) &&
            Object.defineProperty(t, n, {
              enumerable: !0,
              get: e[n],
            });
      }),
      (i.g = (function () {
        if ("object" == typeof globalThis) return globalThis;
        try {
          return this || new Function("return this")();
        } catch (t) {
          if ("object" == typeof window) return window;
        }
      })()),
      (i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (i.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module",
          }),
          Object.defineProperty(t, "__esModule", {
            value: !0,
          });
      });
    var n = {};
    !(function () {
      "use strict";
      i.r(n);
      var t = i(1),
        e = i.n(t),
        a = i(2),
        o = i(8);
      function s(t) {
        return (s =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
      }
      var r,
        l = a.window.jarallax;
      (a.window.jarallax = o.default),
        (a.window.jarallax.noConflict = function () {
          return (a.window.jarallax = l), this;
        }),
        void 0 !== a.jQuery_T4NT &&
        (((t = function () {
          for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
            e[i] = arguments[i];
          Array.prototype.unshift.call(e, this);
          var n = o.default.apply(a.window, e);
          return "object" !== s(n) ? n : this;
        }).constructor = o.default.constructor),
          (r = a.jQuery_T4NT.fn.jarallax),
          (a.jQuery_T4NT.fn.jarallax = t),
          (a.jQuery_T4NT.fn.jarallax.noConflict = function () {
            return (a.jQuery_T4NT.fn.jarallax = r), this;
          })),
        e()(function () {
          (0, o.default)(document.querySelectorAll("[data-jarallax]"));
        });
    })();
  })();
var t4sJarallax = jarallax.noConflict();
(jQuery_T4NT.fn.t4sJarallax = jQuery_T4NT.fn.jarallax.noConflict()),
  (function (t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jQuery_T4NT"], t)
      : t(jQuery_T4NT);
  })(function (t) {
    "use strict";
    function e(t) {
      var e = t.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
      return new RegExp(e);
    }
    function i(t) {
      return function (i) {
        var a = i.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
        if (a)
          for (var o = 0, s = a.length; o < s; ++o) {
            var l = a[o].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
              d = e(l[0]),
              c = l[1] || "",
              u = l[3] || "",
              f = null;
            (l = l[2]),
              r.hasOwnProperty(l) && ((f = r[l]), (f = Number(t[f]))),
              null !== f &&
              ("!" === c && (f = n(u, f)),
                "" === c && f < 10 && (f = "0" + f.toString()),
                (i = i.replace(d, f.toString())));
          }
        return i.replace(/%%/, "%");
      };
    }
    function n(t, e) {
      var i = "s",
        n = "";
      return (
        t &&
        (1 === (t = t.replace(/(:|;|\s)/gi, "").split(/\,/)).length
          ? (i = t[0])
          : ((n = t[0]), (i = t[1]))),
        Math.abs(e) > 1 ? i : n
      );
    }
    var a = [],
      o = [],
      s = {
        precision: 100,
        elapse: !1,
        defer: !1,
      };
    o.push(/^[0-9]*$/.source),
      o.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
      o.push(
        /[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source
      ),
      (o = new RegExp(o.join("|")));
    var r = {
      Y: "years",
      m: "months",
      n: "daysToMonth",
      d: "daysToWeek",
      w: "weeks",
      W: "weeksToMonth",
      H: "hours",
      M: "minutes",
      S: "seconds",
      D: "totalDays",
      I: "totalHours",
      N: "totalMinutes",
      T: "totalSeconds",
    },
      l = function (e, i, n) {
        (this.el = e),
          (this.$el = t(e)),
          (this.interval = null),
          (this.offset = {}),
          (this.options = t.extend({}, s)),
          (this.instanceNumber = a.length),
          a.push(this),
          this.$el.data("countdown-instance", this.instanceNumber),
          n &&
          ("function" == typeof n
            ? (this.$el.on("update.countdown", n),
              this.$el.on("stoped.countdown", n),
              this.$el.on("finish.countdown", n))
            : (this.options = t.extend({}, s, n))),
          this.setFinalDate(i),
          !1 === this.options.defer && this.start();
      };
    t.extend(l.prototype, {
      start: function () {
        null !== this.interval && clearInterval(this.interval);
        var t = this;
        this.update(),
          (this.interval = setInterval(function () {
            t.update.call(t);
          }, this.options.precision));
      },
      stop: function () {
        clearInterval(this.interval),
          (this.interval = null),
          this.dispatchEvent("stoped");
      },
      toggle: function () {
        this.interval ? this.stop() : this.start();
      },
      pause: function () {
        this.stop();
      },
      resume: function () {
        this.start();
      },
      remove: function () {
        this.stop.call(this),
          (a[this.instanceNumber] = null),
          delete this.$el.data().countdownInstance;
      },
      setFinalDate: function (t) {
        this.finalDate = (function (t) {
          if (t instanceof Date) return t;
          if (String(t).match(o))
            return (
              String(t).match(/^[0-9]*$/) && (t = Number(t)),
              String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")),
              new Date(t)
            );
          throw new Error("Couldn't cast `" + t + "` to a date object.");
        })(t);
      },
      update: function () {
        if (0 !== this.$el.closest("html").length) {
          var e,
            i = void 0 !== t._data(this.el, "events"),
            n = new Date();
          (e = this.finalDate.getTime() - n.getTime()),
            (e = Math.ceil(e / 1e3)),
            (e = !this.options.elapse && e < 0 ? 0 : Math.abs(e)),
            this.totalSecsLeft !== e &&
            i &&
            ((this.totalSecsLeft = e),
              (this.elapsed = n >= this.finalDate),
              (this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(
                  (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
                ),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                weeksToMonth:
                  Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - n.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                totalSeconds: this.totalSecsLeft,
              }),
              this.options.elapse || 0 !== this.totalSecsLeft
                ? this.dispatchEvent("update")
                : (this.stop(), this.dispatchEvent("finish")));
        } else this.remove();
      },
      dispatchEvent: function (e) {
        var n = t.Event(e + ".countdown");
        (n.finalDate = this.finalDate),
          (n.elapsed = this.elapsed),
          (n.offset = t.extend({}, this.offset)),
          (n.strftime = i(this.offset)),
          this.$el.trigger(n);
      },
    }),
      (t.fn.countdown = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return this.each(function () {
          var i = t(this).data("countdown-instance");
          if (void 0 !== i) {
            var n = a[i],
              o = e[0];
            l.prototype.hasOwnProperty(o)
              ? n[o].apply(n, e.slice(1))
              : null === String(o).match(/^[$A-Z_][0-9A-Z_$]*$/i)
                ? (n.setFinalDate.call(n, o), n.start())
                : t.error(
                  "Method %s does not exist on jQuery_T4NT.countdown".replace(
                    /\%s/gi,
                    o
                  )
                );
          } else new l(this, e[0], e[1]);
        });
      });
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs =
          e());
  })(this, function () {
    "use strict";
    var t = "millisecond",
      e = "second",
      i = "minute",
      n = "hour",
      a = "day",
      o = "week",
      s = "month",
      r = "quarter",
      l = "year",
      d = "date",
      c = "Invalid Date",
      u =
        /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
      f =
        /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      p = {
        name: "en",
        weekdays:
          "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months:
          "January_February_March_April_May_June_July_August_September_October_November_December".split(
            "_"
          ),
      },
      h = function (t, e, i) {
        var n = String(t);
        return !n || n.length >= e
          ? t
          : "" + Array(e + 1 - n.length).join(i) + t;
      },
      m = {
        s: h,
        z: function (t) {
          var e = -t.utcOffset(),
            i = Math.abs(e),
            n = Math.floor(i / 60),
            a = i % 60;
          return (e <= 0 ? "+" : "-") + h(n, 2, "0") + ":" + h(a, 2, "0");
        },
        m: function t(e, i) {
          if (e.date() < i.date()) return -t(i, e);
          var n = 12 * (i.year() - e.year()) + (i.month() - e.month()),
            a = e.clone().add(n, s),
            o = i - a < 0,
            r = e.clone().add(n + (o ? -1 : 1), s);
          return +(-(n + (i - a) / (o ? a - r : r - a)) || 0);
        },
        a: function (t) {
          return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function (c) {
          return (
            {
              M: s,
              y: l,
              w: o,
              d: a,
              D: d,
              h: n,
              m: i,
              s: e,
              ms: t,
              Q: r,
            }[c] ||
            String(c || "")
              .toLowerCase()
              .replace(/s$/, "")
          );
        },
        u: function (t) {
          return void 0 === t;
        },
      },
      g = "en",
      v = {};
    v[g] = p;
    var y = function (t) {
      return t instanceof T;
    },
      b = function (t, e, i) {
        var n;
        if (!t) return g;
        if ("string" == typeof t) v[t] && (n = t), e && ((v[t] = e), (n = t));
        else {
          var a = t.name;
          (v[a] = t), (n = a);
        }
        return !i && n && (g = n), n || (!i && g);
      },
      S = function (t, e) {
        if (y(t)) return t.clone();
        var i = "object" == typeof e ? e : {};
        return (i.date = t), (i.args = arguments), new T(i);
      },
      w = m;
    (w.l = b),
      (w.i = y),
      (w.w = function (t, e) {
        return S(t, {
          locale: e.$L,
          utc: e.$u,
          x: e.$x,
          $offset: e.$offset,
        });
      });
    var T = (function () {
      function p(t) {
        (this.$L = b(t.locale, null, !0)), this.parse(t);
      }
      var h = p.prototype;
      return (
        (h.parse = function (t) {
          (this.$d = (function (t) {
            var e = t.date,
              i = t.utc;
            if (null === e) return new Date(NaN);
            if (w.u(e)) return new Date();
            if (e instanceof Date) return new Date(e);
            if ("string" == typeof e && !/Z$/i.test(e)) {
              var n = e.match(u);
              if (n) {
                var a = n[2] - 1 || 0,
                  o = (n[7] || "0").substring(0, 3);
                return i
                  ? new Date(
                    Date.UTC(
                      n[1],
                      a,
                      n[3] || 1,
                      n[4] || 0,
                      n[5] || 0,
                      n[6] || 0,
                      o
                    )
                  )
                  : new Date(
                    n[1],
                    a,
                    n[3] || 1,
                    n[4] || 0,
                    n[5] || 0,
                    n[6] || 0,
                    o
                  );
              }
            }
            return new Date(e);
          })(t)),
            (this.$x = t.x || {}),
            this.init();
        }),
        (h.init = function () {
          var t = this.$d;
          (this.$y = t.getFullYear()),
            (this.$M = t.getMonth()),
            (this.$D = t.getDate()),
            (this.$W = t.getDay()),
            (this.$H = t.getHours()),
            (this.$m = t.getMinutes()),
            (this.$s = t.getSeconds()),
            (this.$ms = t.getMilliseconds());
        }),
        (h.$utils = function () {
          return w;
        }),
        (h.isValid = function () {
          return !(this.$d.toString() === c);
        }),
        (h.isSame = function (t, e) {
          var i = S(t);
          return this.startOf(e) <= i && i <= this.endOf(e);
        }),
        (h.isAfter = function (t, e) {
          return S(t) < this.startOf(e);
        }),
        (h.isBefore = function (t, e) {
          return this.endOf(e) < S(t);
        }),
        (h.$g = function (t, e, i) {
          return w.u(t) ? this[e] : this.set(i, t);
        }),
        (h.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }),
        (h.valueOf = function () {
          return this.$d.getTime();
        }),
        (h.startOf = function (t, r) {
          var c = this,
            u = !!w.u(r) || r,
            f = w.p(t),
            p = function (t, e) {
              var i = w.w(
                c.$u ? Date.UTC(c.$y, e, t) : new Date(c.$y, e, t),
                c
              );
              return u ? i : i.endOf(a);
            },
            h = function (t, e) {
              return w.w(
                c
                  .toDate()
                [t].apply(
                  c.toDate("s"),
                  (u ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)
                ),
                c
              );
            },
            m = this.$W,
            g = this.$M,
            v = this.$D,
            y = "set" + (this.$u ? "UTC" : "");
          switch (f) {
            case l:
              return u ? p(1, 0) : p(31, 11);
            case s:
              return u ? p(1, g) : p(0, g + 1);
            case o:
              var b = this.$locale().weekStart || 0,
                S = (m < b ? m + 7 : m) - b;
              return p(u ? v - S : v + (6 - S), g);
            case a:
            case d:
              return h(y + "Hours", 0);
            case n:
              return h(y + "Minutes", 1);
            case i:
              return h(y + "Seconds", 2);
            case e:
              return h(y + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }),
        (h.endOf = function (t) {
          return this.startOf(t, !1);
        }),
        (h.$set = function (o, r) {
          var c,
            u = w.p(o),
            f = "set" + (this.$u ? "UTC" : ""),
            p = ((c = {}),
              (c[a] = f + "Date"),
              (c[d] = f + "Date"),
              (c[s] = f + "Month"),
              (c[l] = f + "FullYear"),
              (c[n] = f + "Hours"),
              (c[i] = f + "Minutes"),
              (c[e] = f + "Seconds"),
              (c[t] = f + "Milliseconds"),
              c)[u],
            h = u === a ? this.$D + (r - this.$W) : r;
          if (u === s || u === l) {
            var m = this.clone().set(d, 1);
            m.$d[p](h),
              m.init(),
              (this.$d = m.set(d, Math.min(this.$D, m.daysInMonth())).$d);
          } else p && this.$d[p](h);
          return this.init(), this;
        }),
        (h.set = function (t, e) {
          return this.clone().$set(t, e);
        }),
        (h.get = function (t) {
          return this[w.p(t)]();
        }),
        (h.add = function (t, r) {
          var d,
            c = this;
          t = Number(t);
          var u = w.p(r),
            f = function (e) {
              var i = S(c);
              return w.w(i.date(i.date() + Math.round(e * t)), c);
            };
          if (u === s) return this.set(s, this.$M + t);
          if (u === l) return this.set(l, this.$y + t);
          if (u === a) return f(1);
          if (u === o) return f(7);
          var p =
            ((d = {}), (d[i] = 6e4), (d[n] = 36e5), (d[e] = 1e3), d)[u] ||
            1,
            h = this.$d.getTime() + t * p;
          return w.w(h, this);
        }),
        (h.subtract = function (t, e) {
          return this.add(-1 * t, e);
        }),
        (h.format = function (t) {
          var e = this,
            i = this.$locale();
          if (!this.isValid()) return i.invalidDate || c;
          var n = t || "YYYY-MM-DDTHH:mm:ssZ",
            a = w.z(this),
            o = this.$H,
            s = this.$m,
            r = this.$M,
            l = i.weekdays,
            d = i.months,
            u = function (t, i, a, o) {
              return (t && (t[i] || t(e, n))) || a[i].substr(0, o);
            },
            p = function (t) {
              return w.s(o % 12 || 12, t, "0");
            },
            h =
              i.meridiem ||
              function (t, e, i) {
                var n = t < 12 ? "AM" : "PM";
                return i ? n.toLowerCase() : n;
              },
            m = {
              YY: String(this.$y).slice(-2),
              YYYY: this.$y,
              M: r + 1,
              MM: w.s(r + 1, 2, "0"),
              MMM: u(i.monthsShort, r, d, 3),
              MMMM: u(d, r),
              D: this.$D,
              DD: w.s(this.$D, 2, "0"),
              d: String(this.$W),
              dd: u(i.weekdaysMin, this.$W, l, 2),
              ddd: u(i.weekdaysShort, this.$W, l, 3),
              dddd: l[this.$W],
              H: String(o),
              HH: w.s(o, 2, "0"),
              h: p(1),
              hh: p(2),
              a: h(o, s, !0),
              A: h(o, s, !1),
              m: String(s),
              mm: w.s(s, 2, "0"),
              s: String(this.$s),
              ss: w.s(this.$s, 2, "0"),
              SSS: w.s(this.$ms, 3, "0"),
              Z: a,
            };
          return n.replace(f, function (t, e) {
            return e || m[t] || a.replace(":", "");
          });
        }),
        (h.utcOffset = function () {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }),
        (h.diff = function (t, d, c) {
          var u,
            f = w.p(d),
            p = S(t),
            h = 6e4 * (p.utcOffset() - this.utcOffset()),
            m = this - p,
            g = w.m(this, p);
          return (
            (g =
              ((u = {}),
                (u[l] = g / 12),
                (u[s] = g),
                (u[r] = g / 3),
                (u[o] = (m - h) / 6048e5),
                (u[a] = (m - h) / 864e5),
                (u[n] = m / 36e5),
                (u[i] = m / 6e4),
                (u[e] = m / 1e3),
                u)[f] || m),
            c ? g : w.a(g)
          );
        }),
        (h.daysInMonth = function () {
          return this.endOf(s).$D;
        }),
        (h.$locale = function () {
          return v[this.$L];
        }),
        (h.locale = function (t, e) {
          if (!t) return this.$L;
          var i = this.clone(),
            n = b(t, e, !0);
          return n && (i.$L = n), i;
        }),
        (h.clone = function () {
          return w.w(this.$d, this);
        }),
        (h.toDate = function () {
          return new Date(this.valueOf());
        }),
        (h.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }),
        (h.toISOString = function () {
          return this.$d.toISOString();
        }),
        (h.toString = function () {
          return this.$d.toUTCString();
        }),
        p
      );
    })(),
      _ = T.prototype;
    return (
      (S.prototype = _),
      [
        ["$ms", t],
        ["$s", e],
        ["$m", i],
        ["$H", n],
        ["$W", a],
        ["$M", s],
        ["$y", l],
        ["$D", d],
      ].forEach(function (t) {
        _[t[1]] = function (e) {
          return this.$g(e, t[0], t[1]);
        };
      }),
      (S.extend = function (t, e) {
        return t.$i || (t(e, T, S), (t.$i = !0)), S;
      }),
      (S.locale = b),
      (S.isDayjs = y),
      (S.unix = function (t) {
        return S(1e3 * t);
      }),
      (S.en = v[g]),
      (S.Ls = v),
      (S.p = {}),
      S
    );
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t =
          "undefined" != typeof globalThis
            ? globalThis
            : t || self).dayjs_plugin_utc = e());
  })(this, function () {
    "use strict";
    var t = "minute",
      e = /[+-]\d\d(?::?\d\d)?/g,
      i = /([+-]|\d\d)/g;
    return function (n, a, o) {
      var s = a.prototype;
      (o.utc = function (t) {
        return new a({
          date: t,
          utc: !0,
          args: arguments,
        });
      }),
        (s.utc = function (e) {
          var i = o(this.toDate(), {
            locale: this.$L,
            utc: !0,
          });
          return e ? i.add(this.utcOffset(), t) : i;
        }),
        (s.local = function () {
          return o(this.toDate(), {
            locale: this.$L,
            utc: !1,
          });
        });
      var r = s.parse;
      s.parse = function (t) {
        t.utc && (this.$u = !0),
          this.$utils().u(t.$offset) || (this.$offset = t.$offset),
          r.call(this, t);
      };
      var l = s.init;
      s.init = function () {
        if (this.$u) {
          var t = this.$d;
          (this.$y = t.getUTCFullYear()),
            (this.$M = t.getUTCMonth()),
            (this.$D = t.getUTCDate()),
            (this.$W = t.getUTCDay()),
            (this.$H = t.getUTCHours()),
            (this.$m = t.getUTCMinutes()),
            (this.$s = t.getUTCSeconds()),
            (this.$ms = t.getUTCMilliseconds());
        } else l.call(this);
      };
      var d = s.utcOffset;
      s.utcOffset = function (n, a) {
        var o = this.$utils().u;
        if (o(n))
          return this.$u ? 0 : o(this.$offset) ? d.call(this) : this.$offset;
        if (
          "string" == typeof n &&
          null ===
          (n = (function (t) {
            void 0 === t && (t = "");
            var n = t.match(e);
            if (!n) return null;
            var a = ("" + n[0]).match(i) || ["-", 0, 0],
              o = a[0],
              s = 60 * +a[1] + +a[2];
            return 0 === s ? 0 : "+" === o ? s : -s;
          })(n))
        )
          return this;
        var s = Math.abs(n) <= 16 ? 60 * n : n,
          r = this;
        if (a) return (r.$offset = s), (r.$u = 0 === n), r;
        if (0 !== n) {
          var l = this.$u
            ? this.toDate().getTimezoneOffset()
            : -1 * this.utcOffset();
          ((r = this.local().add(s + l, t)).$offset = s),
            (r.$x.$localOffset = l);
        } else r = this.utc();
        return r;
      };
      var c = s.format;
      (s.format = function (t) {
        var e = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return c.call(this, e);
      }),
        (s.valueOf = function () {
          var t = this.$utils().u(this.$offset)
            ? 0
            : this.$offset +
            (this.$x.$localOffset || new Date().getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t;
        }),
        (s.isUTC = function () {
          return !!this.$u;
        }),
        (s.toISOString = function () {
          return this.toDate().toISOString();
        }),
        (s.toString = function () {
          return this.toDate().toUTCString();
        });
      var u = s.toDate;
      s.toDate = function (t) {
        return "s" === t && this.$offset
          ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate()
          : u.call(this);
      };
      var f = s.diff;
      s.diff = function (t, e, i) {
        if (t && this.$u === t.$u) return f.call(this, t, e, i);
        var n = this.local(),
          a = o(t).local();
        return f.call(n, a, e, i);
      };
    };
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t =
          "undefined" != typeof globalThis
            ? globalThis
            : t || self).dayjs_plugin_timezone = e());
  })(this, function () {
    "use strict";
    var t = {
      year: 0,
      month: 1,
      day: 2,
      hour: 3,
      minute: 4,
      second: 5,
    },
      e = {};
    return function (i, n, a) {
      var o,
        s = function (t, i, n) {
          void 0 === n && (n = {});
          var a = new Date(t);
          return (function (t, i) {
            void 0 === i && (i = {});
            var n = i.timeZoneName || "short",
              a = t + "|" + n,
              o = e[a];
            return (
              o ||
              ((o = new Intl.DateTimeFormat("en-US", {
                hour12: !1,
                timeZone: t,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZoneName: n,
              })),
                (e[a] = o)),
              o
            );
          })(i, n).formatToParts(a);
        },
        r = function (e, i) {
          for (var n = s(e, i), o = [], r = 0; r < n.length; r += 1) {
            var l = n[r],
              d = l.type,
              c = l.value,
              u = t[d];
            u >= 0 && (o[u] = parseInt(c, 10));
          }
          var f = o[3],
            p = 24 === f ? 0 : f,
            h =
              o[0] +
              "-" +
              o[1] +
              "-" +
              o[2] +
              " " +
              p +
              ":" +
              o[4] +
              ":" +
              o[5] +
              ":000",
            m = +e;
          return (a.utc(h).valueOf() - (m -= m % 1e3)) / 6e4;
        },
        l = n.prototype;
      (l.tz = function (t, e) {
        void 0 === t && (t = o);
        var i = this.utcOffset(),
          n = this.toDate(),
          s = n.toLocaleString("en-US", {
            timeZone: t,
          }),
          r = Math.round((n - new Date(s)) / 1e3 / 60),
          l = a(s)
            .$set("millisecond", this.$ms)
            .utcOffset(15 * -Math.round(n.getTimezoneOffset() / 15) - r, !0);
        if (e) {
          var d = l.utcOffset();
          l = l.add(i - d, "minute");
        }
        return (l.$x.$timezone = t), l;
      }),
        (l.offsetName = function (t) {
          var e = this.$x.$timezone || a.tz.guess(),
            i = s(this.valueOf(), e, {
              timeZoneName: t,
            }).find(function (t) {
              return "timezonename" === t.type.toLowerCase();
            });
          return i && i.value;
        });
      var d = l.startOf;
      (l.startOf = function (t, e) {
        if (!this.$x || !this.$x.$timezone) return d.call(this, t, e);
        var i = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
        return d.call(i, t, e).tz(this.$x.$timezone, !0);
      }),
        (a.tz = function (t, e, i) {
          var n = i && e,
            s = i || e || o,
            l = r(+a(), s);
          if ("string" != typeof t) return a(t).tz(s);
          var d = (function (t, e, i) {
            var n = t - 60 * e * 1e3,
              a = r(n, i);
            if (e === a) return [n, e];
            var o = r((n -= 60 * (a - e) * 1e3), i);
            return a === o
              ? [n, a]
              : [t - 60 * Math.min(a, o) * 1e3, Math.max(a, o)];
          })(a.utc(t, n).valueOf(), l, s),
            c = d[0],
            u = d[1],
            f = a(c).utcOffset(u);
          return (f.$x.$timezone = s), f;
        }),
        (a.tz.guess = function () {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }),
        (a.tz.setDefault = function (t) {
          o = t;
        });
    };
  });
var dayjs_utc = window.dayjs_plugin_utc,
  dayjs_timezone = window.dayjs_plugin_timezone;
function createCommonjsModule(t, e, i) {
  return (
    t(
      (i = {
        path: e,
        exports: {},
        require: function (t, e) {
          return commonjsRequire(t, null == e ? i.path : e);
        },
      }),
      i.exports
    ),
    i.exports
  );
}
function commonjsRequire() {
  throw new Error("Error commonjs");
}
dayjs.locale("en"),
  dayjs.extend(dayjs_utc),
  dayjs.extend(dayjs_timezone),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jQuery_T4NT"], t)
      : "object" == typeof exports
        ? t(require("jQuery_T4NT"))
        : t(window.jQuery_T4NT || window.Zepto);
  })(function (t) {
    var e,
      i,
      n,
      a,
      o,
      s,
      r = {},
      l = function () { },
      d = !!window.jQuery_T4NT,
      c = t(window),
      u = function (t, i) {
        e.ev.on("mfp" + t + ".mfp", i);
      },
      f = function (e, i, n, a) {
        var o = document.createElement("div");
        return (
          (o.className = "mfp-" + e),
          n && (o.innerHTML = n),
          a ? i && i.appendChild(o) : ((o = t(o)), i && o.appendTo(i)),
          o
        );
      },
      p = function (i, n) {
        e.ev.triggerHandler("mfp" + i, n),
          e.st.callbacks &&
          ((i = i.charAt(0).toLowerCase() + i.slice(1)),
            e.st.callbacks[i] &&
            e.st.callbacks[i].apply(e, t.isArray(n) ? n : [n]));
      },
      h = function (i) {
        return (
          (i === s && e.currTemplate.closeBtn) ||
          ((e.currTemplate.closeBtn = t(
            e.st.closeMarkup.replace("%title%", e.st.tClose)
          )),
            (s = i)),
          e.currTemplate.closeBtn
        );
      },
      m = function () {
        t.magnificPopupT4s.instance ||
          ((e = new l()).init(), (t.magnificPopupT4s.instance = e));
      };
    (l.prototype = {
      constructor: l,
      init: function () {
        var i = navigator.appVersion;
        (e.isLowIE = e.isIE8 = document.all && !document.addEventListener),
          (e.isAndroid = /android/gi.test(i)),
          (e.isIOS = /iphone|ipad|ipod/gi.test(i)),
          (e.supportsTransition = (function () {
            var t = document.createElement("p").style,
              e = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== t.transition) return !0;
            for (; e.length;) if (e.pop() + "Transition" in t) return !0;
            return !1;
          })()),
          (e.probablyMobile =
            e.isAndroid ||
            e.isIOS ||
            /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
              navigator.userAgent
            )),
          (n = t(document)),
          (e.popupsCache = {});
      },
      open: function (i) {
        var a;
        if (!1 === i.isObj) {
          (e.items = i.items.toArray()), (e.index = 0);
          var s,
            r = i.items;
          for (a = 0; a < r.length; a++)
            if (((s = r[a]).parsed && (s = s.el[0]), s === i.el[0])) {
              e.index = a;
              break;
            }
        } else
          (e.items = t.isArray(i.items) ? i.items : [i.items]),
            (e.index = i.index || 0);
        if (!e.isOpen) {
          (e.types = []),
            (o = ""),
            i.mainEl && i.mainEl.length ? (e.ev = i.mainEl.eq(0)) : (e.ev = n),
            i.key
              ? (e.popupsCache[i.key] || (e.popupsCache[i.key] = {}),
                (e.currTemplate = e.popupsCache[i.key]))
              : (e.currTemplate = {}),
            (e.st = t.extend(!0, {}, t.magnificPopupT4s.defaults, i)),
            (e.fixedContentPos =
              "auto" === e.st.fixedContentPos
                ? !e.probablyMobile
                : e.st.fixedContentPos),
            e.st.modal &&
            ((e.st.closeOnContentClick = !1),
              (e.st.closeOnBgClick = !1),
              (e.st.showCloseBtn = !1),
              (e.st.enableEscapeKey = !1)),
            e.bgOverlay ||
            ((e.bgOverlay = f("bg").on("click.mfp", function () {
              e.close();
            })),
              (e.wrap = f("wrap")
                .attr("tabindex", -1)
                .on("click.mfp", function (t) {
                  e._checkIfClose(t.target) && e.close();
                })),
              (e.container = f("container", e.wrap))),
            (e.contentContainer = f("content")),
            e.st.preloader &&
            (e.preloader = f("preloader", e.container, e.st.tLoading));
          var l = t.magnificPopupT4s.modules;
          for (a = 0; a < l.length; a++) {
            var d = l[a];
            (d = d.charAt(0).toUpperCase() + d.slice(1)), e["init" + d].call(e);
          }
          p("BeforeOpen"),
            e.st.showCloseBtn &&
            (e.st.closeBtnInside
              ? (u("MarkupParse", function (t, e, i, n) {
                i.close_replaceWith = h(n.type);
              }),
                (o += " mfp-close-btn-in"))
              : e.wrap.append(h())),
            e.st.alignTop && (o += " mfp-align-top"),
            e.fixedContentPos
              ? e.wrap.css({
                overflow: e.st.overflowY,
                overflowX: "hidden",
                overflowY: e.st.overflowY,
              })
              : e.wrap.css({
                top: c.scrollTop(),
                position: "absolute",
              }),
            (!1 === e.st.fixedBgPos ||
              ("auto" === e.st.fixedBgPos && !e.fixedContentPos)) &&
            e.bgOverlay.css({
              height: n.height(),
              position: "absolute",
            }),
            e.st.enableEscapeKey &&
            n.on("keyup.mfp", function (t) {
              27 === t.keyCode && e.close();
            }),
            c.on("resize.mfp", function () {
              e.updateSize();
            }),
            e.st.closeOnContentClick || (o += " mfp-auto-cursor"),
            o && e.wrap.addClass(o);
          var m = (e.wH = c.height()),
            g = {};
          if (e.fixedContentPos && e._hasScrollBar(m)) {
            var v = e._getScrollbarSize();
            v && (g.marginRight = v);
          }
          console.log('opteeeeee')
          e.isIE7
            ? t("body, html").css("overflow", "hidden")
            : (g.overflow = "hidden");
          var y = e.st.mainClass;
          return (
            e.isIE7 && (y += " mfp-ie7"),
            y && e._addClassToMFP(y),
            e.updateItemHTML(),
            p("BuildControls"),
            t("html").css(g),
            e.bgOverlay
              .add(e.wrap)
              .prependTo(e.st.prependTo || t(document.body)),
            (e._lastFocusedEl = document.activeElement),
            setTimeout(function () {
              e.content
                ? (e._addClassToMFP("mfp-ready"), e._setFocus())
                : e.bgOverlay.addClass("mfp-ready"),
                n.on("focusin.mfp", e._onFocusIn);
            }, 16),
            (e.isOpen = !0),
            e.updateSize(m),
            p("Open"),
            i
          );
        }
        e.updateItemHTML();
      },
      close: function () {
        e.isOpen &&
          (p("BeforeClose"),
            (e.isOpen = !1),
            e.st.removalDelay && !e.isLowIE && e.supportsTransition
              ? (e._addClassToMFP("mfp-removing"),
                setTimeout(function () {
                  e._close();
                }, e.st.removalDelay))
              : e._close());
      },
      _close: function () {
        p("Close");
        var i = "mfp-removing mfp-ready ";
        if (
          (e.bgOverlay.detach(),
            e.wrap.detach(),
            e.container.empty(),
            e.st.mainClass && (i += e.st.mainClass + " "),
            e._removeClassFromMFP(i),
            e.fixedContentPos)
        ) {
          var a = {
            marginRight: "",
          };
          e.isIE7 ? t("body, html").css("overflow", "") : (a.overflow = ""),
            t("html").css(a);
        }
        var a = {
          marginRight: "",
        };
        e.isIE7 ? t("body, html").css("overflow", "") : (a.overflow = ""),
          t("html").css(a);
        n.off("keyup.mfp focusin.mfp"),
          e.ev.off(".mfp"),
          e.wrap.attr("class", "mfp-wrap").removeAttr("style"),
          e.bgOverlay.attr("class", "mfp-bg"),
          e.container.attr("class", "mfp-container"),
          !e.st.showCloseBtn ||
          (e.st.closeBtnInside && !0 !== e.currTemplate[e.currItem.type]) ||
          (e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach()),
          e.st.autoFocusLast && e._lastFocusedEl && t(e._lastFocusedEl).focus(),
          (e.currItem = null),
          (e.content = null),
          (e.currTemplate = null),
          (e.prevHeight = 0),
          p("AfterClose");
      },
      updateSize: function (t) {
        if (e.isIOS) {
          var i = document.documentElement.clientWidth / window.innerWidth,
            n = window.innerHeight * i;
          e.wrap.css("height", n), (e.wH = n);
        } else e.wH = t || c.height();
        e.fixedContentPos || e.wrap.css("height", e.wH), p("Resize");
      },
      updateItemHTML: function () {
        var i = e.items[e.index];
        e.contentContainer.detach(),
          e.content && e.content.detach(),
          i.parsed || (i = e.parseEl(e.index));
        var n = i.type;
        if (
          (p("BeforeChange", [e.currItem ? e.currItem.type : "", n]),
            (e.currItem = i),
            !e.currTemplate[n])
        ) {
          var o = !!e.st[n] && e.st[n].markup;
          p("FirstMarkupParse", o), (e.currTemplate[n] = !o || t(o));
        }
        a && a !== i.type && e.container.removeClass("mfp-" + a + "-holder");
        var s = e["get" + n.charAt(0).toUpperCase() + n.slice(1)](
          i,
          e.currTemplate[n]
        );
        e.appendContent(s, n),
          (i.preloaded = !0),
          p("Change", i),
          (a = i.type),
          e.container.prepend(e.contentContainer),
          p("AfterChange");
      },
      appendContent: function (t, i, n) {
        if ("" == t && "ajax" == i) return !1;
        (e.content = t),
          t
            ? e.st.showCloseBtn &&
              e.st.closeBtnInside &&
              !0 === e.currTemplate[i]
              ? e.content.find(".mfp-close").length || e.content.append(h())
              : (e.content = t)
            : (e.content = ""),
          p("BeforeAppend"),
          e.container.addClass("mfp-" + i + "-holder"),
          e.contentContainer.append(e.content);
      },
      parseEl: function (i) {
        var n,
          a = e.items[i];
        if (
          (a.tagName
            ? (a = {
              el: t(a),
            })
            : ((n = a.type),
              (a = {
                data: a,
                src: a.src,
              })),
            a.el)
        ) {
          for (var o = e.types, s = 0; s < o.length; s++)
            if (a.el.hasClass("mfp-" + o[s])) {
              n = o[s];
              break;
            }
          (a.src = a.el.attr("data-mfp-src")),
            a.src || (a.src = a.el.attr("href"));
        }
        return (
          (a.type = n || e.st.type || "inline"),
          (a.index = i),
          (a.parsed = !0),
          (e.items[i] = a),
          p("ElementParse", a),
          e.items[i]
        );
      },
      addGroup: function (t, i) {
        var n = function (n) {
          (n.mfpEl = this), e._openClick(n, t, i);
        };
        i || (i = {});
        var a = "click.magnificPopupT4s";
        (i.mainEl = t),
          i.items
            ? ((i.isObj = !0), t.off(a).on(a, n))
            : ((i.isObj = !1),
              i.delegate
                ? t.off(a).on(a, i.delegate, n)
                : ((i.items = t), t.off(a).on(a, n)));
      },
      _openClick: function (i, n, a) {
        if (
          (void 0 !== a.midClick
            ? a.midClick
            : t.magnificPopupT4s.defaults.midClick) ||
          !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)
        ) {
          var o =
            void 0 !== a.disableOn
              ? a.disableOn
              : t.magnificPopupT4s.defaults.disableOn;
          if (o)
            if (t.isFunction(o)) {
              if (!o.call(e)) return !0;
            } else if (c.width() < o) return !0;
          i.type && (i.preventDefault(), e.isOpen && i.stopPropagation()),
            (a.el = t(i.mfpEl)),
            a.delegate && (a.items = n.find(a.delegate)),
            e.open(a);
        }
      },
      updateStatus: function (t, n) {
        if (e.preloader) {
          i !== t && e.container.removeClass("mfp-s-" + i),
            n || "loading" !== t || (n = e.st.tLoading);
          var a = {
            status: t,
            text: n,
          };
          p("UpdateStatus", a),
            (t = a.status),
            (n = a.text),
            e.preloader.html(n),
            e.preloader.find("a").on("click", function (t) {
              t.stopImmediatePropagation();
            }),
            e.container.addClass("mfp-s-" + t),
            (i = t);
        }
      },
      _checkIfClose: function (i) {
        if (!t(i).hasClass("mfp-prevent-close")) {
          var n = e.st.closeOnContentClick,
            a = e.st.closeOnBgClick;
          if (n && a) return !0;
          if (
            !e.content ||
            t(i).hasClass("mfp-close") ||
            (e.preloader && i === e.preloader[0])
          )
            return !0;
          if (i === e.content[0] || t.contains(e.content[0], i)) {
            if (n) return !0;
          } else if (a && t.contains(document, i)) return !0;
          return !1;
        }
      },
      _addClassToMFP: function (t) {
        e.bgOverlay.addClass(t), e.wrap.addClass(t);
      },
      _removeClassFromMFP: function (t) {
        this.bgOverlay.removeClass(t), e.wrap.removeClass(t);
      },
      _hasScrollBar: function (t) {
        return (
          (e.isIE7 ? n.height() : document.body.scrollHeight) >
          (t || c.height())
        );
      },
      _setFocus: function () {
        (e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus();
      },
      _onFocusIn: function (i) {
        if (i.target !== e.wrap[0] && !t.contains(e.wrap[0], i.target))
          return e._setFocus(), !1;
      },
      _parseMarkup: function (e, i, n) {
        var a;
        n.data && (i = t.extend(n.data, i)),
          p("MarkupParse", [e, i, n]),
          t.each(i, function (i, n) {
            if (void 0 === n || !1 === n) return !0;
            if ((a = i.split("_")).length > 1) {
              var o = e.find(".mfp-" + a[0]);
              if (o.length > 0) {
                var s = a[1];
                "replaceWith" === s
                  ? o[0] !== n[0] && o.replaceWith(n)
                  : "img" === s
                    ? o.is("img")
                      ? o.attr("src", n)
                      : o.replaceWith(
                        t("<img>").attr("src", n).attr("class", o.attr("class"))
                      )
                    : o.attr(a[1], n);
              }
            } else e.find(".mfp-" + i).html(n);
          });
      },
      _getScrollbarSize: function () {
        if (void 0 === e.scrollbarSize) {
          var t = document.createElement("div");
          (t.style.cssText =
            "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
            document.body.appendChild(t),
            (e.scrollbarSize = t.offsetWidth - t.clientWidth),
            document.body.removeChild(t);
        }
        return e.scrollbarSize;
      },
    }),
      (t.magnificPopupT4s = {
        instance: null,
        proto: l.prototype,
        modules: [],
        open: function (e, i) {
          return (
            m(),
            ((e = e ? t.extend(!0, {}, e) : {}).isObj = !0),
            (e.index = i || 0),
            this.instance.open(e)
          );
        },
        close: function () {
          return (
            t.magnificPopupT4s.instance && t.magnificPopupT4s.instance.close()
          );
        },
        registerModule: function (e, i) {
          i.options && (t.magnificPopupT4s.defaults[e] = i.options),
            t.extend(this.proto, i.proto),
            this.modules.push(e);
        },
        defaults: {
          disableOn: 0,
          key: null,
          midClick: !1,
          mainClass: "",
          preloader: !0,
          focus: "",
          closeOnContentClick: !1,
          closeOnBgClick: !0,
          closeBtnInside: !0,
          showCloseBtn: !0,
          enableEscapeKey: !0,
          modal: !1,
          alignTop: !1,
          removalDelay: 0,
          prependTo: null,
          fixedContentPos: "auto",
          fixedBgPos: "auto",
          overflowY: "auto",
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close"><svg class="t4smfp-icon-close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg></button>',
          tClose: "Close (Esc)",
          tLoading: "Loading...",
          autoFocusLast: !0,
        },
      }),
      (t.fn.magnificPopupT4s = function (i) {
        m();
        var n = t(this);
        if ("string" == typeof i)
          if ("open" === i) {
            var a,
              o = d ? n.data("magnificPopup") : n[0].magnificPopupT4s,
              s = parseInt(arguments[1], 10) || 0;
            o.items
              ? (a = o.items[s])
              : ((a = n),
                o.delegate && (a = a.find(o.delegate)),
                (a = a.eq(s))),
              e._openClick(
                {
                  mfpEl: a,
                },
                n,
                o
              );
          } else
            e.isOpen && e[i].apply(e, Array.prototype.slice.call(arguments, 1));
        else
          (i = t.extend(!0, {}, i)),
            d ? n.data("magnificPopup", i) : (n[0].magnificPopupT4s = i),
            e.addGroup(n, i);
        return n;
      });
    var g,
      v,
      y,
      b = function () {
        y && (v.after(y.addClass(g)).detach(), (y = null));
      };
    t.magnificPopupT4s.registerModule("inline", {
      options: {
        hiddenClass: "hide",
        markup: "",
        tNotFound: "Content not found",
      },
      proto: {
        initInline: function () {
          e.types.push("inline"),
            u("Close.inline", function () {
              b();
            });
        },
        getInline: function (i, n) {
          if ((b(), i.src)) {
            var a = e.st.inline,
              o = t(i.src);
            if (o.length) {
              var s = o[0].parentNode;
              s &&
                s.tagName &&
                (v || ((g = a.hiddenClass), (v = f(g)), (g = "mfp-" + g)),
                  (y = o.after(v).detach().removeClass(g))),
                e.updateStatus("ready");
            } else e.updateStatus("error", a.tNotFound), (o = t("<div>"));
            return (i.inlineElement = o), o;
          }
          return e.updateStatus("ready"), e._parseMarkup(n, {}, i), n;
        },
      },
    });
    var S,
      w,
      T,
      _ = function () {
        S && t(document.body).removeClass(S);
      },
      C = function () {
        _(), e.req && e.req.abort();
      };
    t.magnificPopupT4s.registerModule("ajax", {
      options: {
        settings: null,
        cursor: "mfp-ajax-cur",
        tError: '<a href="%url%">The content</a> could not be loaded.',
      },
      proto: {
        initAjax: function () {
          e.types.push("ajax"),
            (S = e.st.ajax.cursor),
            u("Close.ajax", C),
            u("BeforeChange.ajax", C);
        },
        getAjax: function (i) {
          S && t(document.body).addClass(S), e.updateStatus("loading");
          var n = t(i.el).attr("data-storageid") || "nt94",
            a = t.extend(
              {
                url: i.src,
                success: function (a, o, s) {
                  var l = {
                    data: a,
                    xhr: s,
                  };
                  p("ParseAjax", l),
                    e.appendContent(t(l.data), "ajax"),
                    (i.finished = !0),
                    _(),
                    e._setFocus(),
                    setTimeout(function () {
                      e.wrap.addClass("mfp-ready");
                    }, 16),
                    e.updateStatus("ready"),
                    p("AjaxContentAdded"),
                    (r[n] = a);
                },
                error: function () {
                  _(),
                    (i.finished = i.loadError = !0),
                    e.updateStatus(
                      "error",
                      e.st.ajax.tError.replace("%url%", i.src)
                    );
                },
              },
              e.st.ajax.settings
            ),
            o = r[n];
          if (void 0 !== o) {
            var s = {
              data: o,
            };
            p("ParseAjax", s),
              e.appendContent(t(s.data), "ajax"),
              _(),
              e._setFocus(),
              setTimeout(function () {
                e.wrap.addClass("mfp-ready");
              }, 16),
              e.updateStatus("ready"),
              p("AjaxContentAdded");
          } else e.req = t.ajax(a);
          return "";
        },
      },
    }),
      t.magnificPopupT4s.registerModule("image", {
        options: {
          markup:
            '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
          cursor: "mfp-zoom-out-cur",
          titleSrc: "title",
          verticalFit: !0,
          tError: '<a href="%url%">The image</a> could not be loaded.',
        },
        proto: {
          initImage: function () {
            var i = e.st.image,
              n = ".image";
            e.types.push("image"),
              u("Open" + n, function () {
                "image" === e.currItem.type &&
                  i.cursor &&
                  t(document.body).addClass(i.cursor);
              }),
              u("Close" + n, function () {
                i.cursor && t(document.body).removeClass(i.cursor),
                  c.off("resize.mfp");
              }),
              u("Resize" + n, e.resizeImage),
              e.isLowIE && u("AfterChange", e.resizeImage);
          },
          resizeImage: function () {
            var t = e.currItem;
            if (t && t.img && e.st.image.verticalFit) {
              var i = 0;
              e.isLowIE &&
                (i =
                  parseInt(t.img.css("padding-top"), 10) +
                  parseInt(t.img.css("padding-bottom"), 10)),
                t.img.css("max-height", e.wH - i);
            }
          },
          _onImageHasSize: function (t) {
            t.img &&
              ((t.hasSize = !0),
                w && clearInterval(w),
                (t.isCheckingImgSize = !1),
                p("ImageHasSize", t),
                t.imgHidden &&
                (e.content && e.content.removeClass("mfp-loading"),
                  (t.imgHidden = !1)));
          },
          findImageSize: function (t) {
            var i = 0,
              n = t.img[0],
              a = function (o) {
                w && clearInterval(w),
                  (w = setInterval(function () {
                    n.naturalWidth > 0
                      ? e._onImageHasSize(t)
                      : (i > 200 && clearInterval(w),
                        3 == ++i
                          ? a(10)
                          : 40 === i
                            ? a(50)
                            : 100 === i && a(500));
                  }, o));
              };
            a(1);
          },
          getImage: function (i, n) {
            var a = 0,
              o = function () {
                i &&
                  (i.img[0].complete
                    ? (i.img.off(".mfploader"),
                      i === e.currItem &&
                      (e._onImageHasSize(i), e.updateStatus("ready")),
                      (i.hasSize = !0),
                      (i.loaded = !0),
                      p("ImageLoadComplete"))
                    : ++a < 200
                      ? setTimeout(o, 100)
                      : s());
              },
              s = function () {
                i &&
                  (i.img.off(".mfploader"),
                    i === e.currItem &&
                    (e._onImageHasSize(i),
                      e.updateStatus("error", r.tError.replace("%url%", i.src))),
                    (i.hasSize = !0),
                    (i.loaded = !0),
                    (i.loadError = !0));
              },
              r = e.st.image,
              l = n.find(".mfp-img");
            if (l.length) {
              var d = document.createElement("img");
              (d.className = "mfp-img"),
                i.el &&
                i.el.find("img").length &&
                (d.alt = i.el.find("img").attr("alt")),
                (i.img = t(d).on("load.mfploader", o).on("error.mfploader", s)),
                (d.src = i.src),
                l.is("img") && (i.img = i.img.clone()),
                (d = i.img[0]).naturalWidth > 0
                  ? (i.hasSize = !0)
                  : d.width || (i.hasSize = !1);
            }
            return (
              e._parseMarkup(
                n,
                {
                  title: (function (i) {
                    if (i.data && void 0 !== i.data.title) return i.data.title;
                    var n = e.st.image.titleSrc;
                    if (n) {
                      if (t.isFunction(n)) return n.call(e, i);
                      if (i.el) return i.el.attr(n) || "";
                    }
                    return "";
                  })(i),
                  img_replaceWith: i.img,
                },
                i
              ),
              e.resizeImage(),
              i.hasSize
                ? (w && clearInterval(w),
                  i.loadError
                    ? (n.addClass("mfp-loading"),
                      e.updateStatus("error", r.tError.replace("%url%", i.src)))
                    : (n.removeClass("mfp-loading"), e.updateStatus("ready")),
                  n)
                : (e.updateStatus("loading"),
                  (i.loading = !0),
                  i.hasSize ||
                  ((i.imgHidden = !0),
                    n.addClass("mfp-loading"),
                    e.findImageSize(i)),
                  n)
            );
          },
        },
      }),
      t.magnificPopupT4s.registerModule("zoom", {
        options: {
          enabled: !1,
          easing: "ease-in-out",
          duration: 300,
          opener: function (t) {
            return t.is("img") ? t : t.find("img");
          },
        },
        proto: {
          initZoom: function () {
            var t,
              i = e.st.zoom,
              n = ".zoom";
            if (i.enabled && e.supportsTransition) {
              var a,
                o,
                s = i.duration,
                r = function (t) {
                  var e = t
                    .clone()
                    .removeAttr("style")
                    .removeAttr("class")
                    .addClass("mfp-animated-image"),
                    n = "all " + i.duration / 1e3 + "s " + i.easing,
                    a = {
                      position: "fixed",
                      zIndex: 9999,
                      left: 0,
                      top: 0,
                      "-webkit-backface-visibility": "hidden",
                    },
                    o = "transition";
                  return (
                    (a["-webkit-" + o] =
                      a["-moz-" + o] =
                      a["-o-" + o] =
                      a[o] =
                      n),
                    e.css(a),
                    e
                  );
                },
                l = function () {
                  e.content.css("visibility", "visible");
                };
              u("BuildControls" + n, function () {
                if (e._allowZoom()) {
                  if (
                    (clearTimeout(a),
                      e.content.css("visibility", "hidden"),
                      !(t = e._getItemToZoom()))
                  )
                    return void l();
                  (o = r(t)).css(e._getOffset()),
                    e.wrap.append(o),
                    (a = setTimeout(function () {
                      o.css(e._getOffset(!0)),
                        (a = setTimeout(function () {
                          l(),
                            setTimeout(function () {
                              o.remove(),
                                (t = o = null),
                                p("ZoomAnimationEnded");
                            }, 16);
                        }, s));
                    }, 16));
                }
              }),
                u("BeforeClose" + n, function () {
                  if (e._allowZoom()) {
                    if ((clearTimeout(a), (e.st.removalDelay = s), !t)) {
                      if (!(t = e._getItemToZoom())) return;
                      o = r(t);
                    }
                    o.css(e._getOffset(!0)),
                      e.wrap.append(o),
                      e.content.css("visibility", "hidden"),
                      setTimeout(function () {
                        o.css(e._getOffset());
                      }, 16);
                  }
                }),
                u("Close" + n, function () {
                  e._allowZoom() && (l(), o && o.remove(), (t = null));
                });
            }
          },
          _allowZoom: function () {
            return "image" === e.currItem.type;
          },
          _getItemToZoom: function () {
            return !!e.currItem.hasSize && e.currItem.img;
          },
          _getOffset: function (i) {
            var n,
              a = (n = i
                ? e.currItem.img
                : e.st.zoom.opener(e.currItem.el || e.currItem)).offset(),
              o = parseInt(n.css("padding-top"), 10),
              s = parseInt(n.css("padding-bottom"), 10);
            a.top -= t(window).scrollTop() - o;
            var r = {
              width: n.width(),
              height: (d ? n.innerHeight() : n[0].offsetHeight) - s - o,
            };
            return (
              void 0 === T &&
              (T = void 0 !== document.createElement("p").style.MozTransform),
              T
                ? (r["-moz-transform"] = r.transform =
                  "translate(" + a.left + "px," + a.top + "px)")
                : ((r.left = a.left), (r.top = a.top)),
              r
            );
          },
        },
      });
    var $ = function (t) {
      if (e.currTemplate.iframe) {
        var i = e.currTemplate.iframe.find("iframe");
        i.length &&
          (t || (i[0].src = "//about:blank"),
            e.isIE8 && i.css("display", t ? "block" : "none"));
      }
    };
    t.magnificPopupT4s.registerModule("iframe", {
      options: {
        markup:
          '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
        srcAction: "iframe_src",
        patterns: {
          youtube: {
            index: "youtube.com",
            id: "v=",
            src: "//www.youtube.com/embed/%id%?autoplay=1",
          },
          vimeo: {
            index: "vimeo.com/",
            id: "/",
            src: "//player.vimeo.com/video/%id%?autoplay=1",
          },
          gmaps: {
            index: "//maps.google.",
            src: "%id%&output=embed",
          },
        },
      },
      proto: {
        initIframe: function () {
          e.types.push("iframe"),
            u("BeforeChange", function (t, e, i) {
              e !== i && ("iframe" === e ? $() : "iframe" === i && $(!0));
            }),
            u("Close.iframe", function () {
              $();
            });
        },
        getIframe: function (i, n) {
          var a = i.src,
            o = e.st.iframe;
          t.each(o.patterns, function () {
            if (a.indexOf(this.index) > -1)
              return (
                this.id &&
                (a =
                  "string" == typeof this.id
                    ? a.substr(
                      a.lastIndexOf(this.id) + this.id.length,
                      a.length
                    )
                    : this.id.call(this, a)),
                (a = this.src.replace(/%id%/g, a)),
                !1
              );
          });
          var s = {};
          return (
            o.srcAction && (s[o.srcAction] = a),
            e._parseMarkup(n, s, i),
            e.updateStatus("ready"),
            n
          );
        },
      },
    });
    var k = function (t) {
      var i = e.items.length;
      return t > i - 1 ? t - i : t < 0 ? i + t : t;
    },
      x = function (t, e, i) {
        return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i);
      };
    t.magnificPopupT4s.registerModule("gallery", {
      options: {
        enabled: !1,
        arrowMarkup:
          '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
        preload: [0, 2],
        navigateByImgClick: !0,
        arrows: !0,
        tPrev: "Previous (Left arrow key)",
        tNext: "Next (Right arrow key)",
        tCounter: "%curr% of %total%",
      },
      proto: {
        initGallery: function () {
          var i = e.st.gallery,
            a = ".mfp-gallery";
          if (((e.direction = !0), !i || !i.enabled)) return !1;
          (o += " mfp-gallery"),
            u("Open" + a, function () {
              i.navigateByImgClick &&
                e.wrap.on("click" + a, ".mfp-img", function () {
                  if (e.items.length > 1) return e.next(), !1;
                }),
                n.on("keydown" + a, function (t) {
                  37 === t.keyCode ? e.prev() : 39 === t.keyCode && e.next();
                });
            }),
            u("UpdateStatus" + a, function (t, i) {
              i.text && (i.text = x(i.text, e.currItem.index, e.items.length));
            }),
            u("MarkupParse" + a, function (t, n, a, o) {
              var s = e.items.length;
              a.counter = s > 1 ? x(i.tCounter, o.index, s) : "";
            }),
            u("BuildControls" + a, function () {
              if (e.items.length > 1 && i.arrows && !e.arrowLeft) {
                var n = i.arrowMarkup,
                  a = (e.arrowLeft = t(
                    n.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")
                  ).addClass("mfp-prevent-close")),
                  o = (e.arrowRight = t(
                    n.replace(/%title%/gi, i.tNext).replace(/%dir%/gi, "right")
                  ).addClass("mfp-prevent-close"));
                a.click(function () {
                  e.prev();
                }),
                  o.click(function () {
                    e.next();
                  }),
                  e.container.append(a.add(o));
              }
            }),
            u("Change" + a, function () {
              e._preloadTimeout && clearTimeout(e._preloadTimeout),
                (e._preloadTimeout = setTimeout(function () {
                  e.preloadNearbyImages(), (e._preloadTimeout = null);
                }, 16));
            }),
            u("Close" + a, function () {
              n.off(a),
                e.wrap.off("click" + a),
                (e.arrowRight = e.arrowLeft = null);
            });
        },
        next: function () {
          (e.direction = !0), (e.index = k(e.index + 1)), e.updateItemHTML();
        },
        prev: function () {
          (e.direction = !1), (e.index = k(e.index - 1)), e.updateItemHTML();
        },
        goTo: function (t) {
          (e.direction = t >= e.index), (e.index = t), e.updateItemHTML();
        },
        preloadNearbyImages: function () {
          var t,
            i = e.st.gallery.preload,
            n = Math.min(i[0], e.items.length),
            a = Math.min(i[1], e.items.length);
          for (t = 1; t <= (e.direction ? a : n); t++)
            e._preloadItem(e.index + t);
          for (t = 1; t <= (e.direction ? n : a); t++)
            e._preloadItem(e.index - t);
        },
        _preloadItem: function (i) {
          if (((i = k(i)), !e.items[i].preloaded)) {
            var n = e.items[i];
            n.parsed || (n = e.parseEl(i)),
              p("LazyLoad", n),
              "image" === n.type &&
              (n.img = t('<img class="mfp-img" />')
                .on("load.mfploader", function () {
                  n.hasSize = !0;
                })
                .on("error.mfploader", function () {
                  (n.hasSize = !0), (n.loadError = !0), p("LazyLoadError", n);
                })
                .attr("src", n.src)),
              (n.preloaded = !0);
          }
        },
      },
    }),
      t.magnificPopupT4s.registerModule("retina", {
        options: {
          replaceSrc: function (t) {
            return t.src.replace(/\.\w+$/, function (t) {
              return "@2x" + t;
            });
          },
          ratio: 1,
        },
        proto: {
          initRetina: function () {
            if (window.devicePixelRatio > 1) {
              var t = e.st.retina,
                i = t.ratio;
              (i = isNaN(i) ? i() : i) > 1 &&
                (u("ImageHasSize.retina", function (t, e) {
                  e.img.css({
                    "max-width": e.img[0].naturalWidth / i,
                    width: "100%",
                  });
                }),
                  u("ElementParse.retina", function (e, n) {
                    n.src = t.replaceSrc(n, i);
                  }));
            }
          },
        },
      }),
      m();
  });
var fastdomT4s = createCommonjsModule(function (t) {
  !(function (e) {
    var i = function () { },
      n =
        e.requestAnimationFrame ||
        e.webkitRequestAnimationFrame ||
        e.mozRequestAnimationFrame ||
        e.msRequestAnimationFrame ||
        function (t) {
          return setTimeout(t, 16);
        };
    function a() {
      (this.reads = []), (this.writes = []), (this.raf = n.bind(e));
    }
    function o(t) {
      t.scheduled ||
        ((t.scheduled = !0),
          t.raf(
            function (t) {
              var e,
                n = t.writes,
                a = t.reads;
              try {
                i("flushing reads", a.length),
                  s(a),
                  i("flushing writes", n.length),
                  s(n);
              } catch (t) {
                e = t;
              }
              (t.scheduled = !1), (a.length || n.length) && o(t);
              if (e) {
                if ((i("task errored", e.message), !t.catch)) throw e;
                t.catch(e);
              }
            }.bind(null, t)
          ));
    }
    function s(t) {
      for (var e; (e = t.shift());) e();
    }
    function r(t, e) {
      var i = t.indexOf(e);
      return !!~i && !!t.splice(i, 1);
    }
    a.prototype = {
      constructor: a,
      measure: function (t, e) {
        var i = e ? t.bind(e) : t;
        return this.reads.push(i), o(this), i;
      },
      mutate: function (t, e) {
        var i = e ? t.bind(e) : t;
        return this.writes.push(i), o(this), i;
      },
      clear: function (t) {
        return r(this.reads, t) || r(this.writes, t);
      },
      extend: function (t) {
        if ("object" != _typeof(t)) throw new Error("expected object");
        var e = Object.create(this);
        return (
          (function (t, e) {
            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
          })(e, t),
          (e.fastdom = this),
          e.initialize && e.initialize(),
          e
        );
      },
      catch: null,
    };
    var l = (e.fastdom = e.fastdom || new a());
    t.exports = l;
  })("undefined" != typeof window ? window : commonjsGlobal);
}),
  smoothscroll = createCommonjsModule(function (t, e) {
    !(function () {
      t.exports = {
        polyfill: function () {
          var t = window,
            e = document;
          if (
            !(
              "scrollBehavior" in e.documentElement.style &&
              !0 !== t.__forceSmoothScrollPolyfill__
            )
          ) {
            var i,
              n = t.HTMLElement || t.Element,
              a = 468,
              o = {
                scroll: t.scroll || t.scrollTo,
                scrollBy: t.scrollBy,
                elementScroll: n.prototype.scroll || l,
                scrollIntoView: n.prototype.scrollIntoView,
              },
              s =
                t.performance && t.performance.now
                  ? t.performance.now.bind(t.performance)
                  : Date.now,
              r =
                ((i = t.navigator.userAgent),
                  new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(i)
                    ? 1
                    : 0);
            (t.scroll = t.scrollTo =
              function () {
                void 0 !== arguments[0] &&
                  (!0 !== d(arguments[0])
                    ? h.call(
                      t,
                      e.body,
                      void 0 !== arguments[0].left
                        ? ~~arguments[0].left
                        : t.scrollX || t.pageXOffset,
                      void 0 !== arguments[0].top
                        ? ~~arguments[0].top
                        : t.scrollY || t.pageYOffset
                    )
                    : o.scroll.call(
                      t,
                      void 0 !== arguments[0].left
                        ? arguments[0].left
                        : "object" !== _typeof(arguments[0])
                          ? arguments[0]
                          : t.scrollX || t.pageXOffset,
                      void 0 !== arguments[0].top
                        ? arguments[0].top
                        : void 0 !== arguments[1]
                          ? arguments[1]
                          : t.scrollY || t.pageYOffset
                    ));
              }),
              (t.scrollBy = function () {
                void 0 !== arguments[0] &&
                  (d(arguments[0])
                    ? o.scrollBy.call(
                      t,
                      void 0 !== arguments[0].left
                        ? arguments[0].left
                        : "object" !== _typeof(arguments[0])
                          ? arguments[0]
                          : 0,
                      void 0 !== arguments[0].top
                        ? arguments[0].top
                        : void 0 !== arguments[1]
                          ? arguments[1]
                          : 0
                    )
                    : h.call(
                      t,
                      e.body,
                      ~~arguments[0].left + (t.scrollX || t.pageXOffset),
                      ~~arguments[0].top + (t.scrollY || t.pageYOffset)
                    ));
              }),
              (n.prototype.scroll = n.prototype.scrollTo =
                function () {
                  if (void 0 !== arguments[0])
                    if (!0 !== d(arguments[0])) {
                      var t = arguments[0].left,
                        e = arguments[0].top;
                      h.call(
                        this,
                        this,
                        void 0 === t ? this.scrollLeft : ~~t,
                        void 0 === e ? this.scrollTop : ~~e
                      );
                    } else {
                      if (
                        "number" == typeof arguments[0] &&
                        void 0 === arguments[1]
                      )
                        throw new SyntaxError("Value could not be converted");
                      o.elementScroll.call(
                        this,
                        void 0 !== arguments[0].left
                          ? ~~arguments[0].left
                          : "object" !== _typeof(arguments[0])
                            ? ~~arguments[0]
                            : this.scrollLeft,
                        void 0 !== arguments[0].top
                          ? ~~arguments[0].top
                          : void 0 !== arguments[1]
                            ? ~~arguments[1]
                            : this.scrollTop
                      );
                    }
                }),
              (n.prototype.scrollBy = function () {
                void 0 !== arguments[0] &&
                  (!0 !== d(arguments[0])
                    ? this.scroll({
                      left: ~~arguments[0].left + this.scrollLeft,
                      top: ~~arguments[0].top + this.scrollTop,
                      behavior: arguments[0].behavior,
                    })
                    : o.elementScroll.call(
                      this,
                      void 0 !== arguments[0].left
                        ? ~~arguments[0].left + this.scrollLeft
                        : ~~arguments[0] + this.scrollLeft,
                      void 0 !== arguments[0].top
                        ? ~~arguments[0].top + this.scrollTop
                        : ~~arguments[1] + this.scrollTop
                    ));
              }),
              (n.prototype.scrollIntoView = function () {
                if (!0 !== d(arguments[0])) {
                  var i = (function (t) {
                    for (; t !== e.body && !1 === f(t);)
                      t = t.parentNode || t.host;
                    return t;
                  })(this),
                    n = i.getBoundingClientRect(),
                    a = this.getBoundingClientRect();
                  i !== e.body
                    ? (h.call(
                      this,
                      i,
                      i.scrollLeft + a.left - n.left,
                      i.scrollTop + a.top - n.top
                    ),
                      "fixed" !== t.getComputedStyle(i).position &&
                      t.scrollBy({
                        left: n.left,
                        top: n.top,
                        behavior: "smooth",
                      }))
                    : t.scrollBy({
                      left: a.left,
                      top: a.top,
                      behavior: "smooth",
                    });
                } else
                  o.scrollIntoView.call(
                    this,
                    void 0 === arguments[0] || arguments[0]
                  );
              });
          }
          function l(t, e) {
            (this.scrollLeft = t), (this.scrollTop = e);
          }
          function d(t) {
            if (
              null === t ||
              "object" !== _typeof(t) ||
              void 0 === t.behavior ||
              "auto" === t.behavior ||
              "instant" === t.behavior
            )
              return !0;
            if ("object" === _typeof(t) && "smooth" === t.behavior) return !1;
            throw new TypeError(
              "behavior member of ScrollOptions " +
              t.behavior +
              " is not a valid value for enumeration ScrollBehavior."
            );
          }
          function c(t, e) {
            return "Y" === e
              ? t.clientHeight + r < t.scrollHeight
              : "X" === e
                ? t.clientWidth + r < t.scrollWidth
                : void 0;
          }
          function u(e, i) {
            var n = t.getComputedStyle(e, null)["overflow" + i];
            return "auto" === n || "scroll" === n;
          }
          function f(t) {
            var e = c(t, "Y") && u(t, "Y"),
              i = c(t, "X") && u(t, "X");
            return e || i;
          }
          function p(e) {
            var i,
              n,
              o,
              r,
              l = (s() - e.startTime) / a;
            (r = l = l > 1 ? 1 : l),
              (i = 0.5 * (1 - Math.cos(Math.PI * r))),
              (n = e.startX + (e.x - e.startX) * i),
              (o = e.startY + (e.y - e.startY) * i),
              e.method.call(e.scrollable, n, o),
              (n === e.x && o === e.y) || t.requestAnimationFrame(p.bind(t, e));
          }
          function h(i, n, a) {
            var r,
              d,
              c,
              u,
              f = s();
            i === e.body
              ? ((r = t),
                (d = t.scrollX || t.pageXOffset),
                (c = t.scrollY || t.pageYOffset),
                (u = o.scroll))
              : ((r = i), (d = i.scrollLeft), (c = i.scrollTop), (u = l)),
              p({
                scrollable: r,
                method: u,
                startTime: f,
                startX: d,
                startY: c,
                x: n,
                y: a,
              });
          }
        },
      };
    })();
  });
function onYouTubeIframeAPIReady() {
  document.dispatchEvent(new CustomEvent("youtube:ready"));
}
!(function (t) {
  "use strict";
  var e = t(window),
    i = t(document),
    n = t("html"),
    a = t("body"),
    o = e.width(),
    s = o < 768,
    r = window.T4Srequest.design_mode,
    l = window.T4Sstrings,
    d = !!(
      "ontouchstart" in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
    );
  (T4SThemeSP.isHover = n.hasClass("t4sp-hover")),
    (T4SThemeSP.isTouch = !T4SThemeSP.isHover && d),
    (T4SThemeSP.getToFetchSection = function (t, e = "text", i = null) {
      let n = t ? T4SThemeSP.root_url + t : i;
      return fetch(n, {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
        },
      })
        .then((t) =>
          t.redirected ? "NVT_94" : "text" == e ? t.text() : t.json()
        )
        .then((t) => t)
        .catch((t) => (console.warn(t), "NVT_94"));
    }),
    (T4SThemeSP.OverflowScroller = (function () {
      function t(t, e) {
        (!t && o > 767) ||
          ((this.element = t),
            (this.options = e),
            (this.lastKnownY = window.scrollY),
            (this.currentTop = 0),
            (this.initialTopOffset =
              e.offsetTop || parseInt(window.getComputedStyle(this.element).top)),
            this._attachListeners(),
            e.updateOffsetTop &&
            ((this.initialTopOffsetCache = this.initialTopOffset),
              this._updateInitialTopOffset()));
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          _updateInitialTopOffset: function () {
            window.addEventListener("T4sHeaderReveal", function () {
              this.initialTopOffset = this.initialTopOffsetCache;
            }),
              window.addEventListener("T4sHeaderHide", function () {
                this.initialTopOffset = 30;
              });
          },
          _attachListeners: function () {
            (this._checkPositionListener = this._checkPosition.bind(this)),
              window.addEventListener("scroll", this._checkPositionListener);
          },
          _checkPosition: function () {
            var t = this;
            fastdomT4s.measure(function () {
              var e =
                t.element.getBoundingClientRect().top +
                window.scrollY -
                t.element.offsetTop +
                t.initialTopOffset,
                i =
                  t.element.clientHeight -
                  window.innerHeight +
                  (t.options.offsetBottom || 0);
              window.scrollY < t.lastKnownY
                ? (t.currentTop -= window.scrollY - t.lastKnownY)
                : (t.currentTop += t.lastKnownY - window.scrollY),
                (t.currentTop = Math.min(
                  Math.max(t.currentTop, -i),
                  e,
                  t.initialTopOffset
                )),
                (t.lastKnownY = window.scrollY);
            }),
              fastdomT4s.mutate(function () {
                t.element.style.top = "".concat(t.currentTop, "px");
              });
          },
          destroy: function () {
            window.removeEventListener("scroll", this._checkPositionListener);
          },
        })),
        t
      );
    })());
  var c = (function () {
    var e = "[data-swatch-item]",
      i = "is--unavailable",
      n = "is--soldout " + i,
      o = window.T4SProductStrings,
      s = o.unavailable,
      r = o.addToCart,
      l = o.soldOut,
      d = o.preOrder,
      c = ((r = o.addToCart), o.replace_qs_atc),
      u = o.replace_qs_pre,
      f = o.badgeSavePercent2,
      p = o.badgeSaveFixed2,
      h = "aria-disabled";
    function m(e) {
      (this.$container = e.$container),
        (this.variants = e.variants),
        (this.productOptions = e.productOptions),
        (this.productOptionSize = e.PrOptionsSize),
        (this.formSelectorId = e.formSelectorId),
        (this.originalSelectorId = e.originalSelectorId),
        (this.enableHistoryState = e.enableHistoryState),
        (this.removeSoldout = e.removeSoldout),
        (this.$options1 = e.$options1),
        (this.$options2 = e.$options2),
        (this.$options3 = e.$options3),
        (this.isNoPick = e.isNoPick),
        (this.isNoPickOriginal = e.isNoPick),
        (this.hasSoldoutUnavailable = e.hasSoldoutUnavailable),
        (this.canMediaGroup = e.canMediaGroup),
        (this.badgesConfigs = e.badgesConfigs),
        (this.$variantImg = e.$variantImg),
        (this.disableVariantImage = e.disableVariantImage),
        (this.swatchWidth = e.swatchWidth),
        (this.$incomingMess = t(this.formSelectorId).find(
          "[data-incoming__mess"
        )),
        (this.isSticky = e.isSticky),
        (this.isMainProduct = e.isMainProduct),
        (this.$quantity = t(this.formSelectorId).find(
          "[data-quantity-value"
        )),
        (this.clickedOptions = []),
        (this.showFirstMedia = e.showFirstMedia),
        (this.oldVariant = {}),
        (this.currentVariant = {}),
        (this.mediaID = 0),
        (this.eventClickedSwatch = !1),
        (this.variantState = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          preOrder: !1,
          showUnitPrice: !1,
        }),
        (this.$productPrice = this.$container.find(
          "[data-product-price]:not([class*=no-save-banner])"
        )),
        (this.saletype = this.$productPrice.data("saletype"));
      let i = this.$container.find("[data-product-unit-price]");
      (this.$unit_price = i.find("[data-unit-price]")),
        (this.$unit_base = i.find("[data-unit-base]"));
      let n = this.$container.find("[data-product-single-badge]"),
        a = this.badgesConfigs.texts,
        o = this.badgesConfigs.saleStyle;
      if (
        ((this.badgeSelector = {
          $onSale: n.find("[data-badge-sale]"),
          $preOrder: n.find("[data-badge-preorder]"),
          $soldOut: n.find("[data-badge-soldout]"),
        }),
          (this.saleLabel = "2" == o ? a.SavePercent : a.sale),
          (this.useComingMess = !1),
          this.$incomingMess[0] &&
          ((this.useComingMess = !0),
            (this.$incomingAvailable = this.$incomingMess.find(
              "[data-incoming-available]"
            )),
            (this.$incomingSoldout = this.$incomingMess.find(
              "[data-incoming-soldout]"
            )),
            (this.$incomingAvailableDate = this.$incomingAvailable.find(
              "[data-incoming-date]"
            )),
            (this.$incomingSoldoutDate = this.$incomingSoldout.find(
              "[data-incoming-date]"
            ))),
          (this.$addToCartButton = this.formSelectorId.find(
            '[type="submit"][name="add"]'
          )),
          (this.$quantityWrapper = this.formSelectorId.find(
            "[data-quantity-wrapper]"
          )),
          (this.$paymentButton = this.formSelectorId.find(
            ".shopify-payment-button"
          )),
          (this.$addToCartButtonText =
            this.$addToCartButton.find(".t4s-btn-atc_text")),
          this.isSticky)
      ) {
        let e = t("[data-sticky-addtocart]");
        (this.$stickyimg = e.find("[data-sticky-img] img")),
          (this.$stickyVtitle = e.find("[data-sticky-v-title]")),
          (this.$stickyPrice = e.find("[data-sticky-price]")),
          (this.$stickyATC = e.find("[data-action-atc]")),
          (this.$stickyATCText = this.$stickyATC.find(".t4s-btn-atc_text")),
          (this.stickyImgOrginal = this.$stickyimg.data("orginal")),
          (this.$stickyQuantityWrapper = e.find("[data-quantity-wrapper]")),
          (this.$stickyQuantity = this.$stickyQuantityWrapper.find(
            "[data-quantity-value]"
          ));
        var s = this;
        this.$stickyQuantity.change(function () {
          s.$quantity.val(this.value);
        }),
          this.$quantity.change(function () {
            s.$stickyQuantity.val(this.value);
          });
      }
      T4SThemeSP.isEditCartReplace &&
        ((this.txt_addToCart = c), (this.txt_preOrder = u)),
        this.originalSelectorId.on("change", this._onSelectChange.bind(this)),
        this.isNoPick
          ? // false ?
          ((this.currentVariant = this._getVariantFromVariantid()),
            (this.updateMediaFilterNoPick = this._updateMediaFilterNoPick))
          : this.originalSelectorId[0].dispatchEvent(
            new Event("change", {
              bubbles: !0,
              cancelable: !0,
            })
          );
    }
    function g(t) {
      return t ? n : i;
    }
    return (
      (m.prototype = Object.assign({}, m.prototype, {
        _onSelectChange: function () {
          this.eventClickedSwatch || (this.oldVariant = this.currentVariant);
          var t = this.eventClickedSwatch
            ? this.currentVariant
            : this._getVariantFromVariantid();
          const option_name = this.productOptions.filter((o) =>
            /color/gi.test(o.name)
          );
          // 当选项只选了一项，或者只有一个选项时，只保留选项和图片更新功能。
          if (
            this.formSelectorId.find(".is--selected").length <= 1 &&
            this.productOptions.filter((o) => /color/gi.test(o.name)).length >
            0 &&
            /color/gi.test(this.productOptions[0].name)
          ) {
            this._updateSwatchSelector(
              t,
              this.oldVariant,
              this.formSelectorId,
              this.hasSoldoutUnavailable,
              true
            ),
              this._updatePrice(t, this.oldVariant, this.$container),
              this._updateBadges(),
              this._updateMedia(t, this.oldVariant, this.$container);
            return;
          }

          this._setVariantState(t),
            this._updateSwatchSelector(
              t,
              this.oldVariant,
              this.formSelectorId,
              this.hasSoldoutUnavailable
            ),
            this._updatePrice(t, this.oldVariant, this.$container),
            this._updateAddToCartButton(
              t,
              this.oldVariant,
              this.$addToCartButton,
              this.$quantityWrapper,
              this.$paymentButton,
              this.$addToCartButtonText
            ),
            this._updateAvailability(t, this.oldVariant, this.$container),
            this._updateSKU(t, this.oldVariant, this.$container),
            this._updateBarcode(t, this.oldVariant, this.$container),
            this._updateMetafield(t, this.oldVariant, this.$container),
            this._updateDelivery(t, this.oldVariant, this.$container),
            this._updateInventoryQuantity(
              t,
              this.oldVariant,
              this.$container
            ),
            this._updatePickupAvailabilityContent(t, this.$container),
            this._updateNotifyBackinStock(t, this.$container),
            this._updateBadges(),
            this._updateIncomingMess(t),
            t &&
            ((this.currentVariant = t),
              this.canMediaGroup &&
              this._updateMediaFilter(t, this.oldVariant, this.$container),
              this._updateMedia(t, this.oldVariant, this.$container),
              this._updateQuantity(t),
              this.disableVariantImage || this._updateVariantImageSwatch(t),
              this.isSticky && this._updateStickyATC(t),
              this.enableHistoryState && this._updateHistoryState(t),
              this.$container.trigger({
                type: "variant:changed",
                currentVariant: t,
                oldVariant: this.oldVariant,
              }));

          let productId = ''
          try {
            productId = JSON.parse(this.$container.attr('data-product-featured') || "{}").id
          } catch (err) {
            productId = ''
          }

          // 选择swatch后给对应的title添加选中文案
          const onSelectSwatchItem = () => {
            const pr_metafield = JSON.parse(this.$container.find(".pr_metafield_json").html() || "{}")
            const optionTitleTipsEls = $('div[data-swatch-option].is--style_option').find(".t4s-swatch__current")
            optionTitleTipsEls.show()

            function updateSelectedOptionText(text) {
              const selected_el = '#add_cart_wrapper #selected-options'
              $(selected_el).text(text)
            }

            // 更改长度选项文案
            function updatePetiteTips(option_el) {
              console.log(option_el)
              const petiteTips = window.length_styles_tips?.[option_el.dataset.value.toLowerCase()] || ''
              const modelInfoIndex = option_el.dataset.index
              const model_el = "form[data-type='add-to-cart-form'] #model-info"

              if (window.style_name_list.includes(option_el.dataset.optionTitle.toLowerCase())) {
                console.log('optionTitleTipsEl', optionTitleTipsEls)
                $(model_el).text(window.model_info_list[modelInfoIndex])
                optionTitleTipsEls.text(petiteTips)
              }
            }

            function updateNewTips(selected_color_swatch) {
              const new_shipping = pr_metafield?.new_shipping
              if (!new_shipping || new_shipping.length == 0) {
                return
              }
              console.log('selected_color_swatch', selected_color_swatch.dataset.value, new_shipping)
              if (new_shipping.includes(selected_color_swatch.dataset.value)) {
                $('.sku_after_info').show()
              } else {
                $('.sku_after_info').hide()
              }
            }

            function updateBodySizeTips(selected_el) {
              const size_name_list = ['size-top', 'size-bottom', 'size', 'größe-oberteile', 'größe-unterteile','size-dress','size-pants','größe-kleid','größe-hosen','größe', 'size-outerwear', 'größe-oberbekleidung']
              if (!size_name_list.includes(selected_el.dataset.option)) {
                return
              }
              const size_value = selected_el.dataset.value.toLowerCase()

              const current_swatch_option = $(selected_el).closest(`div[data-swatch-option][data-option-name=${selected_el.dataset.option}]`)
              console.log(' $(current_swatch_option)', current_swatch_option)
              const swatch_option_tips_target = $(current_swatch_option).find(`#${selected_el.dataset.option}-tips`)
              const swatch_opiton_current_value = $(current_swatch_option).find(`span[data-current-value]`)
              const cur_size_tips = window.sizeDataJson?.[size_value]
              if (!cur_size_tips) {
                return
              }
              const numeric_size = cur_size_tips.us || cur_size_tips.eu || cur_size_tips['uk/aus']
              console.log('swatch_opiton_current_value', swatch_opiton_current_value)
              swatch_opiton_current_value.text(`${selected_el.dataset.value}(${numeric_size})`)
              swatch_option_tips_target?.html(`<div>Bust: <span>${cur_size_tips.bust}</span></div><div>Waist: <span>${cur_size_tips.waist}</span></div><div>Hip: <span>${cur_size_tips.hip}</span></div>`)
              swatch_option_tips_target?.show()
            }

            optionTitleTipsEls.hide()
            function loopAllSelected() {
              const selected_option_el = $('form div[data-swatch-item].is--selected')
              console.log('selected_option_el', selected_option_el)
              console.log('this', this)
              let option_text = ''
              selected_option_el.each(function (index, element) {
                const option_value = index !== selected_option_el.length - 1 ? `${element.dataset.value}, ` : element.dataset.value
                let option_title = `${element.dataset.optionTitle}:`
                if (Object.keys(color_group_map?.[productId] || {}).length && ['color', 'farbe'].includes(element.dataset.optionTitle.toLowerCase())) {
                  option_title = color_group_map?.[productId]?.[option_value] || option_title
                }
                console.log('option_title', option_title, Object.keys(color_group_map).length)

                option_text = option_text.concat(`${option_title}${option_value}`)
                updatePetiteTips(element)
                Array.from(element.classList).includes('is-sw__color') && updateNewTips(element)
                updateBodySizeTips(element)
              })
              updateSelectedOptionText(option_text)
              optionTitleTipsEls.show()
            }
            loopAllSelected.call(this)
          }
          onSelectSwatchItem()
        },
        _getVariantFromOptions: function () {
          var t = this.clickedOptions;
          return (
            this.variants.find(function (e) {
              return t.every(function (t) {
                return e[t.index] === t.value;
              });
            }) || "nathan"
          );
        },
        _getVariantFromSize: function () {
          var e,
            i = this.variants,
            n = this.productOptionSize,
            a = this.removeSoldout,
            o = this.clickedOptions[0].value,
            s = this.clickedOptions[1],
            r = (this.clickedOptions[2], this.clickedCurrentValue),
            l = this.clickedCurrentIndex;
          return (
            1 == n
              ? (e = t.grep(i, function (t, e) {
                return 0 == t.available;
              }))
              : (3 == n) & a
                ? ((s = s.value),
                  (e = t.grep(i, function (t, e) {
                    return t.option1 == o && t.option2 == s && t.available;
                  }))[0] ||
                  (e = t.grep(i, function (t, e) {
                    return t.available && t[l] == r;
                  })))
                : a
                  ? (e = t.grep(i, function (t, e) {
                    return t.option1 == o && t.available;
                  }))[0] ||
                  (e = t.grep(i, function (t, e) {
                    return t.available && t[l] == r;
                  }))
                  : 3 == n
                    ? ((s = s.value),
                      (e = t.grep(i, function (t, e) {
                        return t.option1 == o && t.option2 == s;
                      }))[0] ||
                      (e = t.grep(i, function (t, e) {
                        return t[l] == r;
                      })))
                    : (e = t.grep(i, function (t, e) {
                      return t.option1 == o;
                    }))[0] ||
                    (e = t.grep(i, function (t, e) {
                      return t[l] == r;
                    })),
            e[0]
          );
        },
        _getVariantFromVariantid: function () {
          var t = [],
            e = this.variants,
            i = e.length,
            n = this.originalSelectorId.val();
          for (let a = 0; a < i; a++)
            if (e[a].id == n) {
              t[0] = e[a];
              break;
            }
          return t[0] || null;
        },
        _getVariantFromOptionIndex: function (e, i) {
          var n,
            a = this.variants,
            o = i.option1,
            s = i.option2;
          console.log('getVariantFromOptionIndex', e, o, s, a, i)
          switch (e) {
            case 1:
              n = t.grep(a, function (t, e) {
                return t.option1 == o;
              });
              break;
            case 2:
              n = t.grep(a, function (t, e) {
                return t.option2 == s;
              });
              break;
            case 3:
              n = t.grep(a, function (t, e) {
                return t.option3 == option3;
              });
              break;
            case 1.2:
              n = t.grep(a, function (t, e) {
                return t.option1 == o && t.option2 == s;
              });
              break;
            default:
              n = t.grep(a, function (t, e) {
                return 0 == t.available;
              });
          }
          return n || "nathan";
        },
        _updateMediaFilterNoPick: function () {
          if (this.clickedCurrentValue && this.clickedCurrentIndex) {
            var t = this.clickedCurrentIndex.replace("option", ""),
              e = this.productOptions[parseInt(t) - 1].name || "not4s",
              i = this.clickedCurrentValue || "not4s",
              n = this.$container.find("[data-main-media]"),
              a = n.find(
                `[data-grname="${e.toLowerCase()}"][data-grpvl="${i.toLowerCase()}"]`
              ),
              o = this.$container.find(".t4s-carousel__nav"),
              s = o.find(
                `[data-grname="${e.toLowerCase()}"][data-grpvl="${i.toLowerCase()}"]`
              );
            0 != a.length &&
              (n.find("[data-main-slide]").addClass("is--media-hide"),
                a.removeClass("is--media-hide"),
                o.find(".t4s-carousel__nav-item").addClass("is--media-hide"),
                s.removeClass("is--media-hide"),
                n.hasClass("flickityt4s-enabled")
                  ? (n.trigger("update.flickityt4s"),
                    s.hasClass("is-nav-selected") ||
                    s.first().addClass("is-nav-selected"))
                  : n.hasClass("isotopet4s-enabled") && (v(n), n.isotopet4s()));
          }
        },
        _updateMediaFilter: function (t, e, i) {
          if (this.clickedCurrentValue && this.clickedCurrentIndex) {
            var n = this.clickedCurrentIndex.replace("option", ""),
              a = this.productOptions[parseInt(n) - 1].name || "not4s",
              o = this.clickedCurrentValue || "not4s",
              s = i.find("[data-main-media]"),
              r = `[data-grname="${a.toLowerCase()}"][data-grpvl="${o.toLowerCase()}"]`,
              l = s.find(r),
              d = i.find(".t4s-carousel__nav"),
              c = d.find(r);
            if (0 != l.length)
              if (
                (s.find("[data-main-slide]").addClass("is--media-hide"),
                  l.removeClass("is--media-hide"),
                  d.find(".t4s-carousel__nav-item").addClass("is--media-hide"),
                  c.removeClass("is--media-hide"),
                  s.hasClass("flickityt4s-enabled"))
              ) {
                if ((s.trigger("update.flickityt4s"), t.featured_media))
                  var u = s
                    .find(`[data-media-id="${t.featured_media.id}"`)
                    .index();
                s.flickityt4s("selectCell", u, !1, !1);
              } else
                s.hasClass("isotopet4s-enabled") && (v(s), s.isotopet4s());
          }
        },
        // _updateSwatchSelector: function (
        //   t,
        //   a,
        //   o,
        //   s,
        //   has_empty_value = false
        // ) {
        //   var r,
        //     l,
        //     d = this.$options1,
        //     c = this.$options2,
        //     u = this.$options3,
        //     f = this.productOptionSize,
        //     p = [],
        //     h = 0,
        //     m = t.option1,
        //     v = t.option2,
        //     y = t.option3,
        //     b = [],
        //     S = [],
        //     w = [];
        //   o.find(".is--selected").removeClass("is--selected"),
        //     o.find("[data-current-value]").html(""),
        //     (b = this.productOptions[0].values),
        //     d.find("[data-current-value]").html(m),
        //     d.find(e).eq(b.indexOf(m)).addClass("is--selected"),
        //     c[0] &&
        //     ((S = this.productOptions[1].values),
        //       !has_empty_value && c.find("[data-current-value]").html(v),
        //       !has_empty_value &&
        //       c.find(e).eq(S.indexOf(v)).addClass("is--selected")),
        //     u[0] &&
        //     ((w = this.productOptions[2].values),
        //       !has_empty_value && u.find("[data-current-value]").html(y),
        //       !has_empty_value &&
        //       u.find(e).eq(w.indexOf(y)).addClass("is--selected"));
        //   var T = S.length,
        //     _ = w.length;
        //   if (s)
        //     switch (f) {
        //       case 3:
        //         if (1 == _ && 1 == T)
        //           for (
        //             h = (p = this._getVariantFromOptionIndex(0, t)).length,
        //             l = 0;
        //             l < h;
        //             l++
        //           )
        //             c.find(e).eq(b.indexOf(m)).addClass("is--soldout");
        //         else if (1 == _)
        //           for (
        //             h = (p = this._getVariantFromOptionIndex(1, t)).length,
        //             d.find(e).addClass(n),
        //             c.find(e).addClass(n),
        //             l = 0;
        //             l < h;
        //             l++
        //           )
        //             (r = p[l]).option3 == y &&
        //               (r.available
        //                 ? (c.find(e).eq(S.indexOf(v)).removeClass(n),
        //                   r.option2 == v &&
        //                   d.find(e).eq(b.indexOf(m)).removeClass(n))
        //                 : (c.find(e).eq(S.indexOf(v)).removeClass(i),
        //                   r.option2 == v &&
        //                   d.find(e).eq(b.indexOf(m)).removeClass(i)));
        //         else
        //           for (
        //             h = (p = this._getVariantFromOptionIndex(1, t)).length,
        //             c.find(e).addClass(n),
        //             u.find(e).addClass(n),
        //             l = 0;
        //             l < h;
        //             l++
        //           )
        //             (r = p[l]).option1 == m &&
        //               (r.available
        //                 ? (c.find(e).eq(S.indexOf(r.option2)).removeClass(n),
        //                   r.option2 == v &&
        //                   u.find(e).eq(w.indexOf(r.option3)).removeClass(n))
        //                 : (c.find(e).eq(S.indexOf(r.option2)).removeClass(i),
        //                   r.option2 == v &&
        //                   u
        //                     .find(e)
        //                     .eq(w.indexOf(r.option3))
        //                     .removeClass(i)));
        //         break;
        //       case 2:
        //         if (1 == T)
        //           for (
        //             d.find(e).addClass(n),
        //             h = (p = this._getVariantFromOptionIndex(2, t)).length,
        //             l = 0;
        //             l < h;
        //             l++
        //           )
        //             (r = p[l]).option2 == v &&
        //               d
        //                 .find(e)
        //                 .eq(b.indexOf(r.option1))
        //                 .removeClass(g(r.available));
        //         else
        //           for (
        //             h = (p = this._getVariantFromOptionIndex(1, t)).length,
        //             c.find(e).addClass(n),
        //             l = 0;
        //             l < h;
        //             l++
        //           )
        //             (r = p[l]).option1 == m &&
        //               c
        //                 .find(e)
        //                 .eq(S.indexOf(r.option2))
        //                 .removeClass(g(r.available));
        //         break;
        //       default:
        //         for (
        //           h = (p = this._getVariantFromOptionIndex(0, t)).length,
        //           l = 0;
        //           l < h;
        //           l++
        //         )
        //           (r = p[l]),
        //             d
        //               .find(e)
        //               .eq(b.indexOf(r.option1))
        //               .addClass("is--soldout");
        //         this.removeSoldout &&
        //           d.find(".is--selected").is(":hidden") &&
        //           d.find("[data-swatch-item]:visible:first").trigger("click");
        //     }
        // },
        _updateSwatchSelector: function (
          currentVariant,          // t
          selector,                // a
          swatchContainer,         // o
          enableAvailabilityUpdate,// s
          has_empty_value = false
        ) {
          // 定义常用变量
          var variant, // r
            limit,   // l
            $option1Container = this.$options1, // d
            $option2Container = this.$options2, // c
            $option3Container = this.$options3, // u
            optionCount = this.productOptionSize, // f
            variantsList = [], // p
            variantsCount = 0, // h

            // 获取当前变体的三个选项值
            currentOption1 = currentVariant.option1, // m
            currentOption2 = currentVariant.option2, // v
            currentOption3 = currentVariant.option3, // y

            // 存储各选项的所有值
            option1Values = [], // b
            option2Values = [], // S
            option3Values = []; // w

          // 常量定义 (基于外部作用域推断)
          const SWATCH_SELECTOR = "[data-swatch-item]"; // e
          const CLASS_SOLDOUT_UNAVAILABLE = "is--soldout is--unavailable"; // n
          const CLASS_UNAVAILABLE = "is--unavailable"; // i

          // 辅助函数 g: 根据可用性返回要移除的类名
          // 如果可用，移除“售罄”和“不可用”；如果不可用，仅移除“不可用”(保留售罄样式)
          const getClassToRemove = (available) => available ? CLASS_SOLDOUT_UNAVAILABLE : CLASS_UNAVAILABLE;

          // 1. 重置 UI 状态：移除所有选中样式，清空当前值文本
          swatchContainer.find(".is--selected").removeClass("is--selected");
          swatchContainer.find("[data-current-value]").html("");

          // 2. 更新选项 1 的 UI (选中状态和文本)
          option1Values = this.productOptions[0].values;
          $option1Container.find("[data-current-value]").html(currentOption1);
          // 找到对应值的 swatch 并添加选中样式
          $option1Container.find(SWATCH_SELECTOR).eq(option1Values.indexOf(currentOption1)).addClass("is--selected");

          // 3. 更新选项 2 的 UI (如果存在)
          if ($option2Container[0]) {
            option2Values = this.productOptions[1].values;
            if (!has_empty_value) {
              $option2Container.find("[data-current-value]").html(currentOption2);
              $option2Container.find(SWATCH_SELECTOR).eq(option2Values.indexOf(currentOption2)).addClass("is--selected");
            }
          }

          // 4. 更新选项 3 的 UI (如果存在)
          if ($option3Container[0]) {
            option3Values = this.productOptions[2].values;
            if (!has_empty_value) {
              $option3Container.find("[data-current-value]").html(currentOption3);
              $option3Container.find(SWATCH_SELECTOR).eq(option3Values.indexOf(currentOption3)).addClass("is--selected");
            }
          }

          var option2Length = option2Values.length;
          var option3Length = option3Values.length;

          // 5. 根据库存情况更新 Swatch 的可用性状态 (Soldout / Unavailable)
          // 仅当 enableAvailabilityUpdate (s) 为 true 时执行
          if (enableAvailabilityUpdate) {
            switch (optionCount) {

              // === 情况 A: 产品有 3 个选项 ===
              case 3:
                if (option3Length == 1 && option2Length == 1) {
                  // 特殊情况：选项 2 和 3 都只有一个值
                  // 获取所有不可用的变体 (searchType 0 对应 default case，返回不可用变体)
                  variantsList = this._getVariantFromOptionIndex(0, currentVariant);
                  variantsCount = variantsList.length;

                  // 遍历不可用变体，标记选项 2 容器中的对应项为售罄
                  // 注意：这里原代码逻辑似乎有些奇怪，它在 option2Container 中查找 option1 的索引
                  for (limit = 0; limit < variantsCount; limit++) {
                    // 原代码: c.find(e).eq(b.indexOf(m)).addClass("is--soldout");
                    // 这里的逻辑可能是标记当前选中的组合在某些维度下是售罄的
                    $option2Container.find(SWATCH_SELECTOR).eq(option1Values.indexOf(currentOption1)).addClass("is--soldout");
                  }
                }
                else if (option3Length == 1) {
                  // 特殊情况：仅选项 3 只有一个值
                  // 获取匹配当前 Option 1 的所有变体
                  variantsList = this._getVariantFromOptionIndex(1, currentVariant);
                  variantsCount = variantsList.length;

                  // 先将选项 1 和 2 的所有 Swatch 标记为售罄/不可用
                  $option1Container.find(SWATCH_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  $option2Container.find(SWATCH_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);

                  for (limit = 0; limit < variantsCount; limit++) {
                    variant = variantsList[limit];
                    // 如果变体的 option3 匹配当前选中值
                    if (variant.option3 == currentOption3) {
                      // 根据变体可用性，移除对应的售罄/不可用类
                      if (variant.available) {
                        // 变体可用：移除选项 2 对应项的“售罄+不可用”
                        $option2Container.find(SWATCH_SELECTOR).eq(option2Values.indexOf(currentOption2)).removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        // 如果变体的 option2 也匹配，移除选项 1 对应项的“售罄+不可用”
                        if (variant.option2 == currentOption2) {
                          $option1Container.find(SWATCH_SELECTOR).eq(option1Values.indexOf(currentOption1)).removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        }
                      } else {
                        // 变体不可用（售罄）：仅移除“不可用”（保留“售罄”样式）
                        $option2Container.find(SWATCH_SELECTOR).eq(option2Values.indexOf(currentOption2)).removeClass(CLASS_UNAVAILABLE);
                        if (variant.option2 == currentOption2) {
                          $option1Container.find(SWATCH_SELECTOR).eq(option1Values.indexOf(currentOption1)).removeClass(CLASS_UNAVAILABLE);
                        }
                      }
                    }
                  }
                }
                else {
                  // 标准 3 选项情况
                  // 获取匹配当前 Option 1 的所有变体
                  variantsList = this._getVariantFromOptionIndex(1, currentVariant);
                  variantsCount = variantsList.length;

                  // 先将选项 2 和 3 标记为售罄/不可用
                  $option2Container.find(SWATCH_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  $option3Container.find(SWATCH_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);

                  for (limit = 0; limit < variantsCount; limit++) {
                    variant = variantsList[limit];
                    // 确保变体的 option1 匹配当前选中
                    if (variant.option1 == currentOption1) {
                      // 处理可用性逻辑
                      if (variant.available) {
                        // 变体可用：更新选项 2 的状态
                        $option2Container.find(SWATCH_SELECTOR).eq(option2Values.indexOf(variant.option2)).removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        // 如果 option2 也匹配，更新选项 3 的状态
                        if (variant.option2 == currentOption2) {
                          $option3Container.find(SWATCH_SELECTOR).eq(option3Values.indexOf(variant.option3)).removeClass(CLASS_SOLDOUT_UNAVAILABLE);
                        }
                      } else {
                        // 变体售罄：更新选项 2 的状态（保留售罄样式）
                        $option2Container.find(SWATCH_SELECTOR).eq(option2Values.indexOf(variant.option2)).removeClass(CLASS_UNAVAILABLE);
                        // 如果 option2 也匹配，更新选项 3 的状态
                        if (variant.option2 == currentOption2) {
                          $option3Container.find(SWATCH_SELECTOR).eq(option3Values.indexOf(variant.option3)).removeClass(CLASS_UNAVAILABLE);
                        }
                      }
                    }
                  }
                }
                break;

              // === 情况 B: 产品有 2 个选项 ===
              case 2:
                if (option2Length == 1) { // 也就是 option1Length > 1 且 option2Length == 1
                  // 如果选项 2 只有一个值
                  // 标记选项 1 所有项为售罄/不可用
                  $option1Container.find(SWATCH_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);
                  // 获取匹配当前 Option 2 的所有变体
                  variantsList = this._getVariantFromOptionIndex(2, currentVariant);
                  variantsCount = variantsList.length;

                  for (limit = 0; limit < variantsCount; limit++) {
                    variant = variantsList[limit];
                    // 如果变体的 option2 匹配当前选中
                    if (variant.option2 == currentOption2) {
                      // 更新选项 1 对应项的状态
                      $option1Container
                        .find(SWATCH_SELECTOR)
                        .eq(option1Values.indexOf(variant.option1))
                        .removeClass(getClassToRemove(variant.available));
                    }
                  }
                }
                else {
                  // 标准 2 选项情况
                  // 获取匹配当前 Option 1 的所有变体
                  variantsList = this._getVariantFromOptionIndex(1, currentVariant);
                  variantsCount = variantsList.length;
                  // 标记选项 2 所有项为售罄/不可用
                  $option2Container.find(SWATCH_SELECTOR).addClass(CLASS_SOLDOUT_UNAVAILABLE);

                  for (limit = 0; limit < variantsCount; limit++) {
                    variant = variantsList[limit];
                    // 如果变体的 option1 匹配当前选中
                    if (variant.option1 == currentOption1) {
                      // 更新选项 2 对应项的状态
                      $option2Container
                        .find(SWATCH_SELECTOR)
                        .eq(option2Values.indexOf(variant.option2))
                        .removeClass(getClassToRemove(variant.available));
                    }
                  }
                }
                break;

              // === 情况 C: 默认情况 (通常是 1 个选项) ===
              default:
                // 获取所有不可用的变体 (searchType 0 -> default case)
                variantsList = this._getVariantFromOptionIndex(0, currentVariant);
                variantsCount = variantsList.length;

                for (limit = 0; limit < variantsCount; limit++) {
                  variant = variantsList[limit];
                  // 将不可用变体对应的选项 1 Swatch 标记为售罄
                  $option1Container
                    .find(SWATCH_SELECTOR)
                    .eq(option1Values.indexOf(variant.option1))
                    .addClass("is--soldout");
                }

                // 如果开启了“移除售罄项”功能，且当前选中的项被隐藏（因为它售罄了），则自动点击第一个可见的选项
                if (this.removeSoldout && $option1Container.find(".is--selected").is(":hidden")) {
                  $option1Container.find("[data-swatch-item]:visible:first").trigger("click");
                }
            }
          }
        },
        _updateMetafield: function (e, i, n) {
          e &&
            e.id != i.id &&
            (n.find("[data-variant-toggle]").hide(),
              n.find(`[data-variant-toggle="${e.id}"]`).show(),
              this.isMainProduct &&
              (t("[data-variant-tab][data-variant-toggle]").hide(),
                t(`[data-variant-tab][data-variant-toggle="${e.id}"]`).show()));
        },
        _updateMedia: function (t, e, i) {
          // if (t.featured_media && t.featured_media != e.featured_media && !this.showFirstMedia) {
          if (t.featured_media && t.featured_media != e.featured_media) {
            this.mediaID = t.featured_media.id;
            var n = i.find("[data-main-media]");
            if (n.hasClass("flickityt4s-enabled")) {
              var a = n
                .find('[data-media-id="' + this.mediaID + '"]')
                .index();
              n.flickityt4s("select", a, !1, !0),
                (this.eventClickedSwatch = !1);
            } else {
              var o = n.find('[data-media-id="' + this.mediaID + '"]'),
                s = o[0];
              if (!s || T4SThemeSP.isVisible(o)) return;
              this.header ||
                (this.header = document.querySelector(".t4s-section-header")),
                this.header.dispatchEvent(new Event("preventHeaderReveal")),
                window.setTimeout(() => {
                  (n[0].scrollLeft = 0),
                    s.scrollIntoView({
                      behavior: "smooth",
                      block: "center"
                    });
                });
            }
          } else this.showFirstMedia = !1;
        },
        _updatePrice: function (t, e, i) {
          let n = t.price,
            o = t.compare_at_price;
          if (!t) return void this.$productPrice.hide();

          // 不跳过，因为默认除了选颜色，其它不选，会影响其它折扣显示
          // if (!this.isNoPickOriginal && n === e.price && o === e.compare_at_price && t.unit_price === e.unit_price)
          //     return;

          this.isNoPickOriginal && (this.isNoPickOriginal = !1);
          let s = T4SThemeSP.Currency.formatMoney(n);
          // compare_at_price 大于 price，表示处于打折中，展示打折信息
          if ((this.$productPrice.show(), o > n)) {
            let t = `<del>${T4SThemeSP.Currency.formatMoney(
              o
            )}</del> <ins>${s}</ins>`,
              e = o - n,
              i = (100 * e) / o,
              a = Math.round(i);
            this.isSticky && this.$stickyPrice.html(t),
              this.badgeSelector.$onSale.html(
                this.saleLabel.replace("[sale]", a)
              ),
              "1" == this.saletype
                ? (t += ` <span class="t4s-badge-price">${f.replace(
                  "[sale]",
                  a
                )}</span>`)
                : "2" == this.saletype &&
                (t += ` <span class="t4s-badge-price">${p.replace(
                  "[sale]",
                  T4SThemeSP.Currency.formatMoney(e)
                )}</span>`),
              this.$productPrice.html(t);
          } else
            this.$productPrice.html(s),
              this.isSticky && this.$stickyPrice.html(s);
          this.variantState.showUnitPrice &&
            (this.$unit_price.html(
              T4SThemeSP.Currency.formatMoney(t.unit_price)
            ),
              this.$unit_base.html(T4SThemeSP.Currency.getBaseUnit(t))),
            a.trigger("currency:update");
        },
        _updateQuantity: function (t) {
          if (this.variantState.preOrder)
            this.$quantity.attr("max", 9999),
              this.isSticky && this.$stickyQuantity.attr("max", 9999);
          else if (null != t.inventory_management) {
            let e = t.inventory_quantity;
            this.$quantity.attr("max", e),
              this.isSticky && this.$stickyQuantity.attr("max", e),
              parseInt(this.$quantity.val()) > e &&
              this.$quantity.attr("value", 1).val(1),
              this.isSticky &&
              parseInt(this.$stickyQuantity.val()) > e &&
              this.$stickyQuantity.attr("value", 1).val(1);
          } else
            this.$quantity.attr("max", 9999),
              this.isSticky && this.$stickyQuantity.attr("max", 9999);
        },
        _updateAvailability: function (t, e, i) {
          var n = i.find("[data-product-available]");
          if (n[0]) {
            var a = n.find("[data-available-status]"),
              o = n.find("[data-soldout-status]"),
              s = n.find("[data-instock-status]"),
              r = n.find("[data-preorder-status]");
            t
              ? (n.show(),
                this.variantState.available
                  ? (a.show(),
                    o.hide(),
                    this.variantState.preOrder
                      ? (r.show(), s.hide())
                      : (s.show(), r.hide()))
                  : (o.show(), a.hide()))
              : n.hide();
          }
        },
        _updateBarcode: function (t, e, i) {
          var n = i.find("[data-product-barcode]");
          if (n[0]) {
            var a = n.find("[data-product__barcode-number]");
            if (t && "" !== t.barcode) {
              if (e && e.barcode === t.barcode) return;
              a.text(t.barcode), n.show(0);
            } else n.hide(0);
          }
        },
        _updateSKU: function (t, e, i) {
          var n = i.find("[data-product-sku]");
          if (n[0]) {
            var a = n.find("[data-product__sku-number]");
            if (t && "" !== t.sku) {
              if (false && e && e.sku === t.sku) return;
              a.text(t.sku), n.show(0);
            } else n.hide(0);
          }
        },
        _updateAddToCartButton: function (t, e, i, n, a, o) {
          if (i[0] || a[0])
            if (
              (T4SThemeSP.isEditCartReplace &&
                !i.is("[data-replace-item]") &&
                i.attr("data-replace-item", ""),
                t && "nathan" != t)
            )
              if (t.available) {
                let t = this.variantState.preOrder
                  ? this.txt_preOrder || d
                  : this.txt_addToCart || r;
                n.show(),
                  i.removeAttr("disabled " + h).attr("data-atc-form", ""),
                  o.text(t),
                  a.show(),
                  this.isSticky &&
                  (this.$stickyQuantityWrapper.show(),
                    this.$stickyATC.removeAttr("disabled " + h),
                    this.$stickyATCText.text(t));
              } else
                n.hide(),
                  i
                    .attr("disabled", "disabled")
                    .attr(h, !0)
                    .removeAttr("data-atc-form", ""),
                  o.text(l),
                  a.hide(),
                  this.isSticky &&
                  (this.$stickyQuantityWrapper.hide(),
                    this.$stickyATC.attr("disabled", "disabled").attr(h, !0),
                    this.$stickyATCText.text(l));
            else
              i
                .attr("disabled", "disabled")
                .attr(h, !0)
                .removeAttr("data-atc-form"),
                o.text(s),
                n.hide(),
                a.hide(),
                this.isSticky &&
                (this.$stickyQuantityWrapper.hide(),
                  this.$stickyATC.attr("disabled", "disabled").attr(h, !0),
                  this.$stickyATCText.text(s));
        },
        _updateDelivery: function (t, e, i) {
          var n = i.find("[data-order-delivery]");
          if (n[0])
            if (t && t.available) {
              var a = y(n.attr("data-order-delivery"));
              this.variantState.preOrder && a.hideWithPreorder
                ? n.hide()
                : n.show();
            } else n.hide();
        },
        _updateInventoryQuantity: function (t, e, i) {
          var n = i.find("[data-inventory-qty]");
          n[0] &&
            (t && t.available
              ? n.trigger({
                type: "variant:inventory",
                currentVariant: t,
                oldVariant: this.oldVariant,
              })
              : n.hide());
        },
        _updatePickupAvailabilityContent: function (t, e) {
          let i = t.available
            ? "pickupAvailability:update"
            : "pickupAvailability:clear";
          e.trigger({
            type: i,
            currentVariant: t,
          });
        },
        _updateNotifyBackinStock: function (t, e) {
          let i = this.variantState.available
            ? "notifyBackinStock:hide"
            : "notifyBackinStock:show";
          e.trigger({
            type: i,
            currentVariant: t,
          });
        },
        _updateBadges: function () {
          let t = this.variantState,
            e = this.badgeSelector;
          t.onSale
            ? e.$onSale.removeAttr("hidden")
            : e.$onSale.attr("hidden", !0),
            t.preOrder
              ? e.$preOrder.removeAttr("hidden")
              : e.$preOrder.attr("hidden", !0),
            t.soldOut
              ? e.$soldOut.removeAttr("hidden")
              : e.$soldOut.attr("hidden", !0);
        },
        _setVariantState: function (t) {
          t
            ? (this.variantState = {
              available: t.available,
              soldOut: !t.available,
              onSale: t.compare_at_price > t.price,
              showUnitPrice: !!t.unit_price,
              preOrder:
                "shopify" == t.inventory_management &&
                t.inventory_quantity <= 0 &&
                t.available,
            })
            : (this.variantState.available = !1);
        },
        _updateVariantImageSwatch: function (t) {
          t.featured_image &&
            this.$variantImg
              .find(".is--selected")
              .attr(
                "data-bg",
                T4SThemeSP.Images.getNewImageUrl(
                  t.featured_image.src,
                  this.swatchWidth
                )
              );
        },
        _updateIncomingMess: function (t) {
          if (!this.useComingMess) return;
          let e = t.next_incoming_date,
            i = t.inventory_quantity,
            n = t.incoming,
            a = t.inventory_management;
          t && e && !(i > 0) && n && "shopify" == a
            ? (this.$incomingMess.removeAttr("hidden"),
              this.variantState.available
                ? (this.$incomingAvailableDate.html(e),
                  this.$incomingSoldout.hide(),
                  this.$incomingAvailable.show())
                : (this.$incomingSoldoutDate.html(e),
                  this.$incomingAvailable.hide(),
                  this.$incomingSoldout.show()))
            : this.$incomingMess.attr("hidden", "");
        },
        _updateStickyATC: function (t) {
          t.featured_image
            ? this.$stickyimg.attr(
              "data-src",
              T4SThemeSP.Images.lazyloadImagePath(t.featured_image.src)
            )
            : this.$stickyimg.attr("data-src", this.stickyImgOrginal),
            this.$stickyVtitle.html(t.title),
            this.$stickyATC.attr("data-variant-id", t.id);
        },
        _updateHistoryState: function (t) {
          if (history.replaceState && t) {
            var e =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              t.id;
            window.history.replaceState(
              {
                path: e,
              },
              "",
              e
            ),
              void 0 !== window.addthis && addthis.layers.refresh();
          }
        },
      })),
      m
    );
  })(),
    u = (function () {
      var e = "data-animation-atc",
        i = T4Sconfigs.timezone,
        n = "t4_nt_guess";
      try {
        n = dayjs.tz.guess();
      } catch (t) { }
      var a = "not4" != i && n != i;
      function o(t) {
        (this.$container = t), this.BootSalesInt();
      }
      function s(t) {
        if (0 != t.length) {
          var i = y(t.attr(e)),
            n = i.ani;
          if ("none" != n) {
            var a = "is--animated " + n,
              o = parseInt(i.time);
            setInterval(function () {
              t.addClass(a),
                setTimeout(function () {
                  t.removeClass(a);
                }, 1e3);
            }, o);
          }
        }
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          BootSalesInt: function () {
            this._liveView(),
              this._flashSold(),
              this._animationATC(),
              this._orderDelivery(),
              this._inventoryQuantity(),
              this._countdown();
          },
          _getRandomInt: function (t, e) {
            return Math.floor(Math.random() * (e - t + 1)) + t;
          },
          _animationATC: function () {
            var t = this.$container.find("[" + e + "]");
            return s(t), void t.length;
          },
          _liveView: function () {
            var t = this.$container.find("[data-live-view]");
            if (0 != t.length) {
              var e = y(t.attr("data-live-view")),
                i = this,
                n = e.min,
                a = e.max,
                o = e.interval,
                s = i._getRandomInt(n, a),
                r = [
                  "1",
                  "2",
                  "4",
                  "3",
                  "6",
                  "10",
                  "-1",
                  "-3",
                  "-2",
                  "-4",
                  "-6",
                ],
                l = ["10", "20", "15"],
                d = "",
                c = "",
                u = "",
                f = t.find("[data-count]");
              p(), t.show(), setInterval(p, o);
            }
            function p() {
              if (
                ((d = Math.floor(Math.random() * r.length)),
                  (c = r[d]),
                  (s = parseInt(s) + parseInt(c)),
                  n >= s)
              ) {
                u = Math.floor(Math.random() * l.length);
                var t = l[u];
                s += t;
              }
              (s < n || s > a) && (s = i._getRandomInt(n, a)),
                f.html(parseInt(s));
            }
          },
          _flashSold: function () {
            var t = this.$container.find("[data-flash-sold]");
            if (0 != t.length) {
              var e = y(t.attr("data-flash-sold")),
                i = this,
                n = e.mins,
                a = e.maxs,
                o = e.mint,
                s = e.maxt,
                r = e.id,
                l =
                  sessionStorage.getItem("soldS" + r) || i._getRandomInt(n, a),
                d =
                  sessionStorage.getItem("soldT" + r) || i._getRandomInt(o, s),
                c = parseInt(l),
                u = parseInt(d),
                f = parseInt(e.time),
                p = t.find("[data-sold]"),
                h = t.find("[data-hour]");
              g(),
                m(c, u),
                t.show(),
                setInterval(function () {
                  (c += i._getRandomInt(1, 4)),
                    (u += 1 * (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1)),
                    g(),
                    m(c, u);
                }, f);
            }
            function m(t, e) {
              p.html(t),
                h.html(Math.floor(u)),
                sessionStorage.setItem("soldS" + r, t),
                sessionStorage.setItem("soldT" + r, e);
            }
            function g() {
              c > a && (c = i._getRandomInt(n, a)),
                u > s && (u = i._getRandomInt(o, s));
            }
          },
          _orderDelivery: function () {
            var e = this.$container.find("[data-order-delivery]");
            if (0 != e.length) {
              var n = y(e.attr("data-order-delivery")),
                o = n.format_day,
                s = n.time.replace("24:00:00", "23:59:59") || "19041994",
                r = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
                l = n.estimateStartDate || 0,
                d = n.estimateEndDate || 0,
                c = n.cut_day.replace(/ /g, "").split(","),
                u = dayjs(),
                f = 0,
                p = dayjs(),
                h = 0,
                m = n.timezone,
                g = dayjs(),
                v = g.format("HHmmss"),
                b = s.replace(/ /g, "").replace(/:/g, ""),
                S = T4SProductStrings.order_dayNames
                  .replace(/ /g, "")
                  .split(","),
                w = T4SProductStrings.order_monthNames
                  .replace(/ /g, "")
                  .split(",");
              if (a && m)
                try {
                  v = (g = dayjs.tz(g, i)).format("HHmmss");
                } catch (t) {
                  console.log("Timezone error: " + i);
                }
              if (
                (parseInt(v) >= parseInt(b) &&
                  ((g = g.add(1, "day")),
                    (u = u.add(1, "day")),
                    (p = p.add(1, "day"))),
                  "2" == n.mode)
              ) {
                for (; c.indexOf(r[u.format("d")]) > -1;) u = u.add(1, "day");
                for (; f < l;)
                  f++,
                    (u = u.add(1, "day")),
                    c.indexOf(r[u.format("d")]) > -1 && f--;
                for (; c.indexOf(r[p.format("d")]) > -1;) p = p.add(1, "day");
                for (; h < d;)
                  h++,
                    (p = p.add(1, "day")),
                    c.indexOf(r[p.format("d")]) > -1 && h--;
              } else {
                for (u = u.add(l, "day"); c.indexOf(r[u.format("d")]) > -1;)
                  u = u.add(1, "day");
                for (p = p.add(d, "day"); c.indexOf(r[p.format("d")]) > -1;)
                  p = p.add(1, "day");
              }
              (S = O(S)), (w = O(w));
              var T = parseInt(u.format("D")),
                _ = T + A(T),
                C = w[parseInt(u.format("M")) - 1],
                $ = S[parseInt(u.format("d"))],
                k = parseInt(p.format("D")),
                x = k + A(k),
                I = w[parseInt(p.format("M")) - 1],
                P = S[parseInt(p.format("d"))];
              if (
                (e
                  .find("[data-start-delivery]")
                  .html(
                    u
                      .format(o)
                      .replace("t44", $)
                      .replace("t45", _)
                      .replace("t46", C)
                  ),
                  e
                    .find("[data-end-delivery]")
                    .html(
                      p
                        .format(o)
                        .replace("t44", P)
                        .replace("t45", x)
                        .replace("t46", I)
                    ),
                  "19041994" != s)
              ) {
                var M = e.find("[data-hour-delivery]");
                M.countdown(g.format("YYYY-MM-DD " + s), {
                  elapse: !0,
                }).on("update.countdown", function (i) {
                  if (i.elapsed) e.hide();
                  else {
                    var n = 24 * i.offset.totalDays + i.offset.hours;
                    M.html(
                      i.strftime(t.trim(M.html().replace("[totalHours]", n)))
                    ).show();
                  }
                });
              }
              e.show();
            }
            function O(t) {
              return t.filter(function (t, e, i) {
                return i.indexOf(t) === e;
              });
            }
            function A(t) {
              if (t > 3 && t < 21) return "th";
              switch (t % 10) {
                case 1:
                  return "st";
                case 2:
                  return "nd";
                case 3:
                  return "rd";
                default:
                  return "th";
              }
            }
          },
          _inventoryQuantity: function () {
            var t = this.$container.find("[data-inventory-qty]");
            if (0 != t.length) {
              t.removeAttr("data-ttcalc");
              var e = y(t.attr("data-inventory-qty")),
                i = this,
                n = e.stock,
                a = e.qty,
                o = e.total,
                s = e.min,
                l = e.max,
                d = e.reduce,
                c = e.bgprocess,
                u = e.bgten,
                f = e.id,
                p = e.inventoryQty || 0,
                h = null,
                m = null,
                g = 1,
                v = 1.7,
                b = 0.17,
                S = i._getRandomInt(s, l),
                w = t.find("[data-count]"),
                T = t.find("[data-progressbar]"),
                _ = t.find("[data-message]"),
                C = T.find(">div");
              if (
                (t.on("variant:inventory", function (e) {
                  if ("2" != n) {
                    var o = e.currentVariant,
                      r = o.inventory_quantity || 0;
                    if (((f = o.id), (r >= a || r < 1) && "1" == n)) t.hide();
                    else {
                      (r >= a || 0 == r) &&
                        isStorageSpSession &&
                        ((r =
                          sessionStorage.getItem("probar" + f) ||
                          i._getRandomInt(s, l)),
                          t.attr("data-variant-qty" + f, r)),
                        t.attr("data-variant-qty" + f, r),
                        sessionStorage.setItem("probar" + f, r),
                        w.text(r);
                      var d = (100 * r) / t.attr("data-ttcalc"),
                        p = r < 10 ? u : c;
                      C.css({
                        "background-color": p,
                        width: d + "%",
                      }),
                        _.show(),
                        T.show(),
                        t.show();
                    }
                  } else t.show();
                }),
                  !(p >= a || p < 1) || "1" != n)
              ) {
                if (
                  (p < a && p > 0 && (S = p),
                    isStorageSpSession && !r && "1" != n)
                ) {
                  var $ = sessionStorage.getItem("probar" + f);
                  $ > 0 && (S = $);
                }
                w.text(S).css({
                  "background-color": "#fff",
                  color: c,
                }),
                  k(S, c, u),
                  _.show(),
                  T.show(),
                  (function () {
                    if (!d) return;
                    (h = setTimeout(function () {
                      --S < g &&
                        (S =
                          x(t.attr("data-variant-qty" + f)) ||
                          i._getRandomInt(s, l)),
                        w.css({
                          "background-color": c,
                          color: "#fff",
                        }),
                        setTimeout(function () {
                          w.css({
                            "background-color": "#fff",
                            color: c,
                          });
                        }, 1800),
                        w.text(S),
                        k(S, c, u);
                    }, 6e4 * b)),
                      (m = setInterval(function () {
                        --S < g &&
                          ((S =
                            x(t.attr("data-variant-qty" + f)) ||
                            i._getRandomInt(s, l)),
                            t.on("destroy:inventoryQty").hide()),
                          w.css({
                            "background-color": c,
                            color: "#fff",
                          }),
                          setTimeout(function () {
                            w.css({
                              "background-color": "#fff",
                              color: c,
                            });
                          }, 1800),
                          w.text(S),
                          k(S, c, u);
                      }, 6e4 * v));
                  })(),
                  t.on("destroy:inventoryQty", function () {
                    clearTimeout(h), clearInterval(m);
                  }),
                  t.on("update:inventoryQty", function () {
                    var e = parseInt(w.text()) - 1;
                    if (!(e < 1)) {
                      w.text(e);
                      var i = (100 * e) / t.attr("data-ttcalc"),
                        n = e < 10 ? u : c;
                      C.css({
                        "background-color": n,
                        width: i + "%",
                      });
                    }
                  });
              }
            }
            function k(e, i, n) {
              (e = parseInt(e)),
                isStorageSpSession && sessionStorage.setItem("probar" + f, e),
                (o = t.attr("data-ttcalc") || o > e ? o : e + o),
                t.attr("data-ttcalc", o);
              var a = (100 * e) / o,
                s = e < 10 ? n : i;
              C.css("background-color", s),
                setTimeout(function () {
                  C.css("width", a + "%");
                }, 300),
                C.css("background-color", s);
            }
            function x(t) {
              return t || 0;
            }
          },
          _countdown: function () {
            var t = this.$container.find("[data-countdown-pr]");
            if (0 != t.length) {
              var e,
                n = t.find("[data-cd-options]"),
                o = y(n.attr("data-cd-options"));
              if (!o.isCountdownMeta) {
                e = o.cd_date.replace("24:00:00", "23:59:59").split(",");
                var s,
                  r,
                  l = dayjs(),
                  d = l.format("HHmmss"),
                  c = e.length;
                if (a)
                  try {
                    d = (l = dayjs.tz(l, i)).format("HHmmss");
                  } catch (t) {
                    console.log("Timezone error: " + i);
                  }
                for (s = 0; s < c; s++) {
                  if (parseInt(e[s].replace(/:/g, "")) >= d) {
                    r = e[s];
                    break;
                  }
                  s == c - 1 && (r = e[s]);
                }
                n.attr("data-date", l.format("YYYY-MM-DD") + " " + r);
              }
              n.attr("data-countdown-t4s", ""), T4SThemeSP.Countdown();
            }
          },
        })),
        {
          init: o,
          ani: s,
        }
      );
    })(),
    f = (function () {
      var t = {},
        e = {
          shopify: "shopify",
          external: "external",
        },
        i = {
          productMediaWrapper: "[data-product-single-media-wrapper]",
        },
        n = {
          enableVideoLooping: "enable-video-looping",
          enableVideoMuting: "enable-video-muting",
          enableVideoAutoplaying: "enable-video-autoplaying",
          videoId: "video-id",
        };
      function a(i) {
        i
          ? (function () {
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var n = t[i];
                if (n.nativeVideo) continue;
                n.host === e.shopify &&
                  (n.element.setAttribute("controls", "controls"),
                    (n.nativeVideo = !0));
              }
          })()
          : o();
      }
      function o() {
        for (var e in t) {
          if (t.hasOwnProperty(e)) t[e].ready();
        }
      }
      return {
        init: function (o, s) {
          if (o) {
            var r = o.querySelector("iframe, video");
            if (r) {
              var l = o.getAttribute("data-nt-media-id");
              (t[l] = {
                mediaId: l,
                sectionId: s,
                host: ((d = r), "VIDEO" === d.tagName ? e.shopify : e.external),
                container: o,
                element: r,
                ready: function () {
                  !(function (t) {
                    if (!t.player) {
                      var enableVideoAutoplaying = false;
                      // 添加寻找size guide视屏的逻辑
                      var e = t.container.closest(i.productMediaWrapper) || $('.size_guide_video-popup .size_guide_video')[0],
                        a =
                          "true" ===
                          e.getAttribute("data-" + n.enableVideoLooping),
                        o =
                          "true" ===
                          e.getAttribute("data-" + n.enableVideoMuting);
                      (enableVideoAutoplaying =
                        "true" ===
                        e.getAttribute("data-" + n.enableVideoAutoplaying)),
                        (t.player = new Shopify.Video(t.element, {
                          loop: {
                            active: a,
                          },
                          volume: o ? 0 : 1,
                          muted: o,
                        })),
                        e.classList.add("is-media__initialized");
                      var s = function () {
                        t.player && t.player.pause();
                      };
                      e.addEventListener("mediaHidden", s),
                        e.addEventListener("xrLaunch", s),
                        e.addEventListener("mediaVisible", function () {
                          !T4SThemeSP.isTouch &&
                            enableVideoAutoplaying &&
                            t.player &&
                            t.player.play();
                        });
                    }
                  })(this);
                },
              }),
                window.Shopify.loadFeatures([
                  {
                    name: "video-ui",
                    version: "2.0",
                    onLoad: a,
                  },
                ]),
                T4SThemeSP.LibraryLoader.load("plyrShopifyStyles");
            }
          }
          var d;
        },
        hosts: e,
        loadVideos: o,
        removeSectionVideos: function (e) {
          for (var i in t)
            if (t.hasOwnProperty(i)) {
              var n = t[i];
              n.sectionId === e &&
                (n.player && n.player.destroy(), delete t[i]);
            }
        },
      };
    })(),
    p = (function () {
      var t = {},
        e = {},
        i = {},
        n = {
          mediaGroup: "[data-product-single-media-group]",
          xrButton: "[data-shopify-xr]",
        };
      function a(e) {
        if (!e)
          if (window.ShopifyXR) {
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var n = t[i];
                if (n.loaded) continue;
                var o = document.querySelector("#ModelJson-" + i);
                window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
                  (n.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          } else
            document.addEventListener("shopify_xr_initialized", function () {
              a();
            });
      }
      function o(t) {
        if (!t)
          for (var i in e)
            if (e.hasOwnProperty(i)) {
              var n = e[i];
              n.modelViewerUi ||
                (n.modelViewerUi = new Shopify.ModelViewerUI(n.element)),
                s(n);
            }
      }
      function s(t) {
        var e = i[t.sectionId];
        t.container.classList.add("is-media__initialized"),
          t.container.addEventListener("mediaVisible", function () {
            e.element &&
              e.element.setAttribute("data-shopify-model3d-id", t.modelId),
              T4SThemeSP.isTouch || t.modelViewerUi.play();
          }),
          t.container.addEventListener("mediaHidden", function () {
            e.element &&
              e.element.setAttribute("data-shopify-model3d-id", e.defaultId),
              t.modelViewerUi.pause();
          }),
          t.container.addEventListener("xrLaunch", function () {
            t.modelViewerUi.pause();
          });
      }
      return {
        init: function (s, r) {
          (t[r] = {
            loaded: !1,
          }),
            s.forEach(function (t, a) {
              var o = t.getAttribute("data-nt-media-id"),
                s = t.querySelector("model-viewer"),
                l = s.getAttribute("data-model-id");
              if (0 === a) {
                var d = t.closest(n.mediaGroup).querySelector(n.xrButton);
                i[r] = {
                  element: d,
                  defaultId: l,
                };
              }
              e[o] = {
                modelId: l,
                sectionId: r,
                container: t,
                element: s,
              };
            }),
            window.Shopify.loadFeatures([
              {
                name: "shopify-xr",
                version: "1.0",
                onLoad: a,
              },
              {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: o,
              },
            ]),
            T4SThemeSP.LibraryLoader.load("modelViewerUiStyles");
        },
        removeSectionModels: function (i) {
          for (var n in e)
            e.hasOwnProperty(n) &&
              e[n].sectionId === i &&
              (e[n].modelViewerUi.destroy(), delete e[n]);
          delete t[i];
        },
      };
    })(),
    h = (function () {
      var e = !1;
      function i(e, i) {
        e = e[0];
        let n = JSON.parse(document.querySelector("#Json360-" + i).innerHTML),
          a = n.imgArray,
          o = parseFloat(e.getAttribute("data-min")) || 1.194,
          s = parseFloat(e.getAttribute("data-max")) || 2,
          r = window.devicePixelRatio < o ? o : window.devicePixelRatio,
          l = r > s ? s : r,
          d = Math.round(e.clientWidth * l);
        n.imgArray = [];
        for (let t in a) n.imgArray.push(`${a[t]}&width=${d}`);
        n.onReady = function () {
          !(function (e, i) {
            i.classList.add("is-media__initialized"),
              i.addEventListener("mediaVisible", function () {
                if (!T4SThemeSP.isTouch)
                  try {
                    e.play(),
                      t(i.querySelector(".nav_bar_play"))
                        .removeClass("nav_bar_play")
                        .addClass("nav_bar_stop");
                  } catch (t) { }
              }),
              t(i).hasClass("is-selected") &&
              (e.play(),
                setTimeout(function () {
                  t(i.querySelector(".nav_bar_play"))
                    .removeClass("nav_bar_play")
                    .addClass("nav_bar_stop");
                }, 50));
            i.addEventListener("mediaHidden", function () {
              e.stop(),
                t(i.querySelector(".nav_bar_stop"))
                  .removeClass("nav_bar_stop")
                  .addClass("nav_bar_play");
            });
          })(c, e);
        };
        var c = t(e.querySelector(".t4s-threesixty")).ThreeSixty(n);
      }
      return {
        init: function (t, n) {
          e
            ? i(t, n)
            : $script(T4Sconfigs.script12b, function () {
              i(t, n), (e = !0);
            });
        },
      };
    })(),
    m = (function () {
      var e = "[data-pickup-availability-popup-open]",
        i = "[data-pickup-availability-popup-close]",
        n = l.mfp_close,
        o = l.mfp_loading,
        s = {};
      function r(t, e) {
        (this.container = e),
          (this.idPopup = this.container.dataset.idPopup),
          (this.hasOnlyDefaultVariant =
            "true" === this.container.dataset.hasOnlyDefaultVariant),
          (this.baseUrl = this.container.dataset.baseUrl),
          (this.variantId = this.container.dataset.variantId);
        var i = this;
        t.on("pickupAvailability:update", function (t) {
          i.updateContent(t.currentVariant.id);
        }),
          t.on("pickupAvailability:clear", function (t) {
            i.clearContent();
          });
      }
      return (
        (r.prototype = Object.assign({}, r.prototype, {
          updateContent: function (t = this.variantId) {
            var i =
              this.baseUrl +
              "/variants/" +
              t +
              "/?section_id=pickup-availability",
              n = this,
              a = "pickup-availability" + t,
              o = n.container.querySelector(e);
            (n.container.style.opacity = 0.5),
              o && ((o.disabled = !0), o.setAttribute("aria-busy", !0)),
              s[a]
                ? n.updateResponse(s[a])
                : T4SThemeSP.getToFetchSection(null, "text", i).then((t) => {
                  "NVT_94" != t && ((s[a] = t), n.updateResponse(t));
                });
          },
          updateResponse: function (t) {
            if ("" !== t.trim()) {
              (this.container.innerHTML = t),
                (this.container.innerHTML =
                  this.container.firstElementChild.innerHTML),
                (this.container.style.opacity = 1);
              var i = this.container.querySelector(e);
              i &&
                ((this.container.querySelector("#pickupAvailabilityPopup").id =
                  this.idPopup),
                  i.addEventListener("click", this._onClickModalOpen.bind(this)));
            }
          },
          clearContent: function () {
            this.container.innerHTML = "";
          },
          _onClickModalOpen: function () {
            var e = this;
            t.magnificPopupT4s.open({
              items: {
                src: `#${e.idPopup}`,
              },
              type: "inline",
              removalDelay: 500,
              tClose: n,
              tLoading: o,
              callbacks: {
                beforeOpen: function () {
                  this.st.mainClass =
                    "mfp-move-horizontal t4s-pickup-availability_pp_wrapper";
                },
                open: function () {
                  a.trigger("NTpopupInline:offClose"),
                    a.trigger("currency:update");
                  var t = document.querySelector(`#${e.idPopup} ${i}`);
                  t &&
                    (t.removeEventListener("click", e._onClickModalClose),
                      t.addEventListener("click", e._onClickModalClose));
                },
                beforeClose: function () { },
                close: function () { },
                afterClose: function () {
                  a.trigger("NTpopupInline:onClose");
                },
              },
            });
          },
          _onClickModalClose: function () {
            t.magnificPopupT4s.close();
          },
        })),
        r
      );
    })(),
    g = (function () {
      var n,
        o,
        s = {
          isShow: "is--shown",
          isActive: "sticky-is--active",
          isHiddenMb: "is-hidden--mobile",
        },
        r = e.height(),
        l = i.height();
      function d(i, r) {
        if (i[0]) {
          var l,
            d = this,
            c = "2" == r;
          (o = i.offset().top + i.outerHeight()),
            d._updateContent(),
            u.ani(n.find("[data-action-atc]")),
            d._stickyAddToCartToggle(),
            c || (n.addClass(s.isShow), a.addClass(s.isActive)),
            e.scroll(function () {
              l && clearTimeout(l),
                (l = setTimeout(function () {
                  d._stickyAddToCartToggle(c);
                }, 30));
            }),
            n.find("[data-sticky-v-title]").on("click", function (e) {
              e.preventDefault(),
                t("html, body").animate(
                  {
                    scrollTop: i.offset().top - 100,
                  },
                  500
                );
            });
        }
      }
      return (
        (d.prototype = Object.assign({}, d.prototype, {
          _updateContent: function () {
            T4SThemeSP.$appendComponent.after(t("#t4s-sticky-atc-temp").html()),
              (n = t("[data-sticky-addtocart]"));
          },
          _stickyAddToCartToggle: function (t) {
            var d = e.scrollTop(),
              c = parseInt(d + r) + 60;
            (l = i.height()),
              o < d && c !== l && c < l
                ? (n.addClass(s.isShow), a.addClass(s.isActive))
                : (c === l || c > l || (o > d && t)) &&
                (n.removeClass(s.isShow), a.removeClass(s.isActive));
          },
        })),
        d
      );
    })();
  function v(e) {
    var i = e.find(".t4s-product__media-item:not(.is--media-hide)"),
      n = i.length;
    (4 == n || n > 5) && (n = "normal"),
      e.attr("data-media-sizes", n),
      e
        .find(".t4s-product__media-item:not(.is--media-hide):last")
        .addClass("is--media-last"),
      e.find(".t4s-product__media-item").attr("data-index", ""),
      i.each(function (e) {
        t(this).attr("data-index", e);
      });
  }
  function y(t) {
    return JSON.parse(t || "{}");
  }
  (T4SThemeSP.Product = (function () {
    var o = "data-product-featured",
      l = {},
      d = {},
      b = !n.hasClass("is-remove-unavai-0"),
      S = "is-pswp-disable",
      w = ".t4s-color-mode__variant_image .is--first-color",
      T = "[data-main-media]",
      _ = "[data-pickup-availability-container]",
      C = T4Sconfigs,
      $ = T4SProductStrings,
      k = C.nowTimestamp,
      x = C.new_day_int,
      I = C.use_sale_badge,
      P = C.label_sale_style,
      M = C.use_preorder_badge,
      O = C.use_new_badge,
      A = C.use_soldout_badge,
      E = C.use_custom_badge,
      L = {
        sale: $.badgeSale,
        new: $.badgeNew,
        preOrder: $.badgepreOrder,
        soldout: $.badgeSoldout,
        SavePercent: $.badgeSavePercent,
      },
      V = {
        texts: L,
        saleStyle: P,
      },
      j = !1;
    function D(e) {
      if (
        ((this.$container = t(e)),
          (this.productConfigs = y(this.$container.attr(o))),
          (this.productID = this.productConfigs.id),
          (this.container = e),
          (this.$mainMedia = this.$container.find(T)),
          (this.mainMedia = this.$mainMedia[0]),
          (this.sectionId = this.productConfigs.sectionId),
          (this.disableSwatch = this.productConfigs.disableSwatch),
          (this.isSticky = this.productConfigs.isSticky),
          (this.isStickyMB = this.productConfigs.isStickyMB),
          (this.stickyShow = this.productConfigs.stickyShow),
          (this.$addThis = this.$container.find("[data-t4s-addthis]")),
          (this.eventHandlers = {}),
          this._createBadgesProduct(),
          this._initBootSales(),
          this._initSubmit(),
          this.productConfigs.id)
      ) {
        (this.$variantImg = this.$container.find(w)),
          (this.disableVariantImage = !this.$variantImg[0]),
          (this.$formSelectorId = this.$container.find(
            this.productConfigs.formID
          )),
          (this.$formSelectorIdLength = this.$formSelectorId.length),
          (this.pickupAvailabilityContainer = this.$container.find(_)[0]),
          this.pickupAvailabilityContainer &&
          this.$formSelectorIdLength > 0 &&
          (this._initPickupAvailability(),
            this.disableSwatch && this.pickupAvailability.updateContent()),
          this._initNotifyBackinStock(),
          s && !this.isStickyMB && (this.isSticky = !1),
          this.isSticky && this._initStickyAddToCart(),
          !this.disableSwatch &&
          this.$formSelectorIdLength > 0 &&
          ((this.$originalSelectorId =
            this.$formSelectorId.find('select[name="id"]')),
            (this.$options1 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="0"]'
            )),
            (this.$options2 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="1"]'
            )),
            (this.$options3 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="2"]'
            )),
            this.PrOptionsSize,
            this.disableVariantImage ||
            ((this.$variantImgItems =
              this.$variantImg.find("[data-swatch-item]")),
              (this.swatchWidth = 2 * this.$variantImgItems.outerWidth())),
            this._initVariants(),
            this._swatchesEventListeners(),
            this._changeMediaSlider(),
            this.disableVariantImage || this._updateVariantImageSwatchFirst());
        var i = this;
        if (
          (i.mainMedia && i._initProductIsotope(),
            setTimeout(function () {
              i.mainMedia &&
                (i._initLoadContent(),
                  setTimeout(function () {
                    i._initProductVideo(),
                      i._initModelViewerLibraries(),
                      i._initShopifyXrLaunch(),
                      i._init360ViewerLibraries();
                    var t = i.container.querySelector(
                      ".t4s-product__info-container--sticky"
                    );
                    t &&
                      i.productConfigs.infoOverflowScroller &&
                      (i.infoOverflowScroller = new T4SThemeSP.OverflowScroller(t, {
                        offsetTop: 109,
                        offsetBottom: 30,
                        updateOffsetTop: !0,
                      }));
                  }, 100));
            }, 1e3),
            i.$addThis[0])
        )
          if (i.$addThis.is("[data-qv-addthis]")) {
            if ((r && (j = !1), void 0 !== window.addthis_new_tool))
              return window.addthis_new_tool(), void addthis.layers.refresh();
            j
              ? z()
              : $script(
                "https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-56efaa05a768bd19",
                function () {
                  (j = !0), z();
                }
              );
          } else
            j ||
              $script(
                "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-56efaa05a768bd19",
                function () {
                  j = !0;
                }
              );
        var n = i.productConfigs.main_click;
        "none" != n &&
          i.mainMedia &&
          ((T4SThemeSP.isTouch && i.productConfigs.enable_zoom_click_mb) ||
            (T4SThemeSP.isHover && "pswp" == n)) &&
          this.$mainMedia.find("." + S).removeClass(S);
      }
    }
    function z() {
      $script("https://s7.addthis.com/downloads/ajax_help.min.js", function () {
        const t = setInterval(function () {
          void 0 !== window.addthis_new_tool &&
            (clearInterval(t),
              window.addthis_new_tool(),
              addthis.layers.refresh());
        }, 100);
      });
    }
    return (
      (D.prototype = Object.assign({}, D.prototype, {
        _initVariants: function () {
          var e,
            i,
            n,
            a = this.productConfigs;
          if (l[this.productID] || a.isGrouped)
            a.isGrouped ||
              ((n = l[this.productID]),
                (i = d[this.productID]),
                (this.PrOptionsSize = i.length));
          else
            try {
              (n = JSON.parse(
                this.$container.find(".pr_variants_json").html()
              )),
                this.$originalSelectorId.find("> option").each(function (i) {
                  (e = t(this)),
                    (n[i].incoming = e.data("incoming")),
                    (n[i].next_incoming_date =
                      e.data("nextincomingdate") || null),
                    (n[i].inventory_quantity = e.data("inventoryquantity"));
                }),
                (l[this.productID] = n),
                (i = JSON.parse(
                  this.$container.find(".pr_options_json").html()
                )),
                (d[this.productID] = i),
                (this.PrOptionsSize = i.length);
            } catch (t) {
              return void console.log("not found pr json");
            }
          console.log('variantsinit', i)
          const colorOptionName = document.querySelector(
            `[data-productid='${this.productID}'] .is-t4s-style__color`
          )?.dataset['optionName']
          if (colorOptionName) {
            for (const item of i) {
              if (item.name.toLowerCase() == colorOptionName.toLowerCase()) {
                // 颜色选项按最终页面调整过的序列来排序
                const elements = document.querySelectorAll(
                  `[data-productid='${this.productID}'] .is-t4s-style__color [data-swatch-item]`
                );
                // 将 NodeList 转换为数组并提取 data-value 属性
                item["values"] = [...elements].map((element) =>
                  element.getAttribute("data-value")
                );
              }
            }
            console.log(i);
          }
          var o = {
            enableHistoryState: a.enableHistoryState || !1,
            $container: this.$container,
            formSelectorId: this.$formSelectorId,
            originalSelectorId: this.$originalSelectorId,
            $options1: this.$options1,
            $options2: this.$options2,
            $options3: this.$options3,
            variants: n,
            productOptions: i,
            PrOptionsSize: this.PrOptionsSize,
            removeSoldout: a.removeSoldout,
            isNoPick: a.isNoPick,
            hasSoldoutUnavailable: a.hasSoldoutUnavailable,
            canMediaGroup: a.canMediaGroup,
            isMainProduct: a.isMainProduct,
            oldVariant: {},
            badgesConfigs: V,
            $variantImg: this.$variantImg,
            disableVariantImage: this.disableVariantImage,
            swatchWidth: this.swatchWidth,
            isSticky: this.isSticky,
            showFirstMedia: a.showFirstMedia,
          };
          this.Variants = new c(o);
          console.log(this.Variants)
        },
        _swatchesEventListeners: function () {
          console.log('_swatchesEventListeners', this.PrOptionsSize)
          if (this.PrOptionsSize) {
            var e,
              i,
              n,
              o = !0,
              s = this.$formSelectorId.hasClass("is-form-t4spritem"),
              r = this;
            r.$formSelectorId.on(
              "click",
              "[data-swatch-item]:not(.is--selected)",
              function (l) {
                console.log('swatch_click', l)
                l.preventDefault();
                var d = t(this);

                d
                  .addClass("is--selected")
                  .siblings()
                  .removeClass("is--selected"),
                  d
                    .closest("[data-swatch-option]")
                    .find("[data-current-value]")
                    .html(d.data("value")),
                  s &&
                  o &&
                  (r.$formSelectorId.addClass("t4sproduct-swatched"),
                    r.$formSelectorId
                      .find(
                        '[data-swatch-option][data-id="0"] [data-swatch-name],[data-swatch-option][data-id="1"],[data-swatch-option][data-id="2"]'
                      )
                      .show(150),
                    (o = !1)),
                  (r.Variants.clickedCurrentValue = d.data("value") + ""),
                  (n = d.closest("[data-swatch-option]").data("id")),
                  (r.Variants.clickedCurrentIndex = "option" + ++n),
                  (r.Variants.isNoPick = !1),
                  r.$formSelectorId.find(".is--selected").length <
                    r.PrOptionsSize && r.Variants.isNoPick
                    ? r.Variants.updateMediaFilterNoPick()
                    : (r.Variants.isNoPick &&
                      (a.trigger("hide.t4s.notices"),
                        r.isSticky &&
                        t("[data-sticky-addtocart]").removeAttr("hidden"),
                        (r.Variants.isNoPick = !1)),
                      (r.Variants.eventClickedSwatch = !0),
                      (r.Variants.oldVariant = r.Variants.currentVariant),
                      (r.Variants.clickedOptions = []),
                      r.$formSelectorId
                        .find("[data-swatch-option] .is--selected")
                        .each(function (e, i) {
                          r.Variants.clickedOptions.push({
                            value: t(i).data("value") + "",
                            index: "option" + ++e,
                          });
                        }),
                      (r.Variants.oldVariant = r.Variants.currentVariant),
                      (i = r.Variants._getVariantFromOptions()),
                      r.$originalSelectorId.val(i.id),
                      (e = r.$originalSelectorId.val()),
                      !b ||
                      (null !== e && "" !== e) ||
                      ((i = r.Variants._getVariantFromSize()),
                        r.$originalSelectorId.val(i.id),
                        (e = r.$originalSelectorId.val())),
                      (r.Variants.currentVariant = i),
                      r.$originalSelectorId[0].dispatchEvent(
                        new Event("change", {
                          bubbles: !0,
                          cancelable: !0,
                        })
                      ));
                console.log('theme_swatch_change', d)
                function onColorSwatchChange($target, $form) {
                  if ($target.hasClass("is-sw__color")) {
                    const color = $target.text();
                    const titleEl = $target.prevAll("h4").first();
                    $form.find(".mibao-swatch__current").text("");
                    titleEl.find(".mibao-swatch__current").text(color);
                  }
                }
                onColorSwatchChange(d, t(l.delegateTarget))
              }
            );
          }
        },
        _changeMediaSlider: function () {
          if (
            this.PrOptionsSize &&
            this.productConfigs.changeVariantByImg &&
            0 !=
            this.$container.find(
              ".flickityt4s[data-main-media] .t4s-product__media-item--variant"
            ).length
          ) {
            var e,
              i,
              n,
              a,
              o = this;
            this.$container
              .find(".flickityt4s[data-main-media]")
              .off("select.flickityt4s")
              .on("select.flickityt4s", function (s, r) {
                (a = t(this)
                  .find(".flickityt4s-slider>[data-main-slide]")
                  .eq(r)).hasClass("t4s-product__media-item--variant") &&
                  !o.Variants.eventClickedSwatch &&
                  ((e = a.data("media-id")),
                    (n = o.$originalSelectorId.val()),
                    void 0 ===
                    (i = o.$originalSelectorId
                      .find('option[data-mdid="' + e + '"]')
                      .val()) ||
                    n == i ||
                    o.Variants.isNoPick ||
                    o.Variants.mediaID == e ||
                    (o.$originalSelectorId.val(i),
                      o.$originalSelectorId[0].dispatchEvent(
                        new Event("change", {
                          bubbles: !0,
                          cancelable: !0,
                        })
                      )));
              });
          }
        },
        _initBootSales: function () {
          this.BootSales = new u.init(this.$container);
        },
        _initSubmit: function () {
          i.trigger({
            type: "submitAtc:t4s",
            $container: this.$container,
          });
        },
        _initProductVideo: function () {
          var t = this.sectionId,
            e = this.mainMedia.querySelectorAll(
              '[data-media-type="video"], [data-media-type="external_video"]'
            );
          e.length < 1 ||
            e.forEach(function (e) {
              f.init(e, t);
            });
          function initSizeGuideVideo() {
            try {
              // 仅产品页初始化
              if (meta.page.type !== 'product') return;
              const product_type = this.productConfigs.type
              const video_map = window.size_guide_video_map[product_type]
              if (!video_map?.video) {
                return
              }
              const size_guide_video_wrapper = document.querySelector('.size_guide_video')
              const size_guide_video = document.querySelector('.size_guide_video video')
              size_guide_video.src = video_map?.video
              f.init(size_guide_video_wrapper, t)
              // new Shopify.Video($('.size_guide_video video')[0], { loop: { active: true }, volume: true, muted: false })
            } catch (error) {
              console.error('===>>> size_guide_video error:', error);
            }
          }
          initSizeGuideVideo.call(this)
        },
        _init360ViewerLibraries: function () {
          var t = this.mainMedia.querySelectorAll('[data-media-type="360"]');
          t.length < 1 || h.init(t, this.sectionId);
        },
        _initModelViewerLibraries: function () {
          var t = this.mainMedia.querySelectorAll('[data-media-type="model"]');
          t.length < 1 || p.init(t, this.sectionId);
        },
        _initShopifyXrLaunch: function () {
          (this.eventHandlers.initShopifyXrLaunchHandler =
            this._initShopifyXrLaunchHandler.bind(this)),
            document.addEventListener(
              "shopify_xr_launch",
              this.eventHandlers.initShopifyXrLaunchHandler
            );
        },
        _initShopifyXrLaunchHandler: function () {
          this.mainMedia
            .querySelector("[data-product-single-media-wrapper]")
            .dispatchEvent(
              new CustomEvent("xrLaunch", {
                bubbles: !0,
                cancelable: !0,
              })
            );
        },
        loadContent: function (t) {
          if (t.getAttribute("loaded")) return;
          const e = document.createElement("div"),
            i = t.querySelector("template");
          e.appendChild(i.content.firstElementChild.cloneNode(!0)),
            t.setAttribute("loaded", !0);
          t.appendChild(e.querySelector("video, model-viewer, iframe"));
          i.remove();
        },
        _initLoadContent: function () {
          var t = this;
          t.mainMedia
            .querySelectorAll("[data-deferred-media]")
            .forEach(function (e) {
              e.classList.add("is--adding"),
                t.loadContent(e.querySelector(".t4s-pr"));
            });
        },
        _initProductIsotope: function () {
          var t = this;
          !s &&
            t.productConfigs.hasIsotope &&
            (v(this.$mainMedia),
              T4SThemeSP.Isotopet4s.init(this.$mainMedia),
              e.on("resize.prIstope", function () {
                e.width() < 768 && t.$mainMedia.hasClass("isotopet4s-enabled")
                  ? t.$mainMedia
                    .isotopet4s("destroy")
                    .removeClass("isotopet4s-enabled")
                  : e.width() >= 768 &&
                  !t.$mainMedia.hasClass("isotopet4s-enabled") &&
                  setTimeout(function () {
                    T4SThemeSP.Isotopet4s.init(t.$mainMedia);
                  }, 500);
              }));
        },
        _initPickupAvailability: function () {
          this.pickupAvailability = new m(
            this.$container,
            this.pickupAvailabilityContainer
          );
        },
        _initNotifyBackinStock: function () {
          var t = this.$container.find("[data-notify-stock-btn]");
          if (t[0]) {
            var e = t.data("base-url"),
              i = `${e}/variants/${t.data(
                "variant-id"
              )}/?section_id=back-in-stock`;
            t.attr("data-mfp-src", i).hide().removeClass("t4s-d-none"),
              this.productConfigs.available ||
                !this.productConfigs.disableSwatch
                ? (this.$container.on("notifyBackinStock:show", function (n) {
                  (i = `${e}/variants/${n.currentVariant.id}/?section_id=back-in-stock`),
                    t
                      .attr({
                        "data-mfp-src": i,
                        "data-storageid": `notify-stock${n.currentVariant.id}`,
                      })
                      .show();
                }),
                  this.$container.on("notifyBackinStock:hide", function (e) {
                    t.hide();
                  }))
                : t.show();
          }
        },
        _createBadgesProduct: function () {
          let t = this.$container.find("[data-product-single-badge]"),
            e = (t.attr("data-sort") || "").replace(/ /g, "").split(","),
            i = this.productConfigs,
            n = "";
          if (0 == e.length || 0 == t.length) return;
          let a = e.length;
          for (let t = 0; t < a; t++)
            switch (e[t]) {
              case "sale":
                if (!I) break;
                let a = i.compare_at_price,
                  c = i.price;
                if (a <= c) {
                  n +=
                    '<span data-badge-sale class="t4s-badge-item t4s-badge-sale" hidden></span>';
                  break;
                }
                if ("2" == P)
                  var o = (100 * (a - c)) / a,
                    s = L.SavePercent.replace("[sale]", Math.round(o));
                else if ("3" == P) {
                  var r = a - c;
                  s = T4SThemeSP.Currency.formatMoney(r);
                } else s = L[e[t]];
                n +=
                  '<span data-badge-sale class="t4s-badge-item t4s-badge-sale">' +
                  s +
                  "</span>";
                break;
              case "preOrder":
                if (!M) break;
                n += `<span data-badge-preorder class="t4s-badge-item t4s-badge-preorder"${i.isPreoder ? "" : " hidden"
                  }>${L[e[t]]}</span>`;
                break;
              case "new":
                var l = k - i.dateStart,
                  d = Math.floor(l / 3600);
                if ((d = Math.floor(d / 24)) >= x || !O) break;
                n +=
                  '<span class="t4s-badge-item t4s-badge-new">' +
                  L[e[t]] +
                  "</span>";
                break;
              case "soldout":
                if (!A) break;
                n += `<span data-badge-soldout class="t4s-badge-item t4s-badge-soldout"${i.available ? " hidden" : ""
                  }>${L[e[t]]}</span>`;
                break;
              default:
                let u = i.customBadge;
                if (!u || !E) break;
                let f = u.length;
                for (let t = 0; t < f; t++)
                  n +=
                    '<span class="t4s-badge-item t4s-badge-custom t4s-badge-' +
                    i.customBadgeHandle[t] +
                    '">' +
                    u[t] +
                    "</span>";
            }
          t.html(n);
        },
        _updateVariantImageSwatchFirst: function () {
          let e = this,
            i = e.Variants.variants,
            n = i.length;
          this.$variantImgItems.each(function (a) {
            let o = t(this),
              s = (function (t) {
                for (let e = 0; e < n; e++) {
                  let n = i[e];
                  if (
                    n.featured_image &&
                    n.options.join(" / ").toLowerCase().indexOf(t) > -1
                  )
                    return n.featured_image;
                }
              })(o.data("value").toLowerCase());
            s &&
              o.attr(
                "data-bg",
                T4SThemeSP.Images.getNewImageUrl(s.src, e.swatchWidth)
              );
          });
        },
        _initStickyAddToCart: function () {
          this.stickyAddToCart = new g(this.$formSelectorId, this.stickyShow);
        },
      })),
      D
    );
  })()),
    (T4SThemeSP._initProducts = (function () {
      var e = "data-product-featured",
        i = "initProducts__enabled";
      return function () {
        t("[" + e + "]:not(." + i + ")").each(function () {
          t(this).addClass(i), new T4SThemeSP.Product(this);
        });
      };
    })()),
    (T4SThemeSP.Cookies = (function () {
      return function () {
        var t;
        (t = navigator.cookieEnabled) ||
          ((document.cookie = "testcookie"),
            (t = -1 !== document.cookie.indexOf("testcookie"))),
          t || n.addClass("not--cookies");
      };
    })()),
    (T4SThemeSP.isVisible = function (i, n, a, o, s) {
      if (!(i.length < 1)) {
        o = o || "both";
        var r = e,
          l = i.length > 1 ? i.eq(0) : i,
          d = null != s,
          c = d ? t(s) : r,
          u = d ? c.position() : 0,
          f = l.get(0),
          p = c.outerWidth(),
          h = c.outerHeight(),
          m = !0 !== a || f.offsetWidth * f.offsetHeight;
        if ("function" == typeof f.getBoundingClientRect) {
          var g = f.getBoundingClientRect(),
            v = d
              ? g.top - u.top >= 0 && g.top < h + u.top
              : g.top >= 0 && g.top < h,
            y = d
              ? g.bottom - u.top > 0 && g.bottom <= h + u.top
              : g.bottom > 0 && g.bottom <= h,
            b = d
              ? g.left - u.left >= 0 && g.left < p + u.left
              : g.left >= 0 && g.left < p,
            S = d
              ? g.right - u.left > 0 && g.right < p + u.left
              : g.right > 0 && g.right <= p,
            w = n ? v || y : v && y,
            T = n ? b || S : b && S;
          (w = (g.top < 0 && g.bottom > h) || w),
            (T = (g.left < 0 && g.right > p) || T);
          if ("both" === o) return m && w && T;
          if ("vertical" === o) return m && w;
          if ("horizontal" === o) return m && T;
        } else {
          var _ = d ? 0 : u,
            C = _ + h,
            $ = c.scrollLeft(),
            k = $ + p,
            x = l.position(),
            I = x.top,
            P = I + l.height(),
            M = x.left,
            O = M + l.width(),
            A = !0 === n ? P : I,
            E = !0 === n ? I : P,
            L = !0 === n ? O : M,
            V = !0 === n ? M : O;
          if ("both" === o) return !!m && E <= C && A >= _ && V <= k && L >= $;
          if ("vertical" === o) return !!m && E <= C && A >= _;
          if ("horizontal" === o) return !!m && V <= k && L >= $;
        }
      }
    }),
    (T4SThemeSP.Tabs = (function () {
      var e,
        i,
        n,
        a,
        o = "t4s-tabs-enabled",
        s = "t4s-tabs-simple-enabled",
        r = "t4s-tabs-accordion-enabled",
        l = "t4s-active",
        d = 300,
        c = 150,
        u = 200;
      return {
        Default: function () {
          0 != (i = t(`[data-t4s-tabs]:not(.${o})`)).length &&
            (i.addClass(o),
              i.on(
                "click",
                "[data-t4s-tab-ul] [data-t4s-tab-item]",
                function (i) {
                  i.preventDefault();
                  var n = t(this),
                    a = n.closest("[data-t4s-tabs]"),
                    o = n.attr("href") || n.data("id-tab"),
                    s = a.find(o),
                    r = s.find(".flickityt4s"),
                    d = s.find(".isotopet4s");
                  a.find("." + l).removeClass(l),
                    a.find("[data-t4s-tab-content]").hide(),
                    n.addClass(l),
                    s.show().addClass(l),
                    s.closest("[data-t4s-tab-wrapper]").addClass(l),
                    clearTimeout(e),
                    (e = setTimeout(function () {
                      r.hasClass("flickityt4s-enabled")
                        ? r.flickityt4s("resize")
                        : d.hasClass("isotopet4s-enabled") &&
                        d.isotopet4s("layout");
                    }, 200));
                }
              ));
        },
        Simple: function () {
          0 != (n = t(`[data-t4s-tabs2]:not(.${s})`)).length &&
            (n.addClass(s),
              n.on(
                "click",
                "[data-t4s-tab-ul2] [data-t4s-tab-item]",
                function (e) {
                  e.preventDefault();
                  var i = t(this),
                    n = i.closest("[data-t4s-tabs2]"),
                    a = i.attr("href") || i.data("id-tab");
                  n.find("." + l).removeClass(l),
                    i.addClass(l),
                    n.find(a).addClass(l),
                    n.find(a).closest("[data-t4s-tab-wrapper]").addClass(l);
                }
              ));
        },
        Accordion: function () {
          0 != (a = t(`[data-t4s-tabs]:not(.${r})`)).length &&
            (a.addClass(r),
              t(".t4s-type-accordion, [data-t4s-accordion-pr]")
                .find("." + l)
                .find("[data-t4s-tab-content]")
                .css("display", "block"),
              a.on(
                "click",
                "[data-t4s-tab-wrapper] [data-t4s-tab-item]",
                function (e) {
                  e.preventDefault();
                  var i,
                    n = t(this),
                    a = n.closest("[data-t4s-tabs]"),
                    o = a.find("[data-t4s-tab-ul]"),
                    s = a.find("[data-t4s-tab-wrapper]." + l),
                    r = s.find("[data-t4s-tab-content]"),
                    f = n.closest("[data-t4s-tab-wrapper]"),
                    p = f.find("[data-t4s-tab-content]"),
                    h = n.closest(".t4s-section"),
                    m = p.find(".flickityt4s"),
                    g = p.find(".isotopet4s");
                  0 == h.length && (h = n.closest(".shopify-section")),
                    f.hasClass(l)
                      ? (o.find("." + l).removeClass(l),
                        f.removeClass(l),
                        p.slideUp(d).removeClass(l))
                      : (s.removeClass(l),
                        o.find("." + l).removeClass(l),
                        f.addClass(l),
                        o.find('a[href="' + n.attr("href") + '"]').addClass(l),
                        r.slideUp(c).removeClass(l),
                        p.stop(!0, !0).slideDown(d).addClass(l),
                        clearTimeout(i),
                        (i = setTimeout(function () {
                          if (
                            (m.hasClass("flickityt4s-enabled")
                              ? m.flickityt4s("resize")
                              : g.hasClass("isotopet4s-enabled") &&
                              g.isotopet4s("layout"),
                              !T4SThemeSP.isVisible(f, !0))
                          ) {
                            var e =
                              t(
                                ".ntheader.live_stuck .sp_header_mid"
                              ).height() || 0,
                              i = h.find(".sp-tab.active").offset().top - e - 10;
                            t("body,html").animate({
                              scrollTop: i,
                            });
                          }
                        }, u)));
                }
              ));
        },
      };
    })()),
    (T4SThemeSP.RenderRefresh = (function () {
      function e(t) {
        a.trigger("currency:update");
        let e = t.find(".flickityt4s"),
          i = t.find(".isotopet4s");
        t.find(".t4s-products").length > 0 &&
          T4SThemeSP.reinitProductGridItem(),
          i.length > 0 && T4SThemeSP.Isotopet4s.init(i),
          e.length > 0 && (e[0].flickityt4s = new T4SThemeSP.Carousel(e[0]));
      }
      return function () {
        0 != t("[data-render-lazy-component]").length &&
          (t("[data-render-lazy-component].lazyloadt4sed").each(function () {
            e(t(this));
          }),
            t("[data-render-lazy-component]:not(.lazyloadt4sed)").one(
              "lazyincluded",
              function (i) {
                var n = t(i.target)[0];
                e(t(n));
              }
            ),
            t("[data-render-lazy-component]:not(.lazyloadt4s)").addClass(
              "lazyloadt4s"
            ));
      };
    })()),
    (T4SThemeSP.ParallaxInt = function () {
      var e = t("[data-parallax-t4strue]:not(.parallax_enabled)");
      0 != e.length &&
        e.each(function () {
          var e = t(this),
            i = e.attr("data-imgsl") || ".t4s-parallax-img";
          (e.find(i).length > 0 || e.is(".t4s-parallax-bg.lazyloadt4sed")) &&
            e.addClass("parallax_enabled").t4sJarallax({
              speed: e.attr("data-speed") || 0.8,
              imgElement: i,
            });
        });
    }),
    (T4SThemeSP.Countdown = (function () {
      var e = T4Sconfigs.timezone,
        i = "t4_nt_guess";
      try {
        i = dayjs.tz.guess();
      } catch (t) { }
      return function () {
        var n = t("[data-countdown-t4s]:not(.t4s-countdown-enabled)");
        0 != n.length &&
          n.each(function () {
            var n,
              a = t(this),
              o =
                t(a.attr("data-keyid")).html() ||
                t.trim(a.html()) ||
                "%D days %H:%M:%S",
              s = a.is("[data-refresh-owl]"),
              r = a.data("loop"),
              l = a.data("date"),
              d = parseInt(a.data("dayl")),
              c = dayjs(),
              u = l.replace(/\//g, "").replace(/-/g, "") + "",
              f = parseInt(u),
              p = u.length < 9 ? "YYYYMMDD" : "YYYYMMDDHHmmss";
            if (
              ((f > parseInt(c.format(p)) || d < 1) && (r = !1),
                r || "true" == r)
            ) {
              var h = dayjs(l).format(" HH:mm:ss"),
                m = d - (c.diff(l.replace(/\//g, "-"), "days") % d);
              (l = (c = c.add(m, "day")).format("YYYY/MM/DD") + h),
                a.attr("data-dateloop", l);
            }
            a
              .countdown(
                (function (t) {
                  if (void 0 !== t) {
                    var n = t.replace("24:00:00", "23:59:59");
                    if ("not4" != e && i != e)
                      try {
                        n = dayjs.tz(t.replace(/\//g, "-"), e).toDate();
                      } catch (t) {
                        console.log("Timezone error: " + e);
                      }
                    else n = new Date(n);
                    return n;
                  }
                })(l),
                {
                  elapse: !0,
                }
              )
              .on("update.countdown", function (t) {
                if (t.elapsed)
                  a.html("")
                    .addClass("expired_cdt4")
                    .closest("[data-countdown-wrap]")
                    .html("")
                    .addClass("expired_cdt4");
                else {
                  var e = 24 * t.offset.totalDays + t.offset.hours;
                  a.html(t.strftime(o.replace("[totalHours]", e)));
                }
              })
              .addClass("t4s-countdown-enabled")
              .closest("[data-countdown-wrap]")
              .addClass("t4s-countdown-enabled"),
              s &&
              (clearTimeout(n),
                (n = setTimeout(() => {
                  a.closest(".flickityt4s-enabled").flickityt4s("resize");
                }, 600)));
          });
      };
    })()),
    (T4SThemeSP.AnimateOnScroll = (function () {
      var e = T4Sconfigs.timeani || 200,
        i = new IntersectionObserver(function (t, n) {
          t.forEach(function (t) {
            var n = t.target;
            t.isIntersecting &&
              !n.classList.contains("t4s_animated") &&
              (setTimeout(function () {
                n.classList.add("t4s_animated");
              }, e),
                i.unobserve(n));
          });
        });
      return function () {
        var e = t("[data-t4s-animate]:not(.t4s-animate-init)");
        0 != e.length &&
          window.IntersectionObserver &&
          e.each(function (e) {
            i.observe(this), t(this).addClass("t4s-animate-init");
          });
      };
    })()),
    (T4SThemeSP.PopupMFP = (function () {
      var e = t.fn.magnificPopupT4s,
        i = l.mfp_close,
        n = l.mfp_loading,
        o = t("[data-open-mfp-inline]:not(.t4s-mfp-enabled)"),
        s = t("[data-open-mfp-iframe]:not(.t4s-mfp-enabled)"),
        r = t("[data-open-mfp-video]:not(.t4s-mfp-enabled)"),
        d = t("[data-open-mfp-ajax]:not(.t4s-mfp-enabled)"),
        c = t("[data-open-mfp]");
      return function () {
        void 0 !== e &&
          (0 != o.length &&
            o
              .magnificPopupT4s({
                type: "inline",
                removalDelay: 500,
                tClose: i,
                tLoading: n,
                callbacks: {
                  beforeOpen: function () {
                    this.st.mainClass =
                      "mfp-move-horizontal t4s-inline-popup-wrapper " +
                      t(this.st.el).data("id") || "";
                  },
                  open: function () {
                    a.trigger("NTpopupInline:offClose"),
                      a.trigger("currency:update");
                  },
                  afterClose: function () {
                    a.trigger("NTpopupInline:onClose");
                  },
                },
              })
              .addClass("t4s-mfp-enabled"),
            0 != (s = t("[data-open-mfp-iframe]:not(.t4s-mfp-enabled)")).length &&
            s
              .magnificPopupT4s({
                type: "iframe",
                tClose: i,
                tLoading: n,
                iframe: {
                  markup:
                    '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe"><div class="mfp-close"></div><iframe class="mfp-iframe" allow="autoplay; encrypted-media" frameborder="0" allowfullscreen></iframe></div>',
                  patterns: {
                    youtube: {
                      index: "youtube.com/",
                      id: "v=",
                      src: "//www.youtube.com/embed/%id%?enablejsapi=1&autoplay=0&rel=0&playlist=%id%&loop=1",
                    },
                    vimeo: {
                      index: "vimeo.com/",
                      id: "/",
                      src: "//player.vimeo.com/video/%id%?autoplay=0&loop=1",
                    },
                    gmaps: {
                      index: "//maps.google.",
                      src: "%id%&output=embed",
                    },
                  },
                  srcAction: "iframe_src",
                },
                callbacks: {
                  beforeOpen: function () {
                    this.st.mainClass =
                      "t4s-iframe-popup-wrapper " + t(this.st.el).data("id") ||
                      "";
                  },
                  change: function () { },
                  open: function () {
                    var e = t(this.st.el),
                      i = t(".t4s-mfp-iframe").find(".mfp-iframe"),
                      n = i.attr("src");
                    e.is("[data-autoplay-true]") &&
                      (n = n.replace("autoplay=0", "autoplay=1")),
                      e.is("[data-loop-false]") &&
                      (n = (n = n.split("&playlist=")[0]).replace(
                        "loop=1",
                        "loop=0"
                      )),
                      i.attr("src", n);
                  },
                  close: function () { },
                },
              })
              .addClass("t4s-mfp-enabled"),
            0 != (r = t("[data-open-mfp-video]:not(.t4s-mfp-enabled)")).length &&
            r.on("click", function (e) {
              e.preventDefault();
              var a,
                o = t(this),
                s = JSON.parse(o.attr("data-options") || "{}"),
                r = s.type,
                l = s.vid,
                d = s.autoplay,
                c = s.loop,
                u =
                  '<iframe src="src_t4s" class="class_t4s" title="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                f = {
                  html5: "html5",
                  youtube: "youtube",
                  vimeo: "vimeo",
                };
              switch (r) {
                case f.html5:
                  a = [
                    '<div class="mfp-video-scaler t4s-pr t4s-mfp-video">',
                    '<video class="mfp-video" src="' +
                    s.src +
                    '" preload="auto" controls ' +
                    (d ? "autoplay" : "") +
                    (d ? " loop" : "") +
                    " playsinline></video>",
                    "</div>",
                  ].join("");
                  break;
                case f.youtube:
                  (u = u
                    .replace(
                      "src_t4s",
                      "//www.youtube.com/embed/" +
                      l +
                      "?enablejsapi=1&showinfo=0&controls=1&modestbranding=1&autoplay=" +
                      +d +
                      "&rel=0" +
                      (c ? "&playlist=" + l + "&loop=1" : "")
                    )
                    .replace("class_t4s", "js-youtube")),
                    (a =
                      '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe">' +
                      u +
                      "</div>");
                  break;
                case f.vimeo:
                  (u = u
                    .replace(
                      "src_t4s",
                      "//player.vimeo.com/video/" +
                      l +
                      "?&portrait=0&byline=0&color=" +
                      s.accent_color +
                      "&autoplay=" +
                      +d +
                      "&loop=" +
                      +c
                    )
                    .replace("class_t4s", "js-vimeo")),
                    (a =
                      '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe">' +
                      u +
                      "</div>");
              }
              t.magnificPopupT4s.open({
                items: {
                  src: a,
                  type: "inline",
                },
                tClose: i,
                tLoading: n,
                callbacks: {
                  beforeOpen: function () {
                    this.st.mainClass =
                      "t4s-video-popup-wrapper mfp-video-holder " +
                      o.data("id") || "";
                  },
                  open: function () {
                    o.addClass("t4s-mfp-enabled");
                  },
                  afterClose: function () {
                    o.removeClass("t4s-mfp-enabled");
                  },
                },
              });
            }),
            0 != (d = t("[data-open-mfp-ajax]:not(.t4s-mfp-enabled)")).length &&
            d
              .magnificPopupT4s({
                type: "ajax",
                removalDelay: 500,
                tClose: i,
                tLoading:
                  '<div class="t4s-loading-spin t4s-spin-centered t4s-spin-dark t4s-spin-medium"></div>',
                callbacks: {
                  parseAjax: function (e) {
                    var i = t(this.st.el),
                      n = i.data("id") || "",
                      a = i.data("class") || "",
                      o = i.data("style") || "",
                      s = e.data;
                    e.data = `<div class="mfp-with-anim t4s-mfp-popup ${a}" id="${n}" style="${o}">${s.split("[t4splitlz]")[1] || s
                      }</div>`;
                  },
                  ajaxContentAdded: function () { },
                  beforeOpen: function () {
                    this.st.mainClass =
                      "mfp-move-horizontal t4s-ajax-popup-wrapper";
                  },
                  open: function () {
                    var e = t(this.st.el).data("custom"),
                      i = t(this.st.el).data("phone"),
                      n = t(
                        ".t4s-ajax-popup-wrapper:not(.mfp-bg) .mfp-content"
                      );
                    if (
                      (a.trigger("NTpopupInline:offClose"),
                        a.trigger("currency:update"),
                        0 == i &&
                        (n.find("#t4s-ContactFormAsk__phone").remove(),
                          setTimeout(function () {
                            n.find("#t4s-ContactFormAsk__phone").remove();
                          }, 400)),
                        e)
                    ) {
                      var o = e.split("||");
                      t.each(o, function (t, e) {
                        var i = e.split("=>");
                        n.find(i[0]).html(i[1]);
                      }),
                        setTimeout(function () {
                          t.each(o, function (t, e) {
                            var i = e.split("=>");
                            n.find(i[0]).html(i[1]);
                          });
                        }, 400);
                    }
                  },
                  afterClose: function () {
                    a.trigger("NTpopupInline:onClose");
                  },
                },
              })
              .addClass("t4s-mfp-enabled"),
            0 != c.length &&
            a.on("click", "[data-open-mfp]", function (e) {
              e.preventDefault();
              var i = t(e.currentTarget),
                n = t("html"),
                a = i.data(),
                o = a.opennt,
                s = a.color,
                r = a.bg,
                l = a.pos,
                d = a.ani || "has_ntcanvas",
                c = a.remove,
                u = a.class,
                f = a.close || !1,
                p = a.focuslast || !1,
                h = i.attr("data-focus"),
                m = window.pageYOffset;
              window.height,
                t("#shopify-section-header_banner").outerHeight(),
                t(".ntheader_wrapper").outerHeight(),
                i.addClass("current_clicked"),
                t.magnificPopupT4s.open({
                  items: {
                    src: o,
                    type: "inline",
                    tLoading: '<div class="loading-spin dark"></div>',
                  },
                  tClose: nt_settings.close,
                  removalDelay: 300,
                  closeBtnInside: f,
                  focus: h,
                  autoFocusLast: p,
                  callbacks: {
                    beforeOpen: function () {
                      this.st.mainClass = d + " " + s + " " + d + "_" + l;
                    },
                    open: function () {
                      n.addClass(d),
                        n.addClass(d + "_" + l),
                        u && t(".mfp-content").addClass(u),
                        r && t(".mfp-bg").addClass(r),
                        body.on("click", ".close_pp", function (e) {
                          e.preventDefault(), t.magnificPopup.close();
                        }),
                        m && t("html, body").scrollTop(m);
                    },
                    beforeClose: function () {
                      n.removeClass(d);
                    },
                    afterClose: function () {
                      n.removeClass(d + "_" + l),
                        t(".current_clicked").removeClass("current_clicked"),
                        c && t(o).removeClass("mfp-hide");
                    },
                  },
                });
            }));
      };
    })()),
    (T4SThemeSP.NTpopupInline = (function () {
      var e,
        i = t("#t4s_temp_modal").html(),
        o = "modalt4s:trigger",
        s = "modalt4s:opened",
        r = "modalt4s:closed",
        l = "modalt4s:destroy",
        d = "t4s-modal--is-active",
        c = "t4s-modal-opened",
        u = ".t4s_qv",
        f = "transitionend webkitTransitionEnd oTransitionEnd";
      function p() {
        return t("html").hasClass(c);
      }
      function h(t) {
        27 === t.keyCode && a.trigger(r);
      }
      function m(e) {
        t(e.target).parents().is(".t4s-modal__inner") ||
          t(e.target).parents().is(".mfp-ready") ||
          (e.preventDefault(), a.trigger(r));
      }
      return function (g, v, y, b = null) {
        (e = b),
          a.off(o).on(o, function (t) {
            p() ? a.trigger(r) : a.trigger(s);
          }),
          a.off(s).on(s, function (a) {
            p() ||
              ((function (a) {
                T4SThemeSP.$appendComponent.after(i),
                  e && n.addClass(e),
                  t(".t4s-modal__content").html(a);
              })(g),
                (function (e) {
                  n.addClass(c),
                    t(".t4s-modal").addClass(d),
                    t(".t4s-modal").on(f, function () {
                      t(this).focus().off(f);
                    }),
                    setTimeout(function () {
                      t(".t4s-modal").focus();
                    }, 500),
                    e();
                })(y));
          }),
          a.off(r).on(r, function (i) {
            p() &&
              (t(".t4s-modal .flickityt4s-enabled").trigger("destroy.t4s"),
                t("html").removeClass(c).addClass("t4s-modal-closing"),
                t(".t4s-modal").removeClass(d).addClass("t4s-modal--is-closing"),
                setTimeout(function () {
                  t(".t4s-modal").remove(),
                    t("html").removeClass("t4s-modal-closing"),
                    e && n.removeClass(e),
                    (T4SThemeSP.isEditCartReplace = !1);
                }, 500),
                a.trigger(l));
          }),
          a.off(l).on(l, function (t) {
            a.off(o)
              .off(s)
              .off(r)
              .off(l)
              .off("click" + u)
              .off("keyup" + u);
          }),
          a.on("click" + u, "[data-t4s-modal-close]", function (t) {
            t.preventDefault(), a.trigger(r);
          }),
          a.on("click" + u, m),
          a.on("keyup" + u, h),
          a.on("NTpopupInline:offClose", function (t) {
            a.off("keyup" + u, h), a.off("click" + u, m);
          }),
          a.on("NTpopupInline:onClose", function (t) {
            a.on("keyup" + u, h), a.on("click" + u, m);
          });
      };
    })()),
    (T4SThemeSP.Currency = (function () {
      var t = "${{amount}}",
        e = T4SThemeSP.settings && T4SThemeSP.settings.superScriptPrice,
        i = window.T4Sconfigs.moneyFormat,
        n = function (t, e) {
          return null == t || t != t ? e : t;
        };
      return {
        formatMoney: function (a, o) {
          o || (o = i), "string" == typeof a && (a = a.replace(".", ""));
          var s = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            l = o || t;
          function d(t, e, i, a) {
            if (
              ((e = n(e, 2)),
                (i = n(i, ",")),
                (a = n(a, ".")),
                isNaN(t) || null == t)
            )
              return 0;
            var o = (t = (t / 100).toFixed(e)).split(".");
            return (
              o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
              (o[1] ? a + o[1] : "")
            );
          }
          switch (l.match(r)[1]) {
            case "amount":
              (s = d(a, 2)),
                e &&
                s &&
                s.includes(".") &&
                (s = s.replace(".", "<sup>") + "</sup>");
              break;
            case "amount_no_decimals":
              s = d(a, 0);
              break;
            case "amount_with_comma_separator":
              (s = d(a, 2, ".", ",")),
                e &&
                s &&
                s.includes(".") &&
                (s = s.replace(",", "<sup>") + "</sup>");
              break;
            case "amount_no_decimals_with_comma_separator":
              s = d(a, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              s = d(a, 0, " ");
          }
          return l.replace(r, s);
        },
        getBaseUnit: function (t) {
          if (
            t &&
            t.unit_price_measurement &&
            t.unit_price_measurement.reference_value
          )
            return 1 === t.unit_price_measurement.reference_value
              ? t.unit_price_measurement.reference_unit
              : t.unit_price_measurement.reference_value +
              t.unit_price_measurement.reference_unit;
        },
      };
    })()),
    (T4SThemeSP.Helpers = (function () {
      return {
        disableBodyScroll: function () {
          var t,
            e = !1,
            i = !1;
          Element.prototype.matches ||
            (Element.prototype.matches =
              Element.prototype.msMatchesSelector ||
              Element.prototype.webkitMatchesSelector),
            Element.prototype.closest ||
            (Element.prototype.closest = function (t) {
              var e = this;
              if (!document.documentElement.contains(el)) return null;
              do {
                if (e.matches(t)) return e;
                e = e.parentElement;
              } while (null !== e);
              return el;
            });
          var n = function (t) {
            (!1 !== i && t.target.closest(e)) || t.preventDefault();
          },
            a = function (e) {
              1 === e.targetTouches.length && (t = e.targetTouches[0].clientY);
            },
            o = function (e) {
              if (1 === e.targetTouches.length) {
                var n = e.targetTouches[0].clientY - t;
                0 === i.scrollTop && n > 0 && e.preventDefault(),
                  i.scrollHeight - i.scrollTop <= i.clientHeight &&
                  n < 0 &&
                  e.preventDefault();
              }
            };
          return function (t, s) {
            void 0 !== s && ((e = s), (i = document.querySelector(s))),
              !0 === t
                ? (!1 !== i &&
                  (i.addEventListener("touchstart", a, !1),
                    i.addEventListener("touchmove", o, !1)),
                  document.body.addEventListener("touchmove", n, !1))
                : (!1 !== i &&
                  (i.removeEventListener("touchstart", a, !1),
                    i.removeEventListener("touchmove", o, !1)),
                  document.body.removeEventListener("touchmove", n, !1));
          };
        },
        debounce: function (t, e, i) {
          var n;
          return function () {
            var a = this,
              o = arguments,
              s = i && !n;
            clearTimeout(n),
              (n = setTimeout(function () {
                (n = null), i || t.apply(a, o);
              }, e)),
              s && t.apply(a, o);
          };
        },
        getScript: function (t, e) {
          return new Promise(function (i, n) {
            var a = document.createElement("script"),
              o = e || document.getElementsByTagName("script")[0];
            function s(t, e) {
              (e || !a.readyState || /loaded|complete/.test(a.readyState)) &&
                ((a.onload = null),
                  (a.onreadystatechange = null),
                  (a = void 0),
                  e ? n() : i());
            }
            (a.async = !0),
              (a.defer = !0),
              (a.onload = s),
              (a.onreadystatechange = s),
              (a.src = t),
              o.parentNode.insertBefore(a, o);
          });
        },
        loadScript: function (e, i) {
          null != e &&
            t.ajax({
              url: e,
              dataType: "script",
              success: i,
              async: !0,
            });
        },
        prepareTransition: function (t) {
          t.addEventListener(
            "transitionend",
            function (t) {
              t.currentTarget.classList.remove("is-transitioning");
            },
            {
              once: !0,
            }
          );
          var e = 0;
          [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ].forEach(function (i) {
            var n = getComputedStyle(t)[i];
            n && (n.replace(/\D/g, ""), e || (e = parseFloat(n)));
          }),
            0 !== e && (t.classList.add("is-transitioning"), t.offsetWidth);
        },
        serialize: function (t) {
          var e = [];
          return (
            Array.prototype.slice.call(t.elements).forEach(function (t) {
              !t.name ||
                t.disabled ||
                ["file", "reset", "submit", "button"].indexOf(t.type) > -1 ||
                ("select-multiple" !== t.type
                  ? (["checkbox", "radio"].indexOf(t.type) > -1 &&
                    !t.checked) ||
                  e.push(
                    encodeURIComponent(t.name) +
                    "=" +
                    encodeURIComponent(t.value)
                  )
                  : Array.prototype.slice.call(t.options).forEach(function (i) {
                    i.selected &&
                      e.push(
                        encodeURIComponent(t.name) +
                        "=" +
                        encodeURIComponent(i.value)
                      );
                  }));
            }),
            e.join("&")
          );
        },
        cookiesEnabled: function () {
          var t = navigator.cookieEnabled;
          return (
            t ||
            ((document.cookie = "testcookie"),
              (t = -1 !== document.cookie.indexOf("testcookie"))),
            t
          );
        },
        promiseStylesheet: function (t) {
          var e = t;
          return (
            void 0 === this.stylesheetPromise &&
            (this.stylesheetPromise = new Promise(function (t) {
              var i = document.querySelector('link[href="' + e + '"]');
              i.loaded && t(),
                i.addEventListener("load", function () {
                  setTimeout(t, 0);
                });
            })),
            this.stylesheetPromise
          );
        },
      };
    })()),
    (T4SThemeSP.slate = {});
  var b = T4SThemeSP.slate;
  (b.utils = {
    getParameterByName: function (t, e) {
      e || (e = window.location.href), (t = t.replace(/[[\]]/g, "\\$&"));
      var i = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
      return i
        ? i[2]
          ? decodeURIComponent(i[2].replace(/\+/g, " "))
          : ""
        : null;
    },
    removeParameterByName: function (t, e) {
      e || (e = window.location.href), (t = t.replace(/[[\]]/g, "\\$&"));
      var i = e.split("?")[0],
        n = [],
        a = -1 !== e.indexOf("?") ? e.split("?")[1] : "";
      if ("" !== a) {
        for (var o = (n = a.split("&")).length - 1; o >= 0; o -= 1)
          n[o].split("=")[0] === t && n.splice(o, 1);
        n.length && (i = i + "?" + n.join("&"));
      }
      return i;
    },
    resizeSelects: function (e) {
      e.each(function () {
        var e = t(this),
          i = e.find("option:selected").text(),
          n = t("<span>").html(i);
        n.appendTo("body");
        var a = n.width();
        n.remove(), e.width(a + 10);
      });
    },
    keyboardKeys: {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      LEFTARROW: 37,
      RIGHTARROW: 39,
    },
  }),
    (b.rte = {
      wrapTable: function (t) {
        t.$tables.wrap('<div class="' + t.tableWrapperClass + '"></div>');
      },
      wrapIframe: function (e) {
        e.$iframes.each(function () {
          t(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'),
            (this.src = this.src);
        });
      },
    }),
    (b.a11y = {
      pageLinkFocus: function (t) {
        var e = "js-focus-hidden";
        t.first()
          .attr("tabIndex", "-1")
          .focus()
          .addClass(e)
          .one("blur", function () {
            t.first().removeClass(e).removeAttr("tabindex");
          });
      },
      focusHash: function () {
        var e = window.location.hash;
        e && document.getElementById(e.slice(1)) && this.pageLinkFocus(t(e));
      },
      bindInPageLinks: function () {
        t("a[href*=#]").on(
          "click",
          function (e) {
            this.pageLinkFocus(t(e.currentTarget.hash));
          }.bind(this)
        );
      },
      trapFocus: function (e) {
        var i = {
          focusin: e.namespace ? "focusin." + e.namespace : "focusin",
          focusout: e.namespace ? "focusout." + e.namespace : "focusout",
          keydown: e.namespace
            ? "keydown." + e.namespace
            : "keydown.handleFocus",
        },
          n = e.$container.find(
            t(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ).filter(":visible")
          ),
          a = n[0],
          o = n[n.length - 1];
        e.$elementToFocus || (e.$elementToFocus = e.$container),
          e.$container.attr("tabindex", "-1"),
          e.$elementToFocus.focus(),
          t(document).off("focusin"),
          t(document).on(i.focusout, function () {
            t(document).off(i.keydown);
          }),
          t(document).on(i.focusin, function (e) {
            (e.target !== o && e.target !== a) ||
              t(document).on(i.keydown, function (t) {
                !(function (t) {
                  t.keyCode === b.utils.keyboardKeys.TAB &&
                    (t.target !== o ||
                      t.shiftKey ||
                      (t.preventDefault(), a.focus()),
                      t.target === a &&
                      t.shiftKey &&
                      (t.preventDefault(), o.focus()));
                })(t);
              });
          });
      },
      removeTrapFocus: function (e) {
        var i = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$container &&
          e.$container.length &&
          e.$container.removeAttr("tabindex"),
          t(document).off(i);
      },
      accessibleLinks: function (e) {
        var i = document.querySelector("body"),
          n = {
            newWindow: "a11y-new-window-message",
            external: "a11y-external-message",
            newWindowExternal: "a11y-new-window-external-message",
          };
        (void 0 !== e.$links && e.$links.jquery) ||
          (e.$links = t("a[href]:not([aria-describedby])")),
          t.each(e.$links, function () {
            var e = t(this),
              i = e.attr("target"),
              a = e.attr("rel"),
              o = (function (t) {
                var e = window.location.hostname;
                return t[0].hostname !== e;
              })(e),
              s = "_blank" === i;
            o && e.attr("aria-describedby", n.external),
              s &&
              ((void 0 !== a && -1 !== a.indexOf("noopener")) ||
                e.attr("rel", function (t, e) {
                  return (void 0 === e ? "" : e + " ") + "noopener";
                }),
                e.attr("aria-describedby", n.newWindow)),
              o && s && e.attr("aria-describedby", n.newWindowExternal);
          }),
          (function (e) {
            "object" != typeof e && (e = {});
            var a = t.extend(
              {
                newWindow: "Opens in a new window.",
                external: "Opens external website.",
                newWindowExternal: "Opens external website in a new window.",
              },
              e
            ),
              o = document.createElement("ul"),
              s = "";
            for (var r in a) s += "<li id=" + n[r] + ">" + a[r] + "</li>";
            o.setAttribute("hidden", !0), (o.innerHTML = s), i.appendChild(o);
          })(e.messages);
      },
    }),
    (T4SThemeSP.LinkMyltiLang = (function () {
      var e = T4SThemeSP.root_url,
        i = window.location.hostname,
        n = T4Sroutes.root_url,
        a = "is--checked-link",
        o = i + n;
      return function () {
        "/" != e &&
          t(`a[href*="${i}"]:not(.${a})`).each(function () {
            let s = t(this),
              r = s.attr("href");
            s.addClass(a),
              (r.indexOf(i + e) >= 0 && "/" != r) ||
              r.indexOf("preview_theme_id=") > -1 ||
              ("/" != r
                ? s.attr("href", r.replace(i, o))
                : s.attr("href", n));
          });
      };
    })());
  var S,
    w = (function () {
      function e(e) {
        var i = this;
        if (
          ((i.$slider = t(e)),
            (i.slideWrap = i.$slider.closest("[data-slide-wrap]")[0] || e),
            !i.slideWrap)
        )
          return;
        if (
          ((i.sliderOptions = JSON.parse(
            i.$slider.attr("data-options") || "{}"
          )),
            (i.slider = e),
            (i.sliderItems = e.querySelectorAll(".t4s-slider__slide")),
            (i.pageCount = i.slideWrap.querySelector(
              ".t4s-slider-counter--current"
            )),
            (i.pageTotal = i.slideWrap.querySelector(
              ".t4s-slider-counter--total"
            )),
            (i.prevButton = i.slideWrap.querySelector(".t4s-slider__slide-prev")),
            (i.nextButton = i.slideWrap.querySelector(".t4s-slider__slide-next")),
            !i.slider || !i.nextButton)
        )
          return;
        new ResizeObserver((t) => i._initPages()).observe(i.slider),
          i.slider.addEventListener("scroll", i._update.bind(i)),
          i.prevButton.addEventListener("click", i._onButtonClick.bind(i)),
          i.nextButton.addEventListener("click", i._onButtonClick.bind(i));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          _initPages: function () {
            this.slider.classList.remove("is--active"),
              0 !== !this.sliderItems.length &&
              (this.slider.classList.add("is--active"),
                (this.slidesPerPage = Math.floor(
                  this.slider.clientWidth / this.sliderItems[0].clientWidth
                )),
                (this.totalPages =
                  this.sliderItems.length - this.slidesPerPage + 1),
                this._update());
          },
          _update: function () {
            this.pageCount &&
              this.pageTotal &&
              ((this.currentPage =
                Math.round(
                  this.slider.scrollLeft / this.sliderItems[0].clientWidth
                ) + 1),
                1 === this.currentPage
                  ? this.prevButton.setAttribute("disabled", !0)
                  : this.prevButton.removeAttribute("disabled"),
                this.currentPage === this.totalPages
                  ? this.nextButton.setAttribute("disabled", !0)
                  : this.nextButton.removeAttribute("disabled"),
                (this.pageCount.textContent = this.currentPage),
                (this.pageTotal.textContent = this.totalPages));
          },
          _onButtonClick: function (t) {
            t.preventDefault();
            const e =
              "next" === t.currentTarget.name
                ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
                : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
            this.slider.scrollTo({
              left: e,
            });
          },
        })),
        e
      );
    })();
  (T4SThemeSP.SliderComponentInt = void (
    0 != (S = t(".t4s-slider:not(.t4s-enabled)")).length &&
    S.each(function (t) {
      this.classList.add("t4s-enabled"), (this.sliderComponent = new w(this));
    })
  )),
    (T4SThemeSP.LibraryLoader = (function () {
      var t = {
        link: "link",
        script: "script",
      },
        e = {
          requested: "requested",
          loaded: "loaded",
        },
        n = "https://cdn.shopify.com/shopifycloud/",
        a = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: t.script,
          },
          vimeoSdk: {
            tagId: "vimeo-sdk",
            src: "https://player.vimeo.com/api/player.js",
            type: t.script,
          },
          plyrShopifyStyles: {
            tagId: "plyr-shopify-styles",
            src: n + "plyr/v2.0/shopify-plyr.css",
            type: t.link,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: t.link,
          },
        };
      return {
        load: function (n, o) {
          var s = a[n];
          if (s) {
            if (r && "youtubeSdk" == n && window.YT)
              return o(), void i.trigger("youtube:ready");
            if (s.status !== e.requested)
              if (((o = o || function () { }), s.status !== e.loaded)) {
                var l;
                switch (((s.status = e.requested), s.type)) {
                  case t.script:
                    l = (function (t, i) {
                      var n = document.createElement("script");
                      return (
                        (n.src = t.src),
                        n.addEventListener("load", function () {
                          (t.status = e.loaded), i();
                        }),
                        n
                      );
                    })(s, o);
                    break;
                  case t.link:
                    l = (function (t, i) {
                      var n = document.createElement("link");
                      return (
                        (n.href = t.src),
                        (n.rel = "stylesheet"),
                        (n.type = "text/css"),
                        n.addEventListener("load", function () {
                          (t.status = e.loaded), i();
                        }),
                        n
                      );
                    })(s, o);
                }
                (l.id = s.tagId), (s.element = l);
                var d = document.getElementsByTagName(s.type)[0];
                d.parentNode.insertBefore(l, d);
              } else o();
          }
        },
      };
    })());
  var T,
    _ = (function () {
      var n = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo",
      },
        a = !1,
        o = !1;
      function s(e) {
        switch (
        ((this.$video = t(e)),
          (this.video_options = JSON.parse(
            this.$video.attr("data-options") || "{}"
          )),
          (this.video_type = this.video_options.type),
          (this.video_mute = this.video_options.mute),
          (this.$videoInsert = this.$video.find("[data-bgvideo-insert]")),
          (this.$elementToInsert = this.$videoInsert.length
            ? this.$videoInsert
            : this.$video),
          (this.elementToInsert = this.$elementToInsert[0]),
          this.$video.attr("loaded", !0),
          this.video_type)
        ) {
          case n.html5:
            this._setupBgHtml5Video();
            break;
          case n.youtube:
            window.YT
              ? this._setupBgYouTubeVideo()
              : (this._triggerBgYouTubeVideo(),
                a || (T4SThemeSP.LibraryLoader.load("youtubeSdk"), (a = !0)));
            break;
          case n.vimeo:
            window.Vimeo
              ? this._setupBgVimeoVideo()
              : (this._triggerBgVimeoVideo(),
                o ||
                (T4SThemeSP.LibraryLoader.load(
                  "vimeoSdk",
                  this._loadedVimeoSDK.bind(this)
                ),
                  (o = !0)));
        }
      }
      return (
        (s.prototype = Object.assign({}, s.prototype, {
          _triggerBgYouTubeVideo: function () {
            var t = this;
            i.on("youtube:ready", function (e) {
              t._setupBgYouTubeVideo();
            });
          },
          _loadedVimeoSDK: function () {
            i.trigger("vimeo:ready");
          },
          _triggerBgVimeoVideo: function () {
            var t = this;
            i.on("vimeo:ready", function (e) {
              t._setupBgVimeoVideo();
            });
          },
          _setupBgHtml5Video: function () {
            var t = this;
            let e =
              '<video class="t4s_bg_vid_html5" src="' +
              t.video_options.src +
              '" preload="auto" playsinline autoplay ' +
              (t.video_mute ? "muted " : " ") +
              "loop></video>";
            t.$elementToInsert.replaceWith(e),
              t.$video.find(".t4s_bg_vid_html5").on("playing", function (e) {
                t.$video.addClass("t4s-bgvideo-playing");
              });
          },
          _setupBgYouTubeVideo: function () {
            if (window.YT) {
              var t = this;
              (t.player = new YT.Player(t.elementToInsert, {
                videoId: t.video_options.vid,
                playerVars: {
                  iv_load_policy: 3,
                  enablejsapi: 1,
                  disablekb: 1,
                  autoplay: 0,
                  controls: 0,
                  rel: 0,
                  loop: 0,
                  playsinline: 1,
                  modestbranding: 1,
                  autohide: 1,
                  branding: 0,
                  cc_load_policy: 0,
                  fs: 0,
                  quality: "hd1080",
                  wmode: "transparent",
                  height: "100%",
                  width: "100%",
                  origin: t.video_options.requestHost,
                },
                events: {
                  onReady: t.onPlayerReady.bind(this),
                  onStateChange: t.onPlayerStateChange.bind(this),
                },
              })),
                t.resizeVideoBackground(),
                e.on(
                  "resize",
                  T4SThemeSP.debounce(
                    300,
                    function () {
                      t.resizeVideoBackground();
                    }.bind(t)
                  )
                );
            }
          },
          onPlayerReady: function (t) {
            this.video_mute && this.player.mute(), this.player.playVideo();
          },
          onPlayerStateChange: function (t) {
            t.data === YT.PlayerState.PLAYING
              ? this.$video.addClass("t4s-bgvideo-playing")
              : t.data === YT.PlayerState.ENDED && this.player.playVideo();
          },
          _setupBgVimeoVideo: function () {
            if (window.Vimeo) {
              var t = this;
              (t.player = new Vimeo.Player(t.elementToInsert.parentNode, {
                id: t.video_options.vid,
                autoplay: !0,
                autopause: !1,
                muted: !0,
                background: !0,
                loop: t.video_mute,
              })),
                t.$videoInsert.remove(),
                t.resizeVideoBackground(),
                e.on(
                  "resize",
                  T4SThemeSP.debounce(
                    300,
                    function () {
                      t.resizeVideoBackground();
                    }.bind(t)
                  )
                ),
                t.player.on("play", function () {
                  t.$video.addClass("t4s-bgvideo-playing");
                }),
                t.player.on("ended", function () { });
            }
          },
          resizeVideoBackground: function () {
            var t,
              e,
              i,
              n,
              a = this.$video,
              o = a.innerWidth(),
              s = a.innerHeight();
            o / s < 16 / 9
              ? ((t = s * (16 / 9)),
                (e = s),
                (i = -Math.round((t - o) / 2) + "px"),
                (n = -Math.round((e - s) / 2) + "px"))
              : ((e = (t = o) * (9 / 16)),
                (n = -Math.round((e - s) / 2) + "px"),
                (i = -Math.round((t - o) / 2) + "px")),
              (t += "px"),
              (e += "px"),
              a.find("iframe").css({
                maxWidth: "1000%",
                marginLeft: i,
                marginTop: n,
                width: t,
                height: e,
              });
          },
        })),
        s
      );
    })();
  (T4SThemeSP.BgVideo = function () {
    var e = t('[data-video-background]:not([loaded="true"])');
    0 != e.length &&
      e.each(function (t) {
        this.bgVideo = new _(this);
      });
  }),
    (T4SThemeSP.Footer = (function () {
      var a,
        o = {
          opened: "is--footer_opened",
          btnClose: ".t4s-announcement-bar__close",
        },
        s = 200,
        r = t("#t4s-footer"),
        l = t("#MainContent"),
        d = t(".t4s-prefooter"),
        c = n.hasClass("t4s-browser-Safari");
      function u() {
        l.css({
          "--main-mb": r.outerHeight() + "px",
        });
      }
      function f() {
        c &&
          ((a = e.scrollTop()),
            i.outerHeight() - r.outerHeight() <
              a + r.outerHeight() + e.outerHeight()
              ? r.addClass("is--visible-footer")
              : r.removeClass("is--visible-footer"));
      }
      function p() {
        t("[data-footer-open]")
          .off("click")
          .on("click", function () {
            var e = t(this).parent(),
              i = e.find("> [data-footer-content]");
            e.hasClass(o.opened)
              ? (e.removeClass(o.opened), i.stop().slideUp(s))
              : (e.addClass(o.opened), i.stop().slideDown(s));
          }),
          e.off("resize.FooterCollapse");
      }
      return (
        d.length > 0 && (l = d),
        function () {
          e.on("resize.FooterCollapse", p),
            e.width() < 768 && t(".is--footer-collapse-true").length > 0 && p(),
            e.width() < 1025 ||
            0 == t(".is--footer-sticky-true").length ||
            (u(), e.on("resize", u), c && (f(), e.on("scroll", f)));
        }
      );
    })()),
    (T4SThemeSP.Notices = (function () {
      var e,
        i,
        o,
        s,
        r,
        l = t("#t4s-notices__tmp"),
        d = l.html(),
        c = "is--show",
        u = "is--active-notices",
        f = "click.notices",
        p = "hide.t4s.notices",
        h = !1,
        m = 200,
        g = T4Sconfigs.autoHideNotices,
        v = T4Sconfigs.timeOutNotices;
      function y() {
        o.hide(),
          clearTimeout(r),
          e.removeClass(c),
          n.removeClass(u),
          e.off(f).off(p);
      }
      return (
        l.remove(),
        function (l, b = "warning") {
          h ||
            (T4SThemeSP.$appendComponent.after(d),
              (e = t("#t4s-notices__wrapper")),
              (i = e.find(".t4s-notices__mess")),
              (o = e.find(".t4s-notices__progressbar")),
              (s = o.show().find(">span")),
              (h = !0),
              (d = null),
              s.css("animation-duration", `${v}ms`)),
            e.attr("data-notices-status", b),
            i.html(l),
            g ? o.show() : o.hide(),
            setTimeout(function () {
              e.addClass(c), n.addClass(u);
            }, m),
            g &&
            (r = setTimeout(function () {
              y();
            }, v + m)),
            e.on(f, function () {
              y();
            }),
            a.on(p, function () {
              y();
            });
        }
      );
    })()),
    (T4SThemeSP.FormShopifyMessSuccess = function () {
      let t = location.href;
      t.indexOf("contact_posted=true") < 0 ||
        (t.indexOf("contact_posted=true#ContactFormNotifyStock") > -1
          ? T4SThemeSP.Notices(l.frm_notify_stock_success, "success")
          : t.indexOf("contact_posted=true#ContactFormAsk") > -1
            ? T4SThemeSP.Notices(l.frm_contact_ask_success, "success")
            : t.indexOf("contact_posted=true#t4sNewsletterFormPopup") > -1 &&
            T4SThemeSP.Notices(l.frm_newsletter_popup_success, "success"));
    }),
    (T4SThemeSP.PreloadStylePopup = function () {
      var e = t("#t4s-style-popup");
      0 != e.length && a.prepend(e.html());
    }),
    (T4SThemeSP.BtnMore = (function () {
      var e = {
        enabled: "is--enabled",
        btn: "[data-btn-toogle]",
        open: "is--open",
      };
      function i(i) {
        (this.el = i),
          (this.$el = t(i)),
          this.clickHandler(),
          this.$el.addClass(e.enabled),
          (this.selector = this.$el.data("slector")),
          (this.tMore = this.$el.data("tmore")),
          (this.tLess = this.$el.data("tless")),
          (this.hasIsotope = this.$el.hasClass("isotopet4s"));
      }
      return (
        (i.prototype = Object.assign({}, i.prototype, {
          clickHandler: function () {
            var i = this;
            i.$el.on("click.more", e.btn, function (n) {
              n.preventDefault();
              let a = t(this);
              a.parent().find(i.selector).slideToggle(200),
                a.toggleClass(e.open),
                a.hasClass(e.open) ? a.html(i.tLess) : a.html(i.tMore),
                i.hasIsotope &&
                (i.$el.isotopet4s("layout"),
                  setTimeout(function () {
                    i.$el.isotopet4s("layout");
                  }, 219));
            });
          },
        })),
        i
      );
    })()),
    (T4SThemeSP.initBtnMore = void (
      0 != (T = t("[data-wrap-toogle]:not(.is--enabled)")).length &&
      T.each(function () {
        this.btnMore = new T4SThemeSP.BtnMore(this);
      })
    ));
})(jQuery_T4NT),
  jQuery_T4NT(document).ready(function (t) {
    smoothscroll.polyfill(),
      T4SThemeSP.FormShopifyMessSuccess(),
      T4SThemeSP.BgVideo(),
      T4SThemeSP.ParallaxInt(),
      t(".t4s-parallax-bg:not(.lazyloadt4sed)").one("lazyloaded", function (t) {
        setTimeout(function () {
          T4SThemeSP.ParallaxInt();
        }, 100);
      }),
      T4SThemeSP.Countdown(),
      T4SThemeSP.AnimateOnScroll(),
      T4SThemeSP._initProducts(),
      T4SThemeSP.slate.a11y.accessibleLinks({
        $links: t("a[href]:not([aria-describedby])"),
      }),
      T4SThemeSP.Tabs.Default(),
      T4SThemeSP.Tabs.Simple(),
      T4SThemeSP.Tabs.Accordion(),
      T4SThemeSP.Footer(),
      T4SThemeSP.PopupMFP(),
      T4SThemeSP.Cookies(),
      $script([T4Sconfigs.script3, T4Sconfigs.script6]),
      setTimeout(function () {
        T4SThemeSP.LinkMyltiLang();
      }, 500),
      setTimeout(function () {
        T4SThemeSP.PreloadStylePopup();
      }, 1500);
  });

function ogl_fetch_func() {
  this.base_url = 'https://aws-mall.ogl-dragon.com'
  const t = "aSoYWIvKQMjijVbFx1Uz";

  this.headers = {
    token: t,
    "Content-Type": "application/json",
  }

  this.get = async function get(api_url, params, header) {
    //这个可能有兼容性问题
    const query = new URLSearchParams(params)
    const request_url = `${this.base_url}${api_url}?${query}`
    const header_merge = header ? { ...this.headers, header } : this.headers
    return await fetch(request_url, {
      method: "GET",
      headers: header_merge
    }).then(response => response.json())
  }
  this.post = async function post(api_url, data, header) {
    const request_url = `${this.base_url}${api_url}`
    const header_merge = header ? { ...this.headers, header } : this.headers
    return await fetch(request_url, {
      method: "POST",
      headers: header_merge,
      body: JSON.stringify(data)
    }).then(response => response.json())
  }
}

window.ogl_fetch = new ogl_fetch_func()

function showCurrencyTips() {
  // 非北美站不做
  if (window.Shopify.shop !== 'oglmove.myshopify.com') {
    return
  }
  try {
    const currency_tips_showed = 'ogl_currency_tips'
    // 已经展示过
    if (localStorage.getItem(currency_tips_showed) == 1) {
      return
    }
    // 获取定位cookie国家码
    const user_local_iso = window.getCookieMap()["_tracking_consent"].split('_')[1].slice(0, 2)

    if (!user_local_iso) {
      return
    }
    const country_currency_map = window.country_currecncy_map
    const cur_local_price_unit = country_currency_map[user_local_iso.toUpperCase()]
    async function sendData(currency_code) {
      const formData = new FormData();
      formData.append("form_type", "localization");
      formData.append("utf8", '✓');
      formData.append("_method", "put");
      formData.append("return_to", "/");
      formData.append("locale_code", "en");
      formData.append("currency_code", currency_code)

      try {
        await fetch(`${location.origin}/localization`, {
          method: "POST",
          body: formData,
          headers: {
            'cache-control': 'max-age=0'
          }
        });
        // 切换货币成功上报
        Shopify?.analytics?.publish("currency_change", {
          country_code: user_local_iso.toUpperCase(),
          currency_code: cur_local_price_unit,
          event_type: 'currency_change_success'
        });
        location.reload()
      } catch (e) {
        console.error(e);
        // 切换货币成功上报
        Shopify?.analytics?.publish("currency_change", {
          country_code: user_local_iso.toUpperCase(),
          currency_code: cur_local_price_unit,
          event_type: 'currency_change_error'
        });
        location.reload()
      }
    }
    // 判断用户定位不在美国，弹出切换货币弹窗
    if (user_local_iso.toUpperCase() !== 'US' && cur_local_price_unit) {
      const currency_confirm = new window.oglConfirm({
        title: "Friendly Tip",
        content: `Wanna see local prices?`,
        showCancel: false,
        confirmId: 'currency-tips',
        ok: () => {
          localStorage.setItem(currency_tips_showed, 1)
          sendData(cur_local_price_unit)
          sessionStorage.removeItem('timeMenuT4s');
        },
        okBtnText: "Easy—switch now!",
        cancel: () => {
          localStorage.setItem(currency_tips_showed, 1);
          sendData('USD');
          sessionStorage.removeItem('timeMenuT4s');
        }
      })
      currency_confirm.show()
      // 弹出上报
      Shopify?.analytics?.publish("currency_change", {
        country_code: user_local_iso.toUpperCase(),
        currency_code: cur_local_price_unit,
        event_type: 'currency_change_alert'
      });
    }
  } catch (err) {
    //上报错误
    console.log('error', err)
  }

}
window.addEventListener('DOMContentLoaded', showCurrencyTips)
